var _slicedToArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/data/var/lib/jenkins/workspace/TMI-Portal-CustomerEngage_AccountManagement_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/array/from.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayFromJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/from");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayIsArrayJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/is-array");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsGetIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/get-iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceIndexOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/index-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceSliceJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/slice");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js": function node_modulesBabelRuntimeCorejs3CoreJsIsIterableJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/is-iterable");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectGetOwnPropertySymbolsJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/get-own-property-symbols");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectGetPrototypeOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/get-prototype-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectKeysJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/keys");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/set-prototype-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol/iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js": function node_modulesBabelRuntimeCorejs3HelpersArrayLikeToArrayJs(module, exports) {
    module.exports = function (arr, len) {
      (null == len || len > arr.length) && (len = arr.length);

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeCorejs3HelpersArrayWithHolesJs(module, exports, __webpack_require__) {
    var _Array$isArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");

    module.exports = function (arr) {
      if (_Array$isArray(arr)) return arr;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js": function node_modulesBabelRuntimeCorejs3HelpersAssertThisInitializedJs(module, exports) {
    module.exports = function (self) {
      if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return self;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function node_modulesBabelRuntimeCorejs3HelpersClassCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/createClass.js": function node_modulesBabelRuntimeCorejs3HelpersCreateClassJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }

    module.exports = function (Constructor, protoProps, staticProps) {
      return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function node_modulesBabelRuntimeCorejs3HelpersDefinePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/getPrototypeOf.js": function node_modulesBabelRuntimeCorejs3HelpersGetPrototypeOfJs(module, exports, __webpack_require__) {
    var _Object$getPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js"),
        _Object$setPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js");

    function _getPrototypeOf(o) {
      return module.exports = _getPrototypeOf = _Object$setPrototypeOf ? _Object$getPrototypeOf : function (o) {
        return o.__proto__ || _Object$getPrototypeOf(o);
      }, _getPrototypeOf(o);
    }

    module.exports = _getPrototypeOf;
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeCorejs3HelpersIterableToArrayLimitJs(module, exports, __webpack_require__) {
    var _getIterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js"),
        _isIterable = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    module.exports = function (arr, i) {
      if (void 0 !== _Symbol && _isIterable(Object(arr))) {
        var _arr = [],
            _n = !0,
            _d = !1,
            _e = void 0;

        try {
          for (var _s, _i = _getIterator(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !i || _arr.length !== i); _n = !0) {
            ;
          }
        } catch (err) {
          _d = !0, _e = err;
        } finally {
          try {
            _n || null == _i.return || _i.return();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js": function node_modulesBabelRuntimeCorejs3HelpersNonIterableRestJs(module, exports) {
    module.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js": function node_modulesBabelRuntimeCorejs3HelpersObjectWithoutPropertiesJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
        _Object$getOwnPropertySymbols = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js"),
        objectWithoutPropertiesLoose = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js");

    module.exports = function (source, excluded) {
      if (null == source) return {};
      var key,
          i,
          target = objectWithoutPropertiesLoose(source, excluded);

      if (_Object$getOwnPropertySymbols) {
        var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
        }
      }

      return target;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js": function node_modulesBabelRuntimeCorejs3HelpersObjectWithoutPropertiesLooseJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
        _Object$keys = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js");

    module.exports = function (source, excluded) {
      if (null == source) return {};

      var key,
          i,
          target = {},
          sourceKeys = _Object$keys(source);

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || (target[key] = source[key]);
      }

      return target;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/possibleConstructorReturn.js": function node_modulesBabelRuntimeCorejs3HelpersPossibleConstructorReturnJs(module, exports, __webpack_require__) {
    var _typeof = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/typeof.js"),
        assertThisInitialized = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js");

    module.exports = function (self, call) {
      return !call || "object" !== _typeof(call) && "function" != typeof call ? assertThisInitialized(self) : call;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js": function node_modulesBabelRuntimeCorejs3HelpersSlicedToArrayJs(module, exports, __webpack_require__) {
    var arrayWithHoles = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js"),
        iterableToArrayLimit = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js"),
        unsupportedIterableToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js"),
        nonIterableRest = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js");

    module.exports = function (arr, i) {
      return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/typeof.js": function node_modulesBabelRuntimeCorejs3HelpersTypeofJs(module, exports, __webpack_require__) {
    var _Symbol$iterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    function _typeof(obj) {
      return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }

    module.exports = _typeof;
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js": function node_modulesBabelRuntimeCorejs3HelpersUnsupportedIterableToArrayJs(module, exports, __webpack_require__) {
    var _Array$from = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/from.js"),
        _sliceInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js"),
        arrayLikeToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js");

    module.exports = function (o, minLen) {
      var _context;

      if (o) {
        if ("string" == typeof o) return arrayLikeToArray(o, minLen);

        var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? _Array$from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? arrayLikeToArray(o, minLen) : void 0;
      }
    };
  },
  "../../node_modules/lodash/_DataView.js": function node_modulesLodash_DataViewJs(module, exports, __webpack_require__) {
    var DataView = __webpack_require__("../../node_modules/lodash/_getNative.js")(__webpack_require__("../../node_modules/lodash/_root.js"), "DataView");

    module.exports = DataView;
  },
  "../../node_modules/lodash/_Hash.js": function node_modulesLodash_HashJs(module, exports, __webpack_require__) {
    var hashClear = __webpack_require__("../../node_modules/lodash/_hashClear.js"),
        hashDelete = __webpack_require__("../../node_modules/lodash/_hashDelete.js"),
        hashGet = __webpack_require__("../../node_modules/lodash/_hashGet.js"),
        hashHas = __webpack_require__("../../node_modules/lodash/_hashHas.js"),
        hashSet = __webpack_require__("../../node_modules/lodash/_hashSet.js");

    function Hash(entries) {
      var index = -1,
          length = null == entries ? 0 : entries.length;

      for (this.clear(); ++index < length;) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    Hash.prototype.clear = hashClear, Hash.prototype.delete = hashDelete, Hash.prototype.get = hashGet, Hash.prototype.has = hashHas, Hash.prototype.set = hashSet, module.exports = Hash;
  },
  "../../node_modules/lodash/_ListCache.js": function node_modulesLodash_ListCacheJs(module, exports, __webpack_require__) {
    var listCacheClear = __webpack_require__("../../node_modules/lodash/_listCacheClear.js"),
        listCacheDelete = __webpack_require__("../../node_modules/lodash/_listCacheDelete.js"),
        listCacheGet = __webpack_require__("../../node_modules/lodash/_listCacheGet.js"),
        listCacheHas = __webpack_require__("../../node_modules/lodash/_listCacheHas.js"),
        listCacheSet = __webpack_require__("../../node_modules/lodash/_listCacheSet.js");

    function ListCache(entries) {
      var index = -1,
          length = null == entries ? 0 : entries.length;

      for (this.clear(); ++index < length;) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    ListCache.prototype.clear = listCacheClear, ListCache.prototype.delete = listCacheDelete, ListCache.prototype.get = listCacheGet, ListCache.prototype.has = listCacheHas, ListCache.prototype.set = listCacheSet, module.exports = ListCache;
  },
  "../../node_modules/lodash/_Map.js": function node_modulesLodash_MapJs(module, exports, __webpack_require__) {
    var Map = __webpack_require__("../../node_modules/lodash/_getNative.js")(__webpack_require__("../../node_modules/lodash/_root.js"), "Map");

    module.exports = Map;
  },
  "../../node_modules/lodash/_MapCache.js": function node_modulesLodash_MapCacheJs(module, exports, __webpack_require__) {
    var mapCacheClear = __webpack_require__("../../node_modules/lodash/_mapCacheClear.js"),
        mapCacheDelete = __webpack_require__("../../node_modules/lodash/_mapCacheDelete.js"),
        mapCacheGet = __webpack_require__("../../node_modules/lodash/_mapCacheGet.js"),
        mapCacheHas = __webpack_require__("../../node_modules/lodash/_mapCacheHas.js"),
        mapCacheSet = __webpack_require__("../../node_modules/lodash/_mapCacheSet.js");

    function MapCache(entries) {
      var index = -1,
          length = null == entries ? 0 : entries.length;

      for (this.clear(); ++index < length;) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    MapCache.prototype.clear = mapCacheClear, MapCache.prototype.delete = mapCacheDelete, MapCache.prototype.get = mapCacheGet, MapCache.prototype.has = mapCacheHas, MapCache.prototype.set = mapCacheSet, module.exports = MapCache;
  },
  "../../node_modules/lodash/_Promise.js": function node_modulesLodash_PromiseJs(module, exports, __webpack_require__) {
    var Promise = __webpack_require__("../../node_modules/lodash/_getNative.js")(__webpack_require__("../../node_modules/lodash/_root.js"), "Promise");

    module.exports = Promise;
  },
  "../../node_modules/lodash/_Set.js": function node_modulesLodash_SetJs(module, exports, __webpack_require__) {
    var Set = __webpack_require__("../../node_modules/lodash/_getNative.js")(__webpack_require__("../../node_modules/lodash/_root.js"), "Set");

    module.exports = Set;
  },
  "../../node_modules/lodash/_SetCache.js": function node_modulesLodash_SetCacheJs(module, exports, __webpack_require__) {
    var MapCache = __webpack_require__("../../node_modules/lodash/_MapCache.js"),
        setCacheAdd = __webpack_require__("../../node_modules/lodash/_setCacheAdd.js"),
        setCacheHas = __webpack_require__("../../node_modules/lodash/_setCacheHas.js");

    function SetCache(values) {
      var index = -1,
          length = null == values ? 0 : values.length;

      for (this.__data__ = new MapCache(); ++index < length;) {
        this.add(values[index]);
      }
    }

    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd, SetCache.prototype.has = setCacheHas, module.exports = SetCache;
  },
  "../../node_modules/lodash/_Stack.js": function node_modulesLodash_StackJs(module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("../../node_modules/lodash/_ListCache.js"),
        stackClear = __webpack_require__("../../node_modules/lodash/_stackClear.js"),
        stackDelete = __webpack_require__("../../node_modules/lodash/_stackDelete.js"),
        stackGet = __webpack_require__("../../node_modules/lodash/_stackGet.js"),
        stackHas = __webpack_require__("../../node_modules/lodash/_stackHas.js"),
        stackSet = __webpack_require__("../../node_modules/lodash/_stackSet.js");

    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    Stack.prototype.clear = stackClear, Stack.prototype.delete = stackDelete, Stack.prototype.get = stackGet, Stack.prototype.has = stackHas, Stack.prototype.set = stackSet, module.exports = Stack;
  },
  "../../node_modules/lodash/_Symbol.js": function node_modulesLodash_SymbolJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_root.js").Symbol;

    module.exports = Symbol;
  },
  "../../node_modules/lodash/_Uint8Array.js": function node_modulesLodash_Uint8ArrayJs(module, exports, __webpack_require__) {
    var Uint8Array = __webpack_require__("../../node_modules/lodash/_root.js").Uint8Array;

    module.exports = Uint8Array;
  },
  "../../node_modules/lodash/_WeakMap.js": function node_modulesLodash_WeakMapJs(module, exports, __webpack_require__) {
    var WeakMap = __webpack_require__("../../node_modules/lodash/_getNative.js")(__webpack_require__("../../node_modules/lodash/_root.js"), "WeakMap");

    module.exports = WeakMap;
  },
  "../../node_modules/lodash/_arrayFilter.js": function node_modulesLodash_arrayFilterJs(module, exports) {
    module.exports = function (array, predicate) {
      for (var index = -1, length = null == array ? 0 : array.length, resIndex = 0, result = []; ++index < length;) {
        var value = array[index];
        predicate(value, index, array) && (result[resIndex++] = value);
      }

      return result;
    };
  },
  "../../node_modules/lodash/_arrayLikeKeys.js": function node_modulesLodash_arrayLikeKeysJs(module, exports, __webpack_require__) {
    var baseTimes = __webpack_require__("../../node_modules/lodash/_baseTimes.js"),
        isArguments = __webpack_require__("../../node_modules/lodash/isArguments.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isBuffer = __webpack_require__("../../node_modules/lodash/isBuffer.js"),
        isIndex = __webpack_require__("../../node_modules/lodash/_isIndex.js"),
        isTypedArray = __webpack_require__("../../node_modules/lodash/isTypedArray.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        !inherited && !hasOwnProperty.call(value, key) || skipIndexes && ("length" == key || isBuff && ("offset" == key || "parent" == key) || isType && ("buffer" == key || "byteLength" == key || "byteOffset" == key) || isIndex(key, length)) || result.push(key);
      }

      return result;
    };
  },
  "../../node_modules/lodash/_arrayMap.js": function node_modulesLodash_arrayMapJs(module, exports) {
    module.exports = function (array, iteratee) {
      for (var index = -1, length = null == array ? 0 : array.length, result = Array(length); ++index < length;) {
        result[index] = iteratee(array[index], index, array);
      }

      return result;
    };
  },
  "../../node_modules/lodash/_arrayPush.js": function node_modulesLodash_arrayPushJs(module, exports) {
    module.exports = function (array, values) {
      for (var index = -1, length = values.length, offset = array.length; ++index < length;) {
        array[offset + index] = values[index];
      }

      return array;
    };
  },
  "../../node_modules/lodash/_arraySome.js": function node_modulesLodash_arraySomeJs(module, exports) {
    module.exports = function (array, predicate) {
      for (var index = -1, length = null == array ? 0 : array.length; ++index < length;) {
        if (predicate(array[index], index, array)) return !0;
      }

      return !1;
    };
  },
  "../../node_modules/lodash/_assocIndexOf.js": function node_modulesLodash_assocIndexOfJs(module, exports, __webpack_require__) {
    var eq = __webpack_require__("../../node_modules/lodash/eq.js");

    module.exports = function (array, key) {
      for (var length = array.length; length--;) {
        if (eq(array[length][0], key)) return length;
      }

      return -1;
    };
  },
  "../../node_modules/lodash/_baseFindKey.js": function node_modulesLodash_baseFindKeyJs(module, exports) {
    module.exports = function (collection, predicate, eachFunc) {
      var result;
      return eachFunc(collection, function (value, key, collection) {
        if (predicate(value, key, collection)) return result = key, !1;
      }), result;
    };
  },
  "../../node_modules/lodash/_baseFor.js": function node_modulesLodash_baseForJs(module, exports, __webpack_require__) {
    var baseFor = __webpack_require__("../../node_modules/lodash/_createBaseFor.js")();

    module.exports = baseFor;
  },
  "../../node_modules/lodash/_baseForOwn.js": function node_modulesLodash_baseForOwnJs(module, exports, __webpack_require__) {
    var baseFor = __webpack_require__("../../node_modules/lodash/_baseFor.js"),
        keys = __webpack_require__("../../node_modules/lodash/keys.js");

    module.exports = function (object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    };
  },
  "../../node_modules/lodash/_baseGet.js": function node_modulesLodash_baseGetJs(module, exports, __webpack_require__) {
    var castPath = __webpack_require__("../../node_modules/lodash/_castPath.js"),
        toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

    module.exports = function (object, path) {
      for (var index = 0, length = (path = castPath(path, object)).length; null != object && index < length;) {
        object = object[toKey(path[index++])];
      }

      return index && index == length ? object : void 0;
    };
  },
  "../../node_modules/lodash/_baseGetAllKeys.js": function node_modulesLodash_baseGetAllKeysJs(module, exports, __webpack_require__) {
    var arrayPush = __webpack_require__("../../node_modules/lodash/_arrayPush.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js");

    module.exports = function (object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    };
  },
  "../../node_modules/lodash/_baseGetTag.js": function node_modulesLodash_baseGetTagJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        getRawTag = __webpack_require__("../../node_modules/lodash/_getRawTag.js"),
        objectToString = __webpack_require__("../../node_modules/lodash/_objectToString.js"),
        symToStringTag = Symbol ? Symbol.toStringTag : void 0;

    module.exports = function (value) {
      return null == value ? void 0 === value ? "[object Undefined]" : "[object Null]" : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    };
  },
  "../../node_modules/lodash/_baseHasIn.js": function node_modulesLodash_baseHasInJs(module, exports) {
    module.exports = function (object, key) {
      return null != object && key in Object(object);
    };
  },
  "../../node_modules/lodash/_baseIsArguments.js": function node_modulesLodash_baseIsArgumentsJs(module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

    module.exports = function (value) {
      return isObjectLike(value) && "[object Arguments]" == baseGetTag(value);
    };
  },
  "../../node_modules/lodash/_baseIsEqual.js": function node_modulesLodash_baseIsEqualJs(module, exports, __webpack_require__) {
    var baseIsEqualDeep = __webpack_require__("../../node_modules/lodash/_baseIsEqualDeep.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

    module.exports = function baseIsEqual(value, other, bitmask, customizer, stack) {
      return value === other || (null == value || null == other || !isObjectLike(value) && !isObjectLike(other) ? value != value && other != other : baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack));
    };
  },
  "../../node_modules/lodash/_baseIsEqualDeep.js": function node_modulesLodash_baseIsEqualDeepJs(module, exports, __webpack_require__) {
    var Stack = __webpack_require__("../../node_modules/lodash/_Stack.js"),
        equalArrays = __webpack_require__("../../node_modules/lodash/_equalArrays.js"),
        equalByTag = __webpack_require__("../../node_modules/lodash/_equalByTag.js"),
        equalObjects = __webpack_require__("../../node_modules/lodash/_equalObjects.js"),
        getTag = __webpack_require__("../../node_modules/lodash/_getTag.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isBuffer = __webpack_require__("../../node_modules/lodash/isBuffer.js"),
        isTypedArray = __webpack_require__("../../node_modules/lodash/isTypedArray.js"),
        objectTag = "[object Object]",
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? "[object Array]" : getTag(object),
          othTag = othIsArr ? "[object Array]" : getTag(other),
          objIsObj = (objTag = "[object Arguments]" == objTag ? objectTag : objTag) == objectTag,
          othIsObj = (othTag = "[object Arguments]" == othTag ? objectTag : othTag) == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return !1;
        objIsArr = !0, objIsObj = !1;
      }

      if (isSameTag && !objIsObj) return stack || (stack = new Stack()), objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);

      if (!(1 & bitmask)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;
          return stack || (stack = new Stack()), equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }

      return !!isSameTag && (stack || (stack = new Stack()), equalObjects(object, other, bitmask, customizer, equalFunc, stack));
    };
  },
  "../../node_modules/lodash/_baseIsMatch.js": function node_modulesLodash_baseIsMatchJs(module, exports, __webpack_require__) {
    var Stack = __webpack_require__("../../node_modules/lodash/_Stack.js"),
        baseIsEqual = __webpack_require__("../../node_modules/lodash/_baseIsEqual.js");

    module.exports = function (object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;
      if (null == object) return !length;

      for (object = Object(object); index--;) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return !1;
      }

      for (; ++index < length;) {
        var key = (data = matchData[index])[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (void 0 === objValue && !(key in object)) return !1;
        } else {
          var stack = new Stack();
          if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
          if (!(void 0 === result ? baseIsEqual(srcValue, objValue, 3, customizer, stack) : result)) return !1;
        }
      }

      return !0;
    };
  },
  "../../node_modules/lodash/_baseIsNative.js": function node_modulesLodash_baseIsNativeJs(module, exports, __webpack_require__) {
    var isFunction = __webpack_require__("../../node_modules/lodash/isFunction.js"),
        isMasked = __webpack_require__("../../node_modules/lodash/_isMasked.js"),
        isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
        toSource = __webpack_require__("../../node_modules/lodash/_toSource.js"),
        reIsHostCtor = /^\[object .+?Constructor\]$/,
        funcProto = Function.prototype,
        objectProto = Object.prototype,
        funcToString = funcProto.toString,
        hasOwnProperty = objectProto.hasOwnProperty,
        reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    module.exports = function (value) {
      return !(!isObject(value) || isMasked(value)) && (isFunction(value) ? reIsNative : reIsHostCtor).test(toSource(value));
    };
  },
  "../../node_modules/lodash/_baseIsTypedArray.js": function node_modulesLodash_baseIsTypedArrayJs(module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        isLength = __webpack_require__("../../node_modules/lodash/isLength.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js"),
        typedArrayTags = {};

    typedArrayTags["[object Float32Array]"] = typedArrayTags["[object Float64Array]"] = typedArrayTags["[object Int8Array]"] = typedArrayTags["[object Int16Array]"] = typedArrayTags["[object Int32Array]"] = typedArrayTags["[object Uint8Array]"] = typedArrayTags["[object Uint8ClampedArray]"] = typedArrayTags["[object Uint16Array]"] = typedArrayTags["[object Uint32Array]"] = !0, typedArrayTags["[object Arguments]"] = typedArrayTags["[object Array]"] = typedArrayTags["[object ArrayBuffer]"] = typedArrayTags["[object Boolean]"] = typedArrayTags["[object DataView]"] = typedArrayTags["[object Date]"] = typedArrayTags["[object Error]"] = typedArrayTags["[object Function]"] = typedArrayTags["[object Map]"] = typedArrayTags["[object Number]"] = typedArrayTags["[object Object]"] = typedArrayTags["[object RegExp]"] = typedArrayTags["[object Set]"] = typedArrayTags["[object String]"] = typedArrayTags["[object WeakMap]"] = !1, module.exports = function (value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    };
  },
  "../../node_modules/lodash/_baseIteratee.js": function node_modulesLodash_baseIterateeJs(module, exports, __webpack_require__) {
    var baseMatches = __webpack_require__("../../node_modules/lodash/_baseMatches.js"),
        baseMatchesProperty = __webpack_require__("../../node_modules/lodash/_baseMatchesProperty.js"),
        identity = __webpack_require__("../../node_modules/lodash/identity.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        property = __webpack_require__("../../node_modules/lodash/property.js");

    module.exports = function (value) {
      return "function" == typeof value ? value : null == value ? identity : "object" == typeof value ? isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value) : property(value);
    };
  },
  "../../node_modules/lodash/_baseKeys.js": function node_modulesLodash_baseKeysJs(module, exports, __webpack_require__) {
    var isPrototype = __webpack_require__("../../node_modules/lodash/_isPrototype.js"),
        nativeKeys = __webpack_require__("../../node_modules/lodash/_nativeKeys.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (object) {
      if (!isPrototype(object)) return nativeKeys(object);
      var result = [];

      for (var key in Object(object)) {
        hasOwnProperty.call(object, key) && "constructor" != key && result.push(key);
      }

      return result;
    };
  },
  "../../node_modules/lodash/_baseMatches.js": function node_modulesLodash_baseMatchesJs(module, exports, __webpack_require__) {
    var baseIsMatch = __webpack_require__("../../node_modules/lodash/_baseIsMatch.js"),
        getMatchData = __webpack_require__("../../node_modules/lodash/_getMatchData.js"),
        matchesStrictComparable = __webpack_require__("../../node_modules/lodash/_matchesStrictComparable.js");

    module.exports = function (source) {
      var matchData = getMatchData(source);
      return 1 == matchData.length && matchData[0][2] ? matchesStrictComparable(matchData[0][0], matchData[0][1]) : function (object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    };
  },
  "../../node_modules/lodash/_baseMatchesProperty.js": function node_modulesLodash_baseMatchesPropertyJs(module, exports, __webpack_require__) {
    var baseIsEqual = __webpack_require__("../../node_modules/lodash/_baseIsEqual.js"),
        get = __webpack_require__("../../node_modules/lodash/get.js"),
        hasIn = __webpack_require__("../../node_modules/lodash/hasIn.js"),
        isKey = __webpack_require__("../../node_modules/lodash/_isKey.js"),
        isStrictComparable = __webpack_require__("../../node_modules/lodash/_isStrictComparable.js"),
        matchesStrictComparable = __webpack_require__("../../node_modules/lodash/_matchesStrictComparable.js"),
        toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

    module.exports = function (path, srcValue) {
      return isKey(path) && isStrictComparable(srcValue) ? matchesStrictComparable(toKey(path), srcValue) : function (object) {
        var objValue = get(object, path);
        return void 0 === objValue && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, 3);
      };
    };
  },
  "../../node_modules/lodash/_baseProperty.js": function node_modulesLodash_basePropertyJs(module, exports) {
    module.exports = function (key) {
      return function (object) {
        return null == object ? void 0 : object[key];
      };
    };
  },
  "../../node_modules/lodash/_basePropertyDeep.js": function node_modulesLodash_basePropertyDeepJs(module, exports, __webpack_require__) {
    var baseGet = __webpack_require__("../../node_modules/lodash/_baseGet.js");

    module.exports = function (path) {
      return function (object) {
        return baseGet(object, path);
      };
    };
  },
  "../../node_modules/lodash/_baseTimes.js": function node_modulesLodash_baseTimesJs(module, exports) {
    module.exports = function (n, iteratee) {
      for (var index = -1, result = Array(n); ++index < n;) {
        result[index] = iteratee(index);
      }

      return result;
    };
  },
  "../../node_modules/lodash/_baseToString.js": function node_modulesLodash_baseToStringJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        arrayMap = __webpack_require__("../../node_modules/lodash/_arrayMap.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js"),
        symbolProto = Symbol ? Symbol.prototype : void 0,
        symbolToString = symbolProto ? symbolProto.toString : void 0;

    module.exports = function baseToString(value) {
      if ("string" == typeof value) return value;
      if (isArray(value)) return arrayMap(value, baseToString) + "";
      if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
      var result = value + "";
      return "0" == result && 1 / value == -1 / 0 ? "-0" : result;
    };
  },
  "../../node_modules/lodash/_baseUnary.js": function node_modulesLodash_baseUnaryJs(module, exports) {
    module.exports = function (func) {
      return function (value) {
        return func(value);
      };
    };
  },
  "../../node_modules/lodash/_cacheHas.js": function node_modulesLodash_cacheHasJs(module, exports) {
    module.exports = function (cache, key) {
      return cache.has(key);
    };
  },
  "../../node_modules/lodash/_castPath.js": function node_modulesLodash_castPathJs(module, exports, __webpack_require__) {
    var isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isKey = __webpack_require__("../../node_modules/lodash/_isKey.js"),
        stringToPath = __webpack_require__("../../node_modules/lodash/_stringToPath.js"),
        toString = __webpack_require__("../../node_modules/lodash/toString.js");

    module.exports = function (value, object) {
      return isArray(value) ? value : isKey(value, object) ? [value] : stringToPath(toString(value));
    };
  },
  "../../node_modules/lodash/_coreJsData.js": function node_modulesLodash_coreJsDataJs(module, exports, __webpack_require__) {
    var coreJsData = __webpack_require__("../../node_modules/lodash/_root.js")["__core-js_shared__"];

    module.exports = coreJsData;
  },
  "../../node_modules/lodash/_createBaseFor.js": function node_modulesLodash_createBaseForJs(module, exports) {
    module.exports = function (fromRight) {
      return function (object, iteratee, keysFunc) {
        for (var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length; length--;) {
          var key = props[fromRight ? length : ++index];
          if (!1 === iteratee(iterable[key], key, iterable)) break;
        }

        return object;
      };
    };
  },
  "../../node_modules/lodash/_equalArrays.js": function node_modulesLodash_equalArraysJs(module, exports, __webpack_require__) {
    var SetCache = __webpack_require__("../../node_modules/lodash/_SetCache.js"),
        arraySome = __webpack_require__("../../node_modules/lodash/_arraySome.js"),
        cacheHas = __webpack_require__("../../node_modules/lodash/_cacheHas.js");

    module.exports = function (array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = 1 & bitmask,
          arrLength = array.length,
          othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) return !1;
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) return stacked == other;
      var index = -1,
          result = !0,
          seen = 2 & bitmask ? new SetCache() : void 0;

      for (stack.set(array, other), stack.set(other, array); ++index < arrLength;) {
        var arrValue = array[index],
            othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);

        if (void 0 !== compared) {
          if (compared) continue;
          result = !1;
          break;
        }

        if (seen) {
          if (!arraySome(other, function (othValue, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
          })) {
            result = !1;
            break;
          }
        } else if (arrValue !== othValue && !equalFunc(arrValue, othValue, bitmask, customizer, stack)) {
          result = !1;
          break;
        }
      }

      return stack.delete(array), stack.delete(other), result;
    };
  },
  "../../node_modules/lodash/_equalByTag.js": function node_modulesLodash_equalByTagJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        Uint8Array = __webpack_require__("../../node_modules/lodash/_Uint8Array.js"),
        eq = __webpack_require__("../../node_modules/lodash/eq.js"),
        equalArrays = __webpack_require__("../../node_modules/lodash/_equalArrays.js"),
        mapToArray = __webpack_require__("../../node_modules/lodash/_mapToArray.js"),
        setToArray = __webpack_require__("../../node_modules/lodash/_setToArray.js"),
        symbolProto = Symbol ? Symbol.prototype : void 0,
        symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;

    module.exports = function (object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case "[object DataView]":
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return !1;
          object = object.buffer, other = other.buffer;

        case "[object ArrayBuffer]":
          return !(object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return eq(+object, +other);

        case "[object Error]":
          return object.name == other.name && object.message == other.message;

        case "[object RegExp]":
        case "[object String]":
          return object == other + "";

        case "[object Map]":
          var convert = mapToArray;

        case "[object Set]":
          var isPartial = 1 & bitmask;
          if (convert || (convert = setToArray), object.size != other.size && !isPartial) return !1;
          var stacked = stack.get(object);
          if (stacked) return stacked == other;
          bitmask |= 2, stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          return stack.delete(object), result;

        case "[object Symbol]":
          if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

      return !1;
    };
  },
  "../../node_modules/lodash/_equalObjects.js": function node_modulesLodash_equalObjectsJs(module, exports, __webpack_require__) {
    var getAllKeys = __webpack_require__("../../node_modules/lodash/_getAllKeys.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = 1 & bitmask,
          objProps = getAllKeys(object),
          objLength = objProps.length;
      if (objLength != getAllKeys(other).length && !isPartial) return !1;

      for (var index = objLength; index--;) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return !1;
      }

      var stacked = stack.get(object);
      if (stacked && stack.get(other)) return stacked == other;
      var result = !0;
      stack.set(object, other), stack.set(other, object);

      for (var skipCtor = isPartial; ++index < objLength;) {
        var objValue = object[key = objProps[index]],
            othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);

        if (!(void 0 === compared ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = !1;
          break;
        }

        skipCtor || (skipCtor = "constructor" == key);
      }

      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;
        objCtor == othCtor || !("constructor" in object) || !("constructor" in other) || "function" == typeof objCtor && objCtor instanceof objCtor && "function" == typeof othCtor && othCtor instanceof othCtor || (result = !1);
      }

      return stack.delete(object), stack.delete(other), result;
    };
  },
  "../../node_modules/lodash/_freeGlobal.js": function node_modulesLodash_freeGlobalJs(module, exports, __webpack_require__) {
    (function (global) {
      var freeGlobal = "object" == typeof global && global && global.Object === Object && global;
      module.exports = freeGlobal;
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "../../node_modules/lodash/_getAllKeys.js": function node_modulesLodash_getAllKeysJs(module, exports, __webpack_require__) {
    var baseGetAllKeys = __webpack_require__("../../node_modules/lodash/_baseGetAllKeys.js"),
        getSymbols = __webpack_require__("../../node_modules/lodash/_getSymbols.js"),
        keys = __webpack_require__("../../node_modules/lodash/keys.js");

    module.exports = function (object) {
      return baseGetAllKeys(object, keys, getSymbols);
    };
  },
  "../../node_modules/lodash/_getMapData.js": function node_modulesLodash_getMapDataJs(module, exports, __webpack_require__) {
    var isKeyable = __webpack_require__("../../node_modules/lodash/_isKeyable.js");

    module.exports = function (map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data["string" == typeof key ? "string" : "hash"] : data.map;
    };
  },
  "../../node_modules/lodash/_getMatchData.js": function node_modulesLodash_getMatchDataJs(module, exports, __webpack_require__) {
    var isStrictComparable = __webpack_require__("../../node_modules/lodash/_isStrictComparable.js"),
        keys = __webpack_require__("../../node_modules/lodash/keys.js");

    module.exports = function (object) {
      for (var result = keys(object), length = result.length; length--;) {
        var key = result[length],
            value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
      }

      return result;
    };
  },
  "../../node_modules/lodash/_getNative.js": function node_modulesLodash_getNativeJs(module, exports, __webpack_require__) {
    var baseIsNative = __webpack_require__("../../node_modules/lodash/_baseIsNative.js"),
        getValue = __webpack_require__("../../node_modules/lodash/_getValue.js");

    module.exports = function (object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    };
  },
  "../../node_modules/lodash/_getRawTag.js": function node_modulesLodash_getRawTagJs(module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
        objectProto = Object.prototype,
        hasOwnProperty = objectProto.hasOwnProperty,
        nativeObjectToString = objectProto.toString,
        symToStringTag = Symbol ? Symbol.toStringTag : void 0;

    module.exports = function (value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = void 0;
        var unmasked = !0;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
    };
  },
  "../../node_modules/lodash/_getSymbols.js": function node_modulesLodash_getSymbolsJs(module, exports, __webpack_require__) {
    var arrayFilter = __webpack_require__("../../node_modules/lodash/_arrayFilter.js"),
        stubArray = __webpack_require__("../../node_modules/lodash/stubArray.js"),
        propertyIsEnumerable = Object.prototype.propertyIsEnumerable,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        getSymbols = nativeGetSymbols ? function (object) {
      return null == object ? [] : (object = Object(object), arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      }));
    } : stubArray;

    module.exports = getSymbols;
  },
  "../../node_modules/lodash/_getTag.js": function node_modulesLodash_getTagJs(module, exports, __webpack_require__) {
    var DataView = __webpack_require__("../../node_modules/lodash/_DataView.js"),
        Map = __webpack_require__("../../node_modules/lodash/_Map.js"),
        Promise = __webpack_require__("../../node_modules/lodash/_Promise.js"),
        Set = __webpack_require__("../../node_modules/lodash/_Set.js"),
        WeakMap = __webpack_require__("../../node_modules/lodash/_WeakMap.js"),
        baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        toSource = __webpack_require__("../../node_modules/lodash/_toSource.js"),
        dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap),
        getTag = baseGetTag;

    (DataView && "[object DataView]" != getTag(new DataView(new ArrayBuffer(1))) || Map && "[object Map]" != getTag(new Map()) || Promise && "[object Promise]" != getTag(Promise.resolve()) || Set && "[object Set]" != getTag(new Set()) || WeakMap && "[object WeakMap]" != getTag(new WeakMap())) && (getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = "[object Object]" == result ? value.constructor : void 0,
          ctorString = Ctor ? toSource(Ctor) : "";
      if (ctorString) switch (ctorString) {
        case dataViewCtorString:
          return "[object DataView]";

        case mapCtorString:
          return "[object Map]";

        case promiseCtorString:
          return "[object Promise]";

        case setCtorString:
          return "[object Set]";

        case weakMapCtorString:
          return "[object WeakMap]";
      }
      return result;
    }), module.exports = getTag;
  },
  "../../node_modules/lodash/_getValue.js": function node_modulesLodash_getValueJs(module, exports) {
    module.exports = function (object, key) {
      return null == object ? void 0 : object[key];
    };
  },
  "../../node_modules/lodash/_hasPath.js": function node_modulesLodash_hasPathJs(module, exports, __webpack_require__) {
    var castPath = __webpack_require__("../../node_modules/lodash/_castPath.js"),
        isArguments = __webpack_require__("../../node_modules/lodash/isArguments.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isIndex = __webpack_require__("../../node_modules/lodash/_isIndex.js"),
        isLength = __webpack_require__("../../node_modules/lodash/isLength.js"),
        toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

    module.exports = function (object, path, hasFunc) {
      for (var index = -1, length = (path = castPath(path, object)).length, result = !1; ++index < length;) {
        var key = toKey(path[index]);
        if (!(result = null != object && hasFunc(object, key))) break;
        object = object[key];
      }

      return result || ++index != length ? result : !!(length = null == object ? 0 : object.length) && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    };
  },
  "../../node_modules/lodash/_hashClear.js": function node_modulesLodash_hashClearJs(module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("../../node_modules/lodash/_nativeCreate.js");

    module.exports = function () {
      this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
    };
  },
  "../../node_modules/lodash/_hashDelete.js": function node_modulesLodash_hashDeleteJs(module, exports) {
    module.exports = function (key) {
      var result = this.has(key) && delete this.__data__[key];
      return this.size -= result ? 1 : 0, result;
    };
  },
  "../../node_modules/lodash/_hashGet.js": function node_modulesLodash_hashGetJs(module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("../../node_modules/lodash/_nativeCreate.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return "__lodash_hash_undefined__" === result ? void 0 : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    };
  },
  "../../node_modules/lodash/_hashHas.js": function node_modulesLodash_hashHasJs(module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("../../node_modules/lodash/_nativeCreate.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (key) {
      var data = this.__data__;
      return nativeCreate ? void 0 !== data[key] : hasOwnProperty.call(data, key);
    };
  },
  "../../node_modules/lodash/_hashSet.js": function node_modulesLodash_hashSetJs(module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("../../node_modules/lodash/_nativeCreate.js");

    module.exports = function (key, value) {
      var data = this.__data__;
      return this.size += this.has(key) ? 0 : 1, data[key] = nativeCreate && void 0 === value ? "__lodash_hash_undefined__" : value, this;
    };
  },
  "../../node_modules/lodash/_isIndex.js": function node_modulesLodash_isIndexJs(module, exports) {
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    module.exports = function (value, length) {
      var type = typeof value;
      return !!(length = null == length ? 9007199254740991 : length) && ("number" == type || "symbol" != type && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    };
  },
  "../../node_modules/lodash/_isKey.js": function node_modulesLodash_isKeyJs(module, exports, __webpack_require__) {
    var isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js"),
        reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/;

    module.exports = function (value, object) {
      if (isArray(value)) return !1;
      var type = typeof value;
      return !("number" != type && "symbol" != type && "boolean" != type && null != value && !isSymbol(value)) || reIsPlainProp.test(value) || !reIsDeepProp.test(value) || null != object && value in Object(object);
    };
  },
  "../../node_modules/lodash/_isKeyable.js": function node_modulesLodash_isKeyableJs(module, exports) {
    module.exports = function (value) {
      var type = typeof value;
      return "string" == type || "number" == type || "symbol" == type || "boolean" == type ? "__proto__" !== value : null === value;
    };
  },
  "../../node_modules/lodash/_isMasked.js": function node_modulesLodash_isMaskedJs(module, exports, __webpack_require__) {
    var uid,
        coreJsData = __webpack_require__("../../node_modules/lodash/_coreJsData.js"),
        maskSrcKey = (uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "")) ? "Symbol(src)_1." + uid : "";

    module.exports = function (func) {
      return !!maskSrcKey && maskSrcKey in func;
    };
  },
  "../../node_modules/lodash/_isPrototype.js": function node_modulesLodash_isPrototypeJs(module, exports) {
    var objectProto = Object.prototype;

    module.exports = function (value) {
      var Ctor = value && value.constructor;
      return value === ("function" == typeof Ctor && Ctor.prototype || objectProto);
    };
  },
  "../../node_modules/lodash/_isStrictComparable.js": function node_modulesLodash_isStrictComparableJs(module, exports, __webpack_require__) {
    var isObject = __webpack_require__("../../node_modules/lodash/isObject.js");

    module.exports = function (value) {
      return value == value && !isObject(value);
    };
  },
  "../../node_modules/lodash/_listCacheClear.js": function node_modulesLodash_listCacheClearJs(module, exports) {
    module.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  },
  "../../node_modules/lodash/_listCacheDelete.js": function node_modulesLodash_listCacheDeleteJs(module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js"),
        splice = Array.prototype.splice;

    module.exports = function (key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return !(index < 0) && (index == data.length - 1 ? data.pop() : splice.call(data, index, 1), --this.size, !0);
    };
  },
  "../../node_modules/lodash/_listCacheGet.js": function node_modulesLodash_listCacheGetJs(module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

    module.exports = function (key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    };
  },
  "../../node_modules/lodash/_listCacheHas.js": function node_modulesLodash_listCacheHasJs(module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

    module.exports = function (key) {
      return assocIndexOf(this.__data__, key) > -1;
    };
  },
  "../../node_modules/lodash/_listCacheSet.js": function node_modulesLodash_listCacheSetJs(module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

    module.exports = function (key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? (++this.size, data.push([key, value])) : data[index][1] = value, this;
    };
  },
  "../../node_modules/lodash/_mapCacheClear.js": function node_modulesLodash_mapCacheClearJs(module, exports, __webpack_require__) {
    var Hash = __webpack_require__("../../node_modules/lodash/_Hash.js"),
        ListCache = __webpack_require__("../../node_modules/lodash/_ListCache.js"),
        Map = __webpack_require__("../../node_modules/lodash/_Map.js");

    module.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new Hash(),
        map: new (Map || ListCache)(),
        string: new Hash()
      };
    };
  },
  "../../node_modules/lodash/_mapCacheDelete.js": function node_modulesLodash_mapCacheDeleteJs(module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("../../node_modules/lodash/_getMapData.js");

    module.exports = function (key) {
      var result = getMapData(this, key).delete(key);
      return this.size -= result ? 1 : 0, result;
    };
  },
  "../../node_modules/lodash/_mapCacheGet.js": function node_modulesLodash_mapCacheGetJs(module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("../../node_modules/lodash/_getMapData.js");

    module.exports = function (key) {
      return getMapData(this, key).get(key);
    };
  },
  "../../node_modules/lodash/_mapCacheHas.js": function node_modulesLodash_mapCacheHasJs(module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("../../node_modules/lodash/_getMapData.js");

    module.exports = function (key) {
      return getMapData(this, key).has(key);
    };
  },
  "../../node_modules/lodash/_mapCacheSet.js": function node_modulesLodash_mapCacheSetJs(module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("../../node_modules/lodash/_getMapData.js");

    module.exports = function (key, value) {
      var data = getMapData(this, key),
          size = data.size;
      return data.set(key, value), this.size += data.size == size ? 0 : 1, this;
    };
  },
  "../../node_modules/lodash/_mapToArray.js": function node_modulesLodash_mapToArrayJs(module, exports) {
    module.exports = function (map) {
      var index = -1,
          result = Array(map.size);
      return map.forEach(function (value, key) {
        result[++index] = [key, value];
      }), result;
    };
  },
  "../../node_modules/lodash/_matchesStrictComparable.js": function node_modulesLodash_matchesStrictComparableJs(module, exports) {
    module.exports = function (key, srcValue) {
      return function (object) {
        return null != object && object[key] === srcValue && (void 0 !== srcValue || key in Object(object));
      };
    };
  },
  "../../node_modules/lodash/_memoizeCapped.js": function node_modulesLodash_memoizeCappedJs(module, exports, __webpack_require__) {
    var memoize = __webpack_require__("../../node_modules/lodash/memoize.js");

    module.exports = function (func) {
      var result = memoize(func, function (key) {
        return 500 === cache.size && cache.clear(), key;
      }),
          cache = result.cache;
      return result;
    };
  },
  "../../node_modules/lodash/_nativeCreate.js": function node_modulesLodash_nativeCreateJs(module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("../../node_modules/lodash/_getNative.js")(Object, "create");

    module.exports = nativeCreate;
  },
  "../../node_modules/lodash/_nativeKeys.js": function node_modulesLodash_nativeKeysJs(module, exports, __webpack_require__) {
    var nativeKeys = __webpack_require__("../../node_modules/lodash/_overArg.js")(Object.keys, Object);

    module.exports = nativeKeys;
  },
  "../../node_modules/lodash/_nodeUtil.js": function node_modulesLodash_nodeUtilJs(module, exports, __webpack_require__) {
    (function (module) {
      var freeGlobal = __webpack_require__("../../node_modules/lodash/_freeGlobal.js"),
          freeExports = exports && !exports.nodeType && exports,
          freeModule = freeExports && "object" == typeof module && module && !module.nodeType && module,
          freeProcess = freeModule && freeModule.exports === freeExports && freeGlobal.process,
          nodeUtil = function () {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;

          return types || freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
      }();

      module.exports = nodeUtil;
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/module.js")(module));
  },
  "../../node_modules/lodash/_objectToString.js": function node_modulesLodash_objectToStringJs(module, exports) {
    var nativeObjectToString = Object.prototype.toString;

    module.exports = function (value) {
      return nativeObjectToString.call(value);
    };
  },
  "../../node_modules/lodash/_overArg.js": function node_modulesLodash_overArgJs(module, exports) {
    module.exports = function (func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    };
  },
  "../../node_modules/lodash/_root.js": function node_modulesLodash_rootJs(module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__("../../node_modules/lodash/_freeGlobal.js"),
        freeSelf = "object" == typeof self && self && self.Object === Object && self,
        root = freeGlobal || freeSelf || Function("return this")();

    module.exports = root;
  },
  "../../node_modules/lodash/_setCacheAdd.js": function node_modulesLodash_setCacheAddJs(module, exports) {
    module.exports = function (value) {
      return this.__data__.set(value, "__lodash_hash_undefined__"), this;
    };
  },
  "../../node_modules/lodash/_setCacheHas.js": function node_modulesLodash_setCacheHasJs(module, exports) {
    module.exports = function (value) {
      return this.__data__.has(value);
    };
  },
  "../../node_modules/lodash/_setToArray.js": function node_modulesLodash_setToArrayJs(module, exports) {
    module.exports = function (set) {
      var index = -1,
          result = Array(set.size);
      return set.forEach(function (value) {
        result[++index] = value;
      }), result;
    };
  },
  "../../node_modules/lodash/_stackClear.js": function node_modulesLodash_stackClearJs(module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("../../node_modules/lodash/_ListCache.js");

    module.exports = function () {
      this.__data__ = new ListCache(), this.size = 0;
    };
  },
  "../../node_modules/lodash/_stackDelete.js": function node_modulesLodash_stackDeleteJs(module, exports) {
    module.exports = function (key) {
      var data = this.__data__,
          result = data.delete(key);
      return this.size = data.size, result;
    };
  },
  "../../node_modules/lodash/_stackGet.js": function node_modulesLodash_stackGetJs(module, exports) {
    module.exports = function (key) {
      return this.__data__.get(key);
    };
  },
  "../../node_modules/lodash/_stackHas.js": function node_modulesLodash_stackHasJs(module, exports) {
    module.exports = function (key) {
      return this.__data__.has(key);
    };
  },
  "../../node_modules/lodash/_stackSet.js": function node_modulesLodash_stackSetJs(module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("../../node_modules/lodash/_ListCache.js"),
        Map = __webpack_require__("../../node_modules/lodash/_Map.js"),
        MapCache = __webpack_require__("../../node_modules/lodash/_MapCache.js");

    module.exports = function (key, value) {
      var data = this.__data__;

      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < 199) return pairs.push([key, value]), this.size = ++data.size, this;
        data = this.__data__ = new MapCache(pairs);
      }

      return data.set(key, value), this.size = data.size, this;
    };
  },
  "../../node_modules/lodash/_stringToPath.js": function node_modulesLodash_stringToPathJs(module, exports, __webpack_require__) {
    var memoizeCapped = __webpack_require__("../../node_modules/lodash/_memoizeCapped.js"),
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        reEscapeChar = /\\(\\)?/g,
        stringToPath = memoizeCapped(function (string) {
      var result = [];
      return 46 === string.charCodeAt(0) && result.push(""), string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
      }), result;
    });

    module.exports = stringToPath;
  },
  "../../node_modules/lodash/_toKey.js": function node_modulesLodash_toKeyJs(module, exports, __webpack_require__) {
    var isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js");

    module.exports = function (value) {
      if ("string" == typeof value || isSymbol(value)) return value;
      var result = value + "";
      return "0" == result && 1 / value == -1 / 0 ? "-0" : result;
    };
  },
  "../../node_modules/lodash/_toSource.js": function node_modulesLodash_toSourceJs(module, exports) {
    var funcToString = Function.prototype.toString;

    module.exports = function (func) {
      if (null != func) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + "";
        } catch (e) {}
      }

      return "";
    };
  },
  "../../node_modules/lodash/eq.js": function node_modulesLodashEqJs(module, exports) {
    module.exports = function (value, other) {
      return value === other || value != value && other != other;
    };
  },
  "../../node_modules/lodash/findKey.js": function node_modulesLodashFindKeyJs(module, exports, __webpack_require__) {
    var baseFindKey = __webpack_require__("../../node_modules/lodash/_baseFindKey.js"),
        baseForOwn = __webpack_require__("../../node_modules/lodash/_baseForOwn.js"),
        baseIteratee = __webpack_require__("../../node_modules/lodash/_baseIteratee.js");

    module.exports = function (object, predicate) {
      return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
    };
  },
  "../../node_modules/lodash/get.js": function node_modulesLodashGetJs(module, exports, __webpack_require__) {
    var baseGet = __webpack_require__("../../node_modules/lodash/_baseGet.js");

    module.exports = function (object, path, defaultValue) {
      var result = null == object ? void 0 : baseGet(object, path);
      return void 0 === result ? defaultValue : result;
    };
  },
  "../../node_modules/lodash/hasIn.js": function node_modulesLodashHasInJs(module, exports, __webpack_require__) {
    var baseHasIn = __webpack_require__("../../node_modules/lodash/_baseHasIn.js"),
        hasPath = __webpack_require__("../../node_modules/lodash/_hasPath.js");

    module.exports = function (object, path) {
      return null != object && hasPath(object, path, baseHasIn);
    };
  },
  "../../node_modules/lodash/identity.js": function node_modulesLodashIdentityJs(module, exports) {
    module.exports = function (value) {
      return value;
    };
  },
  "../../node_modules/lodash/isArguments.js": function node_modulesLodashIsArgumentsJs(module, exports, __webpack_require__) {
    var baseIsArguments = __webpack_require__("../../node_modules/lodash/_baseIsArguments.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js"),
        objectProto = Object.prototype,
        hasOwnProperty = objectProto.hasOwnProperty,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };

    module.exports = isArguments;
  },
  "../../node_modules/lodash/isArray.js": function node_modulesLodashIsArrayJs(module, exports) {
    var isArray = Array.isArray;
    module.exports = isArray;
  },
  "../../node_modules/lodash/isArrayLike.js": function node_modulesLodashIsArrayLikeJs(module, exports, __webpack_require__) {
    var isFunction = __webpack_require__("../../node_modules/lodash/isFunction.js"),
        isLength = __webpack_require__("../../node_modules/lodash/isLength.js");

    module.exports = function (value) {
      return null != value && isLength(value.length) && !isFunction(value);
    };
  },
  "../../node_modules/lodash/isBuffer.js": function node_modulesLodashIsBufferJs(module, exports, __webpack_require__) {
    (function (module) {
      var root = __webpack_require__("../../node_modules/lodash/_root.js"),
          stubFalse = __webpack_require__("../../node_modules/lodash/stubFalse.js"),
          freeExports = exports && !exports.nodeType && exports,
          freeModule = freeExports && "object" == typeof module && module && !module.nodeType && module,
          Buffer = freeModule && freeModule.exports === freeExports ? root.Buffer : void 0,
          isBuffer = (Buffer ? Buffer.isBuffer : void 0) || stubFalse;

      module.exports = isBuffer;
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/module.js")(module));
  },
  "../../node_modules/lodash/isEmpty.js": function node_modulesLodashIsEmptyJs(module, exports, __webpack_require__) {
    var baseKeys = __webpack_require__("../../node_modules/lodash/_baseKeys.js"),
        getTag = __webpack_require__("../../node_modules/lodash/_getTag.js"),
        isArguments = __webpack_require__("../../node_modules/lodash/isArguments.js"),
        isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
        isArrayLike = __webpack_require__("../../node_modules/lodash/isArrayLike.js"),
        isBuffer = __webpack_require__("../../node_modules/lodash/isBuffer.js"),
        isPrototype = __webpack_require__("../../node_modules/lodash/_isPrototype.js"),
        isTypedArray = __webpack_require__("../../node_modules/lodash/isTypedArray.js"),
        hasOwnProperty = Object.prototype.hasOwnProperty;

    module.exports = function (value) {
      if (null == value) return !0;
      if (isArrayLike(value) && (isArray(value) || "string" == typeof value || "function" == typeof value.splice || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
      var tag = getTag(value);
      if ("[object Map]" == tag || "[object Set]" == tag) return !value.size;
      if (isPrototype(value)) return !baseKeys(value).length;

      for (var key in value) {
        if (hasOwnProperty.call(value, key)) return !1;
      }

      return !0;
    };
  },
  "../../node_modules/lodash/isFunction.js": function node_modulesLodashIsFunctionJs(module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        isObject = __webpack_require__("../../node_modules/lodash/isObject.js");

    module.exports = function (value) {
      if (!isObject(value)) return !1;
      var tag = baseGetTag(value);
      return "[object Function]" == tag || "[object GeneratorFunction]" == tag || "[object AsyncFunction]" == tag || "[object Proxy]" == tag;
    };
  },
  "../../node_modules/lodash/isLength.js": function node_modulesLodashIsLengthJs(module, exports) {
    module.exports = function (value) {
      return "number" == typeof value && value > -1 && value % 1 == 0 && value <= 9007199254740991;
    };
  },
  "../../node_modules/lodash/isNil.js": function node_modulesLodashIsNilJs(module, exports) {
    module.exports = function (value) {
      return null == value;
    };
  },
  "../../node_modules/lodash/isObject.js": function node_modulesLodashIsObjectJs(module, exports) {
    module.exports = function (value) {
      var type = typeof value;
      return null != value && ("object" == type || "function" == type);
    };
  },
  "../../node_modules/lodash/isObjectLike.js": function node_modulesLodashIsObjectLikeJs(module, exports) {
    module.exports = function (value) {
      return null != value && "object" == typeof value;
    };
  },
  "../../node_modules/lodash/isSymbol.js": function node_modulesLodashIsSymbolJs(module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
        isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

    module.exports = function (value) {
      return "symbol" == typeof value || isObjectLike(value) && "[object Symbol]" == baseGetTag(value);
    };
  },
  "../../node_modules/lodash/isTypedArray.js": function node_modulesLodashIsTypedArrayJs(module, exports, __webpack_require__) {
    var baseIsTypedArray = __webpack_require__("../../node_modules/lodash/_baseIsTypedArray.js"),
        baseUnary = __webpack_require__("../../node_modules/lodash/_baseUnary.js"),
        nodeUtil = __webpack_require__("../../node_modules/lodash/_nodeUtil.js"),
        nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray,
        isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    module.exports = isTypedArray;
  },
  "../../node_modules/lodash/keys.js": function node_modulesLodashKeysJs(module, exports, __webpack_require__) {
    var arrayLikeKeys = __webpack_require__("../../node_modules/lodash/_arrayLikeKeys.js"),
        baseKeys = __webpack_require__("../../node_modules/lodash/_baseKeys.js"),
        isArrayLike = __webpack_require__("../../node_modules/lodash/isArrayLike.js");

    module.exports = function (object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    };
  },
  "../../node_modules/lodash/memoize.js": function node_modulesLodashMemoizeJs(module, exports, __webpack_require__) {
    var MapCache = __webpack_require__("../../node_modules/lodash/_MapCache.js");

    function memoize(func, resolver) {
      if ("function" != typeof func || null != resolver && "function" != typeof resolver) throw new TypeError("Expected a function");

      var memoized = function memoized() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        return memoized.cache = cache.set(key, result) || cache, result;
      };

      return memoized.cache = new (memoize.Cache || MapCache)(), memoized;
    }

    memoize.Cache = MapCache, module.exports = memoize;
  },
  "../../node_modules/lodash/property.js": function node_modulesLodashPropertyJs(module, exports, __webpack_require__) {
    var baseProperty = __webpack_require__("../../node_modules/lodash/_baseProperty.js"),
        basePropertyDeep = __webpack_require__("../../node_modules/lodash/_basePropertyDeep.js"),
        isKey = __webpack_require__("../../node_modules/lodash/_isKey.js"),
        toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

    module.exports = function (path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    };
  },
  "../../node_modules/lodash/stubArray.js": function node_modulesLodashStubArrayJs(module, exports) {
    module.exports = function () {
      return [];
    };
  },
  "../../node_modules/lodash/stubFalse.js": function node_modulesLodashStubFalseJs(module, exports) {
    module.exports = function () {
      return !1;
    };
  },
  "../../node_modules/lodash/stubTrue.js": function node_modulesLodashStubTrueJs(module, exports) {
    module.exports = function () {
      return !0;
    };
  },
  "../../node_modules/lodash/toString.js": function node_modulesLodashToStringJs(module, exports, __webpack_require__) {
    var baseToString = __webpack_require__("../../node_modules/lodash/_baseToString.js");

    module.exports = function (value) {
      return null == value ? "" : baseToString(value);
    };
  },
  "../../node_modules/webpack/buildin/global.js": function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g;

    g = function () {
      return this;
    }();

    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }

    module.exports = g;
  },
  "../../node_modules/webpack/buildin/module.js": function node_modulesWebpackBuildinModuleJs(module, exports) {
    module.exports = function (module) {
      return module.webpackPolyfill || (module.deprecate = function () {}, module.paths = [], module.children || (module.children = []), Object.defineProperty(module, "loaded", {
        enumerable: !0,
        get: function get() {
          return module.l;
        }
      }), Object.defineProperty(module, "id", {
        enumerable: !0,
        get: function get() {
          return module.i;
        }
      }), module.webpackPolyfill = 1), module;
    };
  },
  "./DataTable.module.scss": function DataTableModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__DataTable__themeRoot",
      dataTable: "jut__DataTable__dataTable",
      unsortedHeaderCell: "jut__DataTable__unsortedHeaderCell",
      clickableRow: "jut__DataTable__clickableRow",
      activeRow: "jut__DataTable__activeRow",
      selectedRow: "jut__DataTable__selectedRow",
      reactTable: "jut__DataTable__reactTable",
      tableHeader: "jut__DataTable__tableHeader",
      tableBody: "jut__DataTable__tableBody",
      tableRowGroup: "jut__DataTable__tableRowGroup",
      tableHeaderCell: "jut__DataTable__tableHeaderCell",
      tableRow: "jut__DataTable__tableRow",
      tableCell: "jut__DataTable__tableCell",
      headerOneLine: "jut__DataTable__headerOneLine",
      editedCell: "jut__DataTable__editedCell",
      actionColumn: "jut__DataTable__actionColumn",
      rightAlignCell: "jut__DataTable__rightAlignCell",
      selectionCell: "jut__DataTable__selectionCell",
      serviceCell: "jut__DataTable__serviceCell",
      expanderCell: "jut__DataTable__expanderCell",
      expanderIcon: "jut__DataTable__expanderIcon",
      tableBar: "jut__DataTable__tableBar",
      selectionActions: "jut__DataTable__selectionActions",
      transition: "jut__DataTable__transition",
      buttons: "jut__DataTable__buttons",
      enter: "jut__DataTable__enter",
      withBorder: "jut__DataTable__withBorder",
      columnsConfigAction: "jut__DataTable__columnsConfigAction",
      searchWrapper: "jut__DataTable__searchWrapper",
      search: "jut__DataTable__search",
      expandableRowWrapper: "jut__DataTable__expandableRowWrapper",
      expandableRow: "jut__DataTable__expandableRow",
      noDataMessage: "jut__DataTable__noDataMessage",
      radio: "jut__DataTable__radio",
      headerMultiline: "jut__DataTable__headerMultiline",
      actionPanel: "jut__DataTable__actionPanel"
    };
  },
  "./Pagination/Pagination.module.scss": function PaginationPaginationModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      pagination: "jut__Pagination__pagination",
      paginationNav: "jut__Pagination__paginationNav",
      paginationNavButton: "jut__Pagination__paginationNavButton",
      pageButtonsWrapper: "jut__Pagination__pageButtonsWrapper",
      selectedPageButton: "jut__Pagination__selectedPageButton",
      resultOfMessage: "jut__Pagination__resultOfMessage",
      pageSizeSelectWrapper: "jut__Pagination__pageSizeSelectWrapper",
      paginationSelect: "jut__Pagination__paginationSelect",
      paginationMenu: "jut__Pagination__paginationMenu",
      paginationMenuItem: "jut__Pagination__paginationMenuItem"
    };
  },
  "./columns/ActionColumn.module.scss": function columnsActionColumnModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__ActionColumn__themeRoot",
      actionButton: "jut__ActionColumn__actionButton",
      dropdownMenu: "jut__ActionColumn__dropdownMenu",
      menu: "jut__ActionColumn__menu",
      menuItemLabel: "jut__ActionColumn__menuItemLabel",
      editButton: "jut__ActionColumn__editButton",
      actionColumnCell: "jut__ActionColumn__actionColumnCell",
      cancelButton: "jut__ActionColumn__cancelButton",
      focusedButton: "jut__ActionColumn__focusedButton"
    };
  },
  "./columns/FieldColumn.module.scss": function columnsFieldColumnModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      fullWidth: "jut__FieldColumn__fullWidth"
    };
  },
  "./columnsConfig/ColumnEntry.module.scss": function columnsConfigColumnEntryModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__ColumnEntry__themeRoot",
      columnEntry: "jut__ColumnEntry__columnEntry",
      columnEntryCheckbox: "jut__ColumnEntry__columnEntryCheckbox",
      columnEntryLabel: "jut__ColumnEntry__columnEntryLabel"
    };
  },
  "./filterBar/FilterBar.module.scss": function filterBarFilterBarModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      searchBar: "jut__FilterBar__searchBar",
      searchField: "jut__FilterBar__searchField",
      manageFiltersButton: "jut__FilterBar__manageFiltersButton",
      manageFiltersButtonSelected: "jut__FilterBar__manageFiltersButtonSelected",
      titleBar: "jut__FilterBar__titleBar",
      manageFiltersBadge: "jut__FilterBar__manageFiltersBadge",
      filterBar: "jut__FilterBar__filterBar",
      titleDivider: "jut__FilterBar__titleDivider",
      filterTitle: "jut__FilterBar__filterTitle",
      filterItem: "jut__FilterBar__filterItem"
    };
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "createTextFilter", function () {
      return createTextFilter;
    }), __webpack_require__.d(__webpack_exports__, "defaultColumnFilter", function () {
      return defaultColumnFilter;
    }), __webpack_require__.d(__webpack_exports__, "extractAPIFromSchema", function () {
      return extractAPIFromSchema;
    }), __webpack_require__.d(__webpack_exports__, "useDataFilter", function () {
      return useDataFilter;
    }), __webpack_require__.d(__webpack_exports__, "ActionColumn", function () {
      return ActionColumn;
    }), __webpack_require__.d(__webpack_exports__, "FieldColumn", function () {
      return FieldColumn;
    }), __webpack_require__.d(__webpack_exports__, "FilterBar", function () {
      return FilterBar;
    }), __webpack_require__.d(__webpack_exports__, "RadioColumn", function () {
      return RadioColumn;
    }), __webpack_require__.d(__webpack_exports__, "DisplayColumn", function () {
      return DisplayColumn;
    }), __webpack_require__.d(__webpack_exports__, "MoneyColumn", function () {
      return MoneyColumn;
    }), __webpack_require__.d(__webpack_exports__, "ActionItem", function () {
      return ActionItem;
    }), __webpack_require__.d(__webpack_exports__, "DataTable", function () {
      return DataTable;
    }), __webpack_require__.d(__webpack_exports__, "Table", function () {
      return Table;
    }), __webpack_require__.d(__webpack_exports__, "TableColumn", function () {
      return TableColumn;
    }), __webpack_require__.d(__webpack_exports__, "JsonDataTable", function () {
      return JsonDataTable;
    });
    var actions_namespaceObject = {};
    __webpack_require__.r(actions_namespaceObject), __webpack_require__.d(actions_namespaceObject, "collapse", function () {
      return actions_collapse;
    }), __webpack_require__.d(actions_namespaceObject, "toggle", function () {
      return toggle;
    }), __webpack_require__.d(actions_namespaceObject, "collapseAll", function () {
      return actions_collapseAll;
    });
    var selection_actions_namespaceObject = {};
    __webpack_require__.r(selection_actions_namespaceObject), __webpack_require__.d(selection_actions_namespaceObject, "select", function () {
      return actions_select;
    }), __webpack_require__.d(selection_actions_namespaceObject, "toggle", function () {
      return actions_toggle;
    }), __webpack_require__.d(selection_actions_namespaceObject, "setAll", function () {
      return actions_setAll;
    }), __webpack_require__.d(selection_actions_namespaceObject, "clearAll", function () {
      return actions_clearAll;
    });
    var async_actions_namespaceObject = {};
    __webpack_require__.r(async_actions_namespaceObject), __webpack_require__.d(async_actions_namespaceObject, "setAsyncData", function () {
      return actions_setAsyncData;
    }), __webpack_require__.d(async_actions_namespaceObject, "setLoading", function () {
      return actions_setLoading;
    }), __webpack_require__.d(async_actions_namespaceObject, "setAsyncInternalState", function () {
      return actions_setAsyncInternalState;
    });

    var uiconfig_ = __webpack_require__("@jutro/uiconfig"),
        filter_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/filter"),
        filter_default = __webpack_require__.n(filter_),
        extends_ = __webpack_require__("@babel/runtime-corejs3/helpers/extends"),
        extends_default = __webpack_require__.n(extends_),
        objectWithoutProperties = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js"),
        objectWithoutProperties_default = __webpack_require__.n(objectWithoutProperties),
        map_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
        map_default = __webpack_require__.n(map_),
        external_react_ = __webpack_require__("react"),
        external_react_default = __webpack_require__.n(external_react_),
        components_ = __webpack_require__("@jutro/components"),
        router_ = __webpack_require__("@jutro/router"),
        platform_ = __webpack_require__("@jutro/platform"),
        layout_ = __webpack_require__("@jutro/layout"),
        prop_types_ = __webpack_require__("@jutro/prop-types"),
        external_classnames_ = __webpack_require__("classnames"),
        external_classnames_default = __webpack_require__.n(external_classnames_),
        external_prop_types_ = __webpack_require__("prop-types"),
        external_prop_types_default = __webpack_require__.n(external_prop_types_),
        external_lodash_ = __webpack_require__("lodash"),
        external_lodash_default = __webpack_require__.n(external_lodash_),
        uimetadata_ = __webpack_require__("@jutro/uimetadata");

    var TableColumn = function TableColumn() {
      throw new Error("Component <TableColumn /> should never render");
    };

    TableColumn.propTypes = {
      id: external_prop_types_default.a.string,
      header: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.string, external_prop_types_default.a.object]),
      onHeader: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderHeader instead"),
      renderHeader: external_prop_types_default.a.func,
      headerClassName: external_prop_types_default.a.string,
      cell: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.string]),
      onCell: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderCell instead"),
      renderCell: external_prop_types_default.a.func,
      cellClassName: external_prop_types_default.a.string,
      visible: external_prop_types_default.a.bool,
      phone: external_prop_types_default.a.object,
      tablet: external_prop_types_default.a.object,
      textAlign: external_prop_types_default.a.oneOf(["left", "center", "right"]),
      width: external_prop_types_default.a.number,
      columnProportion: external_prop_types_default.a.number,
      sortable: external_prop_types_default.a.bool,
      editCell: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderEditCell instead"),
      onEditCell: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderEditCell instead"),
      renderEditCell: external_prop_types_default.a.func,
      editCellClass: external_prop_types_default.a.string,
      columnClassName: external_prop_types_default.a.string,
      filter: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onFilter instead"),
      onFilter: external_prop_types_default.a.func,
      path: external_prop_types_default.a.string,
      onSort: external_prop_types_default.a.func
    }, TableColumn.defaultProps = {
      columnProportion: 1
    }, TableColumn.displayName = "TableColumn";
    var textAlignMapping = {
      left: "text-left",
      right: "text-right",
      center: "text-center"
    };
    TableColumn.renderHeader = function (props, translator, styles) {
      var headerClassName = props.headerClassName,
          textAlign = props.textAlign,
          id = props.id,
          scope = props.scope;
      if (!1 === props.visible) return null;

      var content = function (props, translator) {
        var header = props.header,
            onHeader = props.onHeader,
            renderHeader = props.renderHeader,
            other = objectWithoutProperties_default()(props, ["header", "onHeader", "renderHeader"]);
        var content = header || onHeader || renderHeader;
        return external_lodash_default.a.isFunction(content) && (other.translator = translator, content = content(other)), translator && (content = translator(content)), content;
      }(props, translator),
          headerClasses = external_classnames_default()(styles && styles.tableHeader, headerClassName, getTextAlignClass(textAlign));

      return external_react_default.a.createElement("th", {
        key: id,
        className: headerClasses,
        scope: scope
      }, content);
    }, TableColumn.renderCell = function (row, index, props, translator, themeStyles) {
      var cellClassName = props.cellClassName,
          textAlign = props.textAlign,
          id = props.id;
      if (!1 === props.visible) return null;

      var content = function (row, index, props, translator, themeStyles) {
        var cell = props.cell,
            onCell = props.onCell,
            renderCell = props.renderCell,
            other = objectWithoutProperties_default()(props, ["cell", "onCell", "renderCell"]);
        var content = cell || onCell || renderCell;
        return external_lodash_default.a.isFunction(content) && (other.translator = translator, content = content(row, index, other, themeStyles)), translator && (content = translator(content)), content;
      }(row, index, props, translator, themeStyles),
          cellClasses = external_classnames_default()(themeStyles && themeStyles.tableCell, getTextAlignClass(textAlign), cellClassName);

      return external_react_default.a.createElement("td", {
        key: id + index,
        className: cellClasses
      }, content);
    };

    var getTextAlignClass = function getTextAlignClass(textAlign) {
      return textAlignMapping[textAlign];
    };

    TableColumn.metadataType = uimetadata_.metadataTypes.CONTAINER, TableColumn.__docgenInfo = {
      componentName: "TableColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "TableColumn",
      methods: [],
      actualName: "TableColumn",
      metadataType: "container",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Identifier"
        },
        header: {
          type: {
            name: "union",
            value: [{
              name: "func"
            }, {
              name: "string"
            }, {
              name: "object"
            }]
          },
          required: !1,
          description: "String or callback(props) to render the column header in the table"
        },
        onHeader: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Callback(props) to render the column header in the table",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderHeader: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback(props) to render the column header in the table"
        },
        headerClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Classname for header <th>"
        },
        cell: {
          type: {
            name: "union",
            value: [{
              name: "func"
            }, {
              name: "string"
            }]
          },
          required: !1,
          description: "String or callback(row, index, props) to render the column cell for a row in the table"
        },
        onCell: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Callback(row, index, props) to render the column cell for a row in the table",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderCell: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback(row, index, props) to render the column cell for a row in the table"
        },
        cellClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional classname for cell (in order to use it in DataTable, specificity of the selector should be higher than 5 classnames)"
        },
        visible: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Is this column shown in the table"
        },
        phone: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include any TableColumn property for use at 'phone' breakpoint"
        },
        tablet: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include any TableColumn property for use at 'tablet' and 'phone' breakpoint"
        },
        textAlign: {
          type: {
            name: "enum",
            value: [{
              value: "'left'",
              computed: !1
            }, {
              value: "'center'",
              computed: !1
            }, {
              value: "'right'",
              computed: !1
            }]
          },
          required: !1,
          description: "Text-align css property value (default 'center')"
        },
        width: {
          type: {
            name: "number"
          },
          required: !1,
          description: "The width of current column, when `undefined` columns will share the table accordingly to columns columnProportion prop"
        },
        columnProportion: {
          type: {
            name: "number"
          },
          required: !1,
          description: "Proportion of the column. Doesn't work when width is defined",
          defaultValue: {
            value: "1",
            computed: !1
          }
        },
        sortable: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "To specify if the column is sortable, when `undefined` the column is sortable"
        },
        editCell: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Callback(row, index, props) to render the column cell for a row in the table in the edit mode",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onEditCell: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Callback(row, index, props) to render the column cell for a row in the table in the edit mode",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderEditCell: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback(row, index, props) to render the column cell for a row in the table in the edit mode"
        },
        editCellClass: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Custom classname for column cell in the edit mode"
        },
        columnClassName: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Classname for column"
        },
        filter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Column filter function",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onFilter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Column filter function"
        },
        path: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The full path of view model, it also acts as an accessor for row's data"
        },
        onSort: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to be invoked on column sort click"
        }
      }
    };

    var ActionItem = function ActionItem() {
      throw new Error("Component <ActionItem /> should never render");
    };

    ActionItem.propTypes = {
      icon: external_prop_types_default.a.string,
      onClick: external_prop_types_default.a.func,
      label: external_prop_types_default.a.string,
      isEditTrigger: external_prop_types_default.a.bool,
      triggerOnRowClick: external_prop_types_default.a.bool,
      singleActionType: external_prop_types_default.a.oneOf(["icon", "link"])
    }, ActionItem.displayName = "ActionItem", ActionItem.__docgenInfo = {
      componentName: "ActionItem",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "ActionItem",
      methods: [],
      actualName: "ActionItem",
      metadataType: "action",
      props: {
        icon: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The short-name (without the preceding `fa-`) of the optional Font Awesome icon"
        },
        onClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Action for click event - ignored if `isEditTrigger` enabled"
        },
        label: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Label for action"
        },
        isEditTrigger: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Determines if action triggers edit mode for row"
        },
        triggerOnRowClick: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Determines if row click should trigger action"
        },
        singleActionType: {
          type: {
            name: "enum",
            value: [{
              value: "'icon'",
              computed: !1
            }, {
              value: "'link'",
              computed: !1
            }]
          },
          required: !1,
          description: "If action is single - determines it should be displayed as icon or link"
        }
      }
    };

    var ActionColumn_module = __webpack_require__("./columns/ActionColumn.module.scss"),
        ActionColumn_module_default = __webpack_require__.n(ActionColumn_module),
        DataTable_module = __webpack_require__("./DataTable.module.scss"),
        DataTable_module_default = __webpack_require__.n(DataTable_module);

    var ActionColumn = function ActionColumn() {
      throw new Error("Component <ActionColumn /> should never render");
    };

    function renderOneAction(actionProps, row, rowId, onEditStart) {
      var icon = actionProps.icon,
          onClick = actionProps.onClick,
          label = (actionProps.className, actionProps.label),
          isEditTrigger = actionProps.isEditTrigger,
          singleActionType = actionProps.singleActionType,
          other = objectWithoutProperties_default()(actionProps, ["icon", "onClick", "className", "label", "isEditTrigger", "singleActionType"]),
          handleOnClick = isEditTrigger ? onEditStart : onClick,
          onClickHandler = function onClickHandler() {
        return handleOnClick(row, rowId);
      };

      return "icon" === singleActionType && icon ? renderActionButton(actionProps, row, rowId, 0, onEditStart) : "link" === singleActionType ? external_react_default.a.createElement(components_.Link, extends_default()({
        icon: icon,
        onClick: onClickHandler
      }, other), label) : external_react_default.a.createElement(components_.Button, extends_default()({
        onClick: onClickHandler,
        size: "small",
        icon: icon
      }, other), label);
    }

    function renderActionButton(_ref5, row, rowId) {
      var icon = _ref5.icon,
          onClick = _ref5.onClick,
          className = _ref5.className,
          isEditTrigger = _ref5.isEditTrigger,
          isOpen = _ref5.isOpen,
          label = _ref5.label;
      var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : rowId;
      var onEditStart = arguments.length > 4 ? arguments[4] : undefined;
      var classes = external_classnames_default()(className, ActionColumn_module_default.a.actionButton, _defineProperty({}, ActionColumn_module_default.a.focusedButton, isOpen)),
          handleOnClick = isEditTrigger ? onEditStart : onClick;
      return external_react_default.a.createElement(components_.Button, {
        key: "" + key,
        className: classes,
        onClick: function onClick() {
          return handleOnClick(row, rowId);
        },
        size: "small",
        type: "tertiary",
        icon: icon,
        "aria-label": (null == label ? void 0 : label.toLowerCase()) || icon,
        "aria-expanded": isOpen
      }, label);
    }

    function renderActionMenu(actionsProps, row, rowId, onEditStart) {
      var menuId = Object(platform_.uniqueInnerId)("" + rowId, "menuId").menuId;
      return external_react_default.a.createElement(router_.DropdownMenu, {
        id: menuId,
        onRenderTrigger: function onRenderTrigger(props, toggleMenu) {
          var isOpen = props.isOpen;
          props.menuId;
          return renderActionButton(_objectSpread({}, objectWithoutProperties_default()(props, ["isOpen", "menuId"]), {
            icon: "mi-more-horiz",
            onClick: function onClick() {
              return toggleMenu(!isOpen);
            },
            isOpen: isOpen
          }), row, rowId);
        },
        className: ActionColumn_module_default.a.dropdownMenu,
        menuClassName: ActionColumn_module_default.a.menu,
        alignRight: !0
      }, map_default()(actionsProps).call(actionsProps, function (props, linkIndex) {
        var label = props.label,
            icon = props.icon,
            onClick = props.onClick,
            isEditTrigger = props.isEditTrigger,
            id = (props.singleActionType, props.id),
            rest = objectWithoutProperties_default()(props, ["label", "icon", "onClick", "isEditTrigger", "singleActionType", "id"]),
            handleOnClick = isEditTrigger ? onEditStart : onClick,
            iconComponent = icon && external_react_default.a.createElement(components_.Icon, {
          icon: icon,
          isFixedWidth: !0
        });
        return external_react_default.a.createElement(router_.DropdownMenuLink, extends_default()({
          id: "".concat(menuId, "__").concat(id || rowId),
          key: "" + linkIndex,
          onClick: function onClick() {
            return handleOnClick(row, rowId);
          }
        }, rest), external_react_default.a.createElement(components_.InlineLabel, {
          tag: "div",
          icon: iconComponent
        }, external_react_default.a.createElement("span", {
          className: ActionColumn_module_default.a.menuItemLabel
        }, label)));
      }));
    }

    function getBreakpointProps(children, breakpoint) {
      var _context, _context2;

      return map_default()(_context = filter_default()(_context2 = external_react_.Children.toArray(children)).call(_context2, Boolean)).call(_context, function (_ref6) {
        var props = _ref6.props;
        return layout_.BreakpointTracker.applyBreakpointOverrides(props, breakpoint);
      });
    }

    ActionColumn.propTypes = _objectSpread({}, TableColumn.propTypes, {
      children: prop_types_.ComponentPropTypes.childOfComponentType(ActionItem)
    }), ActionColumn.getRowActions = function (_ref7) {
      var row = _ref7.row,
          rowId = _ref7.rowId,
          props = _ref7.props,
          onEditStart = _ref7.onEditStart;
      var actionsProps = getBreakpointProps(props.children, props.breakpoint);
      return map_default()(actionsProps).call(actionsProps, function (_ref8) {
        var onClick = _ref8.onClick,
            triggerOnRowClick = _ref8.triggerOnRowClick,
            isEditTrigger = _ref8.isEditTrigger;
        if (triggerOnRowClick) return isEditTrigger ? function () {
          return onEditStart(row, rowId);
        } : function () {
          return onClick(row, rowId);
        };
      });
    }, ActionColumn.defaultCell = function (row, rowId, props, onEditStart) {
      var children = props.children,
          visible = props.visible,
          disableActions = props.disableActions,
          breakpoint = props.breakpoint;
      if (!1 === visible || disableActions || !children) return null;
      var actionsProps = getBreakpointProps(children, breakpoint),
          numberOfActions = actionsProps.length;
      return 1 === numberOfActions ? renderOneAction(actionsProps[0], row, rowId, onEditStart) : numberOfActions > 2 ? renderActionMenu(actionsProps, row, rowId, onEditStart) : map_default()(actionsProps).call(actionsProps, function (buttonProps, buttonIndex) {
        return renderActionButton(buttonProps, row, rowId, buttonIndex, onEditStart);
      });
    }, ActionColumn.editCell = function (_ref9) {
      var editActions = _ref9.editActions;
      var save = editActions.save,
          cancel = editActions.cancel,
          classes = external_classnames_default()(ActionColumn_module_default.a.actionButton, ActionColumn_module_default.a.editButton),
          cancelClasses = external_classnames_default()(classes, ActionColumn_module_default.a.cancelButton);
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement(components_.Button, {
        className: classes,
        onClick: save,
        size: "small",
        icon: "mi-check"
      }), external_react_default.a.createElement(components_.Button, {
        className: cancelClasses,
        onClick: cancel,
        size: "small",
        type: "tertiary",
        icon: "mi-close"
      }));
    }, ActionColumn.displayName = "ActionColumn", ActionColumn.defaultProps = {
      renderCell: ActionColumn.defaultCell,
      renderEditCell: ActionColumn.editCell,
      getRowActions: ActionColumn.getRowActions,
      columnClassName: DataTable_module_default.a.actionColumn,
      cellClassName: ActionColumn_module_default.a.actionColumnCell,
      width: 120,
      sortable: !1,
      textAlign: "right",
      onFilter: function onFilter() {
        return function () {
          return !1;
        };
      }
    }, ActionColumn.__docgenInfo = {
      componentName: "ActionColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "ActionColumn",
      methods: [],
      actualName: "ActionColumn",
      metadataType: "container",
      props: {
        children: {
          type: {
            name: "custom",
            raw: "ComponentPropTypes.childOfComponentType(ActionItem)"
          },
          required: !1,
          description: "List of ActionItems"
        },
        renderCell: {
          defaultValue: {
            value: "ActionColumn.defaultCell",
            computed: !0
          },
          required: !1
        },
        renderEditCell: {
          defaultValue: {
            value: "ActionColumn.editCell",
            computed: !0
          },
          required: !1
        },
        getRowActions: {
          defaultValue: {
            value: "ActionColumn.getRowActions",
            computed: !0
          },
          required: !1
        },
        columnClassName: {
          defaultValue: {
            value: "tableStyles.actionColumn",
            computed: !0
          },
          required: !1
        },
        cellClassName: {
          defaultValue: {
            value: "styles.actionColumnCell",
            computed: !0
          },
          required: !1
        },
        width: {
          defaultValue: {
            value: "120",
            computed: !1
          },
          required: !1
        },
        sortable: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          required: !1
        },
        textAlign: {
          defaultValue: {
            value: "'right'",
            computed: !1
          },
          required: !1
        },
        onFilter: {
          defaultValue: {
            value: "() => () => false",
            computed: !1
          },
          required: !1
        }
      },
      composes: ["../table/TableColumn"]
    }, renderOneAction.__docgenInfo = {
      componentName: "renderOneAction",
      packageName: "@jutro/datatable",
      description: "Render the button with action defined on onclick listener",
      displayName: "renderOneAction",
      methods: [],
      actualName: "renderOneAction"
    }, renderActionButton.__docgenInfo = {
      componentName: "renderActionButton",
      packageName: "@jutro/datatable",
      description: "Render the button with action defined on onclick listener",
      displayName: "renderActionButton",
      methods: [],
      actualName: "renderActionButton"
    }, renderActionMenu.__docgenInfo = {
      componentName: "renderActionMenu",
      packageName: "@jutro/datatable",
      description: "Render ellipsis with dropdown menu of actions",
      displayName: "renderActionMenu",
      methods: [],
      actualName: "renderActionMenu"
    };

    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
        keys_default = __webpack_require__.n(keys_),
        get_ = __webpack_require__("lodash/get"),
        get_default = __webpack_require__.n(get_),
        find_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find"),
        find_default = __webpack_require__.n(find_),
        locale_ = __webpack_require__("@jutro/locale"),
        includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
        includes_default = __webpack_require__.n(includes_),
        some_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/some"),
        some_default = __webpack_require__.n(some_),
        trim_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/trim"),
        trim_default = __webpack_require__.n(trim_),
        stubTrue = __webpack_require__("../../node_modules/lodash/stubTrue.js"),
        stubTrue_default = __webpack_require__.n(stubTrue);

    var createTextFilter = function createTextFilter(filterValue) {
      var _context;

      var words = filter_default()(_context = trim_default()(filterValue).call(filterValue).toLowerCase().split(" ")).call(_context, Boolean);
      return words.length ? function (text) {
        var lowerText = text.toString().toLowerCase();
        return some_default()(words).call(words, function (word) {
          return includes_default()(lowerText).call(lowerText, word);
        });
      } : stubTrue_default.a;
    },
        defaultColumnFilter = function defaultColumnFilter(filterValue, _ref10) {
      var path = _ref10.path;
      var textFilter = createTextFilter(filterValue);
      return function (item) {
        return textFilter(get_default()(item, path, ""));
      };
    };

    var FieldColumn_module = __webpack_require__("./columns/FieldColumn.module.scss"),
        FieldColumn_module_default = __webpack_require__.n(FieldColumn_module);

    var FieldColumn = function FieldColumn() {
      throw new Error("Component <FieldColumn /> should never render");
    };

    FieldColumn.propTypes = _objectSpread({}, TableColumn.propTypes, {
      model: external_prop_types_default.a.object,
      basePath: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.string]),
      uiMetadata: external_prop_types_default.a.object,
      pageProps: external_prop_types_default.a.object,
      readOnly: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.bool]),
      onAccessor: external_prop_types_default.a.func
    });

    var DefaultCell = function DefaultCell(_ref11) {
      var row = _ref11.row,
          rowId = _ref11.rowId,
          innerProps = _ref11.innerProps;
      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          path = innerProps.path,
          visible = innerProps.visible,
          fieldDatatype = innerProps.fieldDatatype,
          id = innerProps.id,
          availableValues = innerProps.availableValues;
      if (!1 === visible) return null;
      var selectedValue = get_default()(row, path).toString(),
          selectOption = find_default()(availableValues).call(availableValues, function (el) {
        return (null !== (_option$code = null == (option = el) ? void 0 : option.code) && void 0 !== _option$code ? _option$code : option.id) === selectedValue;

        var option, _option$code;
      }),
          value = selectOption ? null !== (_option$name = null == (option = selectOption) ? void 0 : option.name) && void 0 !== _option$name ? _option$name : option.displayName : "-";

      var option, _option$name;

      return external_react_default.a.createElement(components_.FieldValue, {
        id: "".concat(id, "_").concat(rowId),
        datatype: fieldDatatype,
        value: translator(value)
      });
    };

    FieldColumn.defaultCell = function (row, rowId, props) {
      return external_react_default.a.createElement(DefaultCell, {
        row: row,
        rowId: rowId,
        innerProps: props
      });
    }, FieldColumn.editCell = function (_ref12) {
      var props = _ref12.props,
          editProps = _ref12.editProps,
          editActions = _ref12.editActions;
      var id = props.id,
          basePath = props.basePath,
          path = props.path,
          visible = props.visible,
          datatype = (props.fieldType, props.fieldDatatype),
          component = props.fieldComponent,
          rest = objectWithoutProperties_default()(props, ["id", "basePath", "path", "visible", "fieldType", "fieldDatatype", "fieldComponent"]),
          row = editProps.row,
          rowId = editProps.rowId,
          index = editProps.index,
          update = editActions.update;
      if (!1 === visible) return null;
      var results = Object(uiconfig_.prepareComponentFromMetadata)({
        type: "field",
        datatype: datatype,
        component: component,
        componentProps: _objectSpread({}, rest, {
          id: "".concat(id, "_").concat(rowId),
          hideLabel: !0,
          className: FieldColumn_module_default.a.fullWidth,
          value: get_default()(row, props.path),
          path: basePath ? "".concat(basePath, ".").concat(index, ".").concat(path) : path,
          onValueChange: function onValueChange(newValue) {
            return update(row, path, newValue);
          }
        })
      });
      return Object(uiconfig_.renderComponentFromMetadata)(results);
    }, FieldColumn.editCellClass = DataTable_module_default.a.editedCell, FieldColumn.displayName = "FieldColumn", FieldColumn.defaultProps = {
      renderCell: FieldColumn.defaultCell,
      renderEditCell: FieldColumn.editCell,
      cellClassName: FieldColumn.editCellClass,
      onFilter: defaultColumnFilter,
      columnProportion: 1
    }, FieldColumn.__docgenInfo = {
      componentName: "FieldColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "FieldColumn",
      methods: [],
      actualName: "FieldColumn",
      metadataType: "container",
      props: {
        model: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        basePath: {
          type: {
            name: "union",
            value: [{
              name: "func"
            }, {
              name: "string"
            }]
          },
          required: !1,
          description: ""
        },
        uiMetadata: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        pageProps: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        readOnly: {
          type: {
            name: "union",
            value: [{
              name: "func"
            }, {
              name: "bool"
            }]
          },
          required: !1,
          description: ""
        },
        onAccessor: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Returns a value that will be used by the column to access the correct data of each row"
        },
        renderCell: {
          defaultValue: {
            value: "FieldColumn.defaultCell",
            computed: !0
          },
          required: !1
        },
        renderEditCell: {
          defaultValue: {
            value: "FieldColumn.editCell",
            computed: !0
          },
          required: !1
        },
        cellClassName: {
          defaultValue: {
            value: "FieldColumn.editCellClass",
            computed: !0
          },
          required: !1
        },
        onFilter: {
          defaultValue: {
            value: "defaultColumnFilter",
            computed: !0
          },
          required: !1
        },
        columnProportion: {
          defaultValue: {
            value: "1",
            computed: !1
          },
          required: !1
        }
      },
      composes: ["../table/TableColumn"]
    }, DefaultCell.__docgenInfo = {
      componentName: "DefaultCell",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "DefaultCell",
      methods: [],
      actualName: "DefaultCell"
    };

    var DisplayColumn = function DisplayColumn() {
      throw new Error("Component <DisplayColumn /> should never render");
    };

    DisplayColumn.propTypes = _objectSpread({}, TableColumn.propTypes, {
      fieldDatatype: external_prop_types_default.a.oneOf(keys_default()(uiconfig_.simpleDatatypeComponentMap)),
      onAccessor: external_prop_types_default.a.func
    }), DisplayColumn.defaultCell = function (row, rowId, _ref13) {
      var fieldDatatype = _ref13.fieldDatatype,
          path = _ref13.path,
          visible = _ref13.visible,
          id = _ref13.id;
      return !1 === visible ? null : external_react_default.a.createElement(components_.FieldValue, {
        id: "".concat(id, "_").concat(rowId),
        datatype: fieldDatatype,
        value: get_default()(row, path)
      });
    }, DisplayColumn.editCell = function (props) {
      return FieldColumn.editCell(props);
    }, DisplayColumn.editCellClass = DataTable_module_default.a.editedCell, DisplayColumn.displayName = "DisplayColumn", DisplayColumn.defaultProps = {
      renderCell: DisplayColumn.defaultCell,
      renderEditCell: DisplayColumn.editCell,
      editCellClass: DisplayColumn.editCellClass,
      onFilter: defaultColumnFilter,
      columnProportion: 1,
      fieldDatatype: "string"
    }, DisplayColumn.__docgenInfo = {
      componentName: "DisplayColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "DisplayColumn",
      methods: [],
      actualName: "DisplayColumn",
      metadataType: "container",
      props: {
        fieldDatatype: {
          type: {
            name: "enum",
            computed: !0,
            value: "Object.keys(simpleDatatypeComponentMap)"
          },
          required: !1,
          description: "",
          defaultValue: {
            value: "'string'",
            computed: !1
          }
        },
        onAccessor: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Returns a value that will be used by the column to access the correct data of each row"
        },
        renderCell: {
          defaultValue: {
            value: "DisplayColumn.defaultCell",
            computed: !0
          },
          required: !1
        },
        renderEditCell: {
          defaultValue: {
            value: "DisplayColumn.editCell",
            computed: !0
          },
          required: !1
        },
        editCellClass: {
          defaultValue: {
            value: "DisplayColumn.editCellClass",
            computed: !0
          },
          required: !1
        },
        onFilter: {
          defaultValue: {
            value: "defaultColumnFilter",
            computed: !0
          },
          required: !1
        },
        columnProportion: {
          defaultValue: {
            value: "1",
            computed: !1
          },
          required: !1
        }
      },
      composes: ["../table/TableColumn"]
    };

    var MoneyColumn = function MoneyColumn() {
      throw new Error("Component <MoneyColumn /> should never render");
    };

    MoneyColumn.propTypes = _objectSpread({}, TableColumn.propTypes, {
      onAccessor: external_prop_types_default.a.func
    }), MoneyColumn.defaultCell = function (row, rowId, _ref14) {
      var path = _ref14.path,
          visible = _ref14.visible;
      if (!1 === visible) return null;
      var value = get_default()(row, path);
      return external_react_default.a.createElement(components_.Money, {
        amount: value
      });
    }, MoneyColumn.editCell = function (_ref15) {
      var props = _ref15.props,
          editProps = _ref15.editProps,
          editActions = _ref15.editActions;
      var path = props.path,
          id = props.id,
          row = editProps.row,
          rowId = editProps.rowId,
          update = editActions.update,
          editedValue = row[path];
      return external_react_default.a.createElement(components_.CurrencyField, {
        id: "".concat(id, "_").concat(rowId),
        size: "small",
        value: {
          amount: editedValue
        },
        onValueChange: function onValueChange(newValue) {
          update(row, path, newValue.amount);
        }
      });
    }, MoneyColumn.displayName = "MoneyColumn", MoneyColumn.defaultProps = {
      renderCell: MoneyColumn.defaultCell,
      renderEditCell: MoneyColumn.editCell,
      onFilter: function onFilter(filterValue, _ref16) {
        var path = _ref16.path;
        var intl = Object(external_react_.useContext)(locale_.IntlContext),
            textFilter = createTextFilter(filterValue);
        return function (item) {
          var value = get_default()(item, path, "");
          if (textFilter(value)) return !0;
          var formattedValue = intl.formatNumber(value);
          return textFilter(formattedValue);
        };
      },
      columnProportion: 1
    }, MoneyColumn.__docgenInfo = {
      componentName: "MoneyColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "MoneyColumn",
      methods: [],
      actualName: "MoneyColumn",
      metadataType: "container",
      props: {
        onAccessor: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Returns a value that will be used by the column to access the correct data of each row"
        },
        renderCell: {
          defaultValue: {
            value: "MoneyColumn.defaultCell",
            computed: !0
          },
          required: !1
        },
        renderEditCell: {
          defaultValue: {
            value: "MoneyColumn.editCell",
            computed: !0
          },
          required: !1
        },
        onFilter: {
          defaultValue: {
            value: "(filterValue, { path }) => {\n    // Fix: find another way to access locale here\n    // currently we assume this method is only called from component render function\n    const intl = useContext(IntlContext); // eslint-disable-line react-hooks/rules-of-hooks\n    const textFilter = createTextFilter(filterValue);\n\n    return item => {\n        const value = get(item, path, '');\n\n        if (textFilter(value)) {\n            return true;\n        }\n\n        const formattedValue = intl.formatNumber(value);\n\n        return textFilter(formattedValue);\n    };\n}",
            computed: !1
          },
          required: !1
        },
        columnProportion: {
          defaultValue: {
            value: "1",
            computed: !1
          },
          required: !1
        }
      },
      composes: ["../table/TableColumn"]
    };

    var RadioColumn = function RadioColumn() {
      throw new Error("Component <RadioColumn /> should never render");
    };

    function renderRadioButton(props) {
      var rowOption = props.rowOption,
          value = props.value,
          onValueChange = props.onValueChange,
          otherProps = props.otherProps,
          themeStyles = props.themeStyles,
          id = otherProps.id,
          rowId = otherProps.rowId,
          rest = objectWithoutProperties_default()(otherProps, ["id", "rowId"]);
      return external_react_default.a.createElement(components_.RadioButton, extends_default()({
        id: "".concat(id, "_").concat(rowId),
        className: null == themeStyles ? void 0 : themeStyles.radio,
        key: rowOption.code,
        option: rowOption,
        value: value,
        onValueChange: onValueChange
      }, rest));
    }

    RadioColumn.propTypes = _objectSpread({}, TableColumn.propTypes, {
      option: external_prop_types_default.a.oneOfType([external_prop_types_default.a.shape({
        name: external_prop_types_default.a.string,
        code: external_prop_types_default.a.string
      }), external_prop_types_default.a.func]),
      onOption: external_prop_types_default.a.func,
      onAccessor: external_prop_types_default.a.func
    }), RadioColumn.getRowActions = function (_ref17) {
      var selectOnRowClick = _ref17.selectOnRowClick;
      if (selectOnRowClick) return function (event) {
        return RadioColumn.onRowClick(event);
      };
    }, RadioColumn.onRowClick = function (evt) {
      var currentRow = evt.currentTarget,
          currentRadioInput = currentRow.querySelector('input[type="radio"]');

      if (currentRadioInput) {
        evt.preventDefault(), currentRadioInput.click();
        var currentRadioLabel = currentRow.querySelector("label[for=\"".concat(currentRadioInput.id, "\"]"));
        currentRadioLabel && currentRadioLabel.focus();
      }
    }, RadioColumn.defaultCell = function (row, rowId, props, themeStyles) {
      props.header, props.onHeader, props.renderHeader, props.cell, props.onCell, props.renderCell, props.className;
      var visible = props.visible,
          option = props.option,
          onOption = props.onOption,
          value = props.value,
          onValueChange = (props.translator, props.onValueChange),
          other = (props.columnProportion, filter_default()(props), props.onFilter, props.basePath, objectWithoutProperties_default()(props, ["header", "onHeader", "renderHeader", "cell", "onCell", "renderCell", "className", "visible", "option", "onOption", "value", "translator", "onValueChange", "columnProportion", "filter", "onFilter", "basePath"]));
      if (!1 === visible) return null;
      var rowOption = option || onOption;
      return external_lodash_default.a.isFunction(rowOption) ? rowOption = rowOption(row, rowId, props) : !rowOption && row && (rowOption = {
        code: row.code,
        name: row.name || row.code
      }), rowOption ? renderRadioButton({
        rowOption: rowOption,
        value: value,
        onValueChange: onValueChange,
        otherProps: _objectSpread({}, other, {
          rowId: rowId
        }),
        themeStyles: themeStyles
      }) : null;
    }, RadioColumn.displayName = "RadioColumn", RadioColumn.defaultProps = {
      renderCell: RadioColumn.defaultCell,
      getRowActions: RadioColumn.getRowActions,
      onFilter: function onFilter(filterValue) {
        var textFilter = createTextFilter(filterValue);
        return function (_ref18) {
          var name = _ref18.name;
          return textFilter(name);
        };
      },
      columnProportion: 1
    }, RadioColumn.__docgenInfo = {
      componentName: "RadioColumn",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "RadioColumn",
      methods: [],
      actualName: "RadioColumn",
      metadataType: "container",
      props: {
        option: {
          type: {
            name: "union",
            value: [{
              name: "shape",
              value: {
                name: {
                  name: "string",
                  required: !1
                },
                code: {
                  name: "string",
                  required: !1
                }
              }
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: "The option to be displayed in cell"
        },
        onOption: {
          type: {
            name: "func"
          },
          required: !1,
          description: "The option to be displayed in cell"
        },
        onAccessor: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Returns a value that will be used by the column to access the correct data of each row"
        },
        renderCell: {
          defaultValue: {
            value: "RadioColumn.defaultCell",
            computed: !0
          },
          required: !1
        },
        getRowActions: {
          defaultValue: {
            value: "RadioColumn.getRowActions",
            computed: !0
          },
          required: !1
        },
        onFilter: {
          defaultValue: {
            value: "filterValue => {\n    const textFilter = createTextFilter(filterValue);\n\n    return ({ name }) => textFilter(name);\n}",
            computed: !1
          },
          required: !1
        },
        columnProportion: {
          defaultValue: {
            value: "1",
            computed: !1
          },
          required: !1
        }
      },
      composes: ["../table/TableColumn"]
    }, renderRadioButton.__docgenInfo = {
      componentName: "renderRadioButton",
      packageName: "@jutro/datatable",
      description: "Render the button with action defined on onclick listener",
      displayName: "renderRadioButton",
      methods: [],
      actualName: "renderRadioButton"
    };

    __webpack_require__("core-js/modules/web.dom-collections.iterator");

    var for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        concat_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/concat"),
        concat_default = __webpack_require__.n(concat_),
        slice_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/slice"),
        slice_default = __webpack_require__.n(slice_),
        sort_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/sort"),
        sort_default = __webpack_require__.n(sort_),
        slicedToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js"),
        slicedToArray_default = __webpack_require__.n(slicedToArray),
        find_index_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find-index"),
        find_index_default = __webpack_require__.n(find_index_),
        external_react_table_ = __webpack_require__("react-table"),
        external_react_table_default = __webpack_require__.n(external_react_table_),
        external_react_transition_group_ = __webpack_require__("react-transition-group"),
        logger_ = __webpack_require__("@jutro/logger"),
        range_ = __webpack_require__("lodash/range"),
        range_default = __webpack_require__.n(range_);

    var external_react_intl_ = __webpack_require__("react-intl");

    var messages = Object(external_react_intl_.defineMessages)({
      showAll: {
        id: "jutro-datatable.Pagination.ShowAll",
        defaultMessage: "Show All"
      },
      previous: {
        id: "jutro-datatable.Pagination.Previous",
        defaultMessage: "Prev"
      },
      next: {
        id: "jutro-datatable.Pagination.Next",
        defaultMessage: "Next"
      },
      resultOf: {
        id: "jutro-datatable.Pagination.`Result of`",
        defaultMessage: "Results of"
      }
    });

    var Pagination_module = __webpack_require__("./Pagination/Pagination.module.scss"),
        Pagination_module_default = __webpack_require__.n(Pagination_module);

    var PaginationSelect = function PaginationSelect(_ref19) {
      var availableValues = _ref19.availableValues,
          displayValue = _ref19.displayValue,
          id = _ref19.id,
          isOpen = _ref19.isOpen,
          onValueChange = _ref19.onValueChange,
          value = _ref19.value;

      var handleClick = function handleClick(evt) {
        evt.preventDefault();
        var menuCode = evt.currentTarget.dataset.code;
        onValueChange(menuCode);
      },
          options = map_default()(availableValues).call(availableValues, function (_ref20) {
        var code = _ref20.code,
            name = _ref20.name;
        return external_react_default.a.createElement(router_.DropdownMenuLink, {
          key: code,
          value: code,
          onClick: handleClick,
          className: Pagination_module_default.a.paginationMenuItem,
          "data-code": code
        }, name);
      });

      return external_react_default.a.createElement(router_.DropdownMenu, {
        id: "paginationSelectDropdownMenu-" + id,
        isOpen: isOpen,
        onRenderTrigger: function onRenderTrigger(props, toggleMenu) {
          var _context;

          var paginationId = props.id,
              paginationSelectButtonId = Object(platform_.uniqueInnerId)(paginationId, "paginationSelectButtonId").paginationSelectButtonId;
          return external_react_default.a.createElement(components_.Button, {
            id: paginationSelectButtonId + "_paginationSelectButton",
            size: "xsmall",
            type: "tertiary",
            onClick: function onClick() {
              return toggleMenu();
            },
            icon: displayValue ? void 0 : "mi-expand-more",
            iconPosition: "right",
            className: Pagination_module_default.a.paginationSelect,
            "aria-expanded": props.isOpen
          }, displayValue || map_default()(_context = filter_default()(availableValues).call(availableValues, function (_ref21) {
            var code = _ref21.code;
            return code === value;
          })).call(_context, function (o) {
            return o.name.defaultMessage || o.name;
          }));
        },
        menuClassName: Pagination_module_default.a.paginationMenu
      }, options);
    };

    PaginationSelect.propTypes = {
      id: external_prop_types_default.a.string,
      availableValues: external_prop_types_default.a.array.isRequired,
      onValueChange: external_prop_types_default.a.func,
      isOpen: external_prop_types_default.a.bool,
      displayValue: external_prop_types_default.a.string
    }, PaginationSelect.defaultProps = {
      isOpen: !1
    }, PaginationSelect.__docgenInfo = {
      componentName: "PaginationSelect",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "PaginationSelect",
      methods: [],
      actualName: "PaginationSelect",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Used to identify the component"
        },
        availableValues: {
          type: {
            name: "array"
          },
          required: !0,
          description: "Array of choice objects to display; choice objects contains 'code' and 'name'"
        },
        onValueChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback used to handle selection change"
        },
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "The prop that indicates if the paginatin select menu is currently visible",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        displayValue: {
          type: {
            name: "string"
          },
          required: !1,
          description: "If set, replaces text on select triggering button"
        }
      }
    };

    var NavButton = function NavButton(_ref22) {
      var onClick = _ref22.onClick,
          icon = _ref22.icon,
          iconPosition = _ref22.iconPosition,
          children = _ref22.children,
          className = _ref22.className;
      return external_react_default.a.createElement(components_.Button, {
        className: external_classnames_default()(Pagination_module_default.a.paginationNavButton, className),
        icon: icon,
        iconPosition: iconPosition,
        size: "xsmall",
        type: "tertiary",
        onClick: onClick
      }, children);
    },
        Pagination = function Pagination(_ref23) {
      var id = _ref23.id,
          page = _ref23.page,
          numberOfRows = _ref23.numberOfRows,
          pageSize = _ref23.pageSize,
          onPageChange = _ref23.onPageChange,
          pageSizeSelectedOption = _ref23.pageSizeSelectedOption,
          pageSizeOptions = _ref23.pageSizeOptions,
          onSelectPageSizeChange = _ref23.onSelectPageSizeChange,
          canNext = _ref23.canNext,
          canPrevious = _ref23.canPrevious;
      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          totalPages = Object(external_react_.useMemo)(function () {
        return function (pageSize, totalRows) {
          return Math.ceil(totalRows / pageSize);
        }(pageSize, numberOfRows);
      }, [pageSize, numberOfRows]),
          transformedPageSizeOptions = Object(external_react_.useMemo)(function () {
        return [].concat(_toConsumableArray(map_default()(pageSizeOptions).call(pageSizeOptions, function (option) {
          return {
            code: option,
            name: option
          };
        })), [{
          code: "All",
          name: translator(messages.showAll)
        }]);
      }, [pageSizeOptions, translator]),
          handleChangePage = Object(external_react_.useCallback)(function (newPage) {
        newPage !== page && onPageChange(newPage);
      }, [onPageChange, page]),
          prevNavButton = canPrevious && external_react_default.a.createElement(NavButton, {
        onClick: function onClick() {
          return handleChangePage(page - 1);
        },
        icon: "mi-chevron-left",
        iconPosition: "left"
      }, messages.previous),
          nextNavButton = canNext && external_react_default.a.createElement(NavButton, {
        onClick: function onClick() {
          return handleChangePage(page + 1);
        },
        icon: "mi-chevron-right",
        iconPosition: "right"
      }, messages.next),
          renderPageButton = Object(external_react_.useCallback)(function (visiblePage, index, visiblePages) {
        var displayDots = index !== visiblePages.length - 1 && visiblePages[index + 1] - visiblePage != 1,
            availableValues = [];
        if (displayDots) for (var i = visiblePages[index]; i < visiblePages[index + 1] - 1; i++) {
          availableValues.push({
            code: i,
            name: i + 1
          });
        }
        var paginationSelectId = Object(platform_.uniqueInnerId)(id, "paginationSelectId").paginationSelectId;
        return external_react_default.a.createElement(external_react_default.a.Fragment, {
          key: visiblePage
        }, external_react_default.a.createElement(NavButton, {
          onClick: function onClick() {
            return handleChangePage(visiblePage - 1);
          },
          className: _defineProperty({}, Pagination_module_default.a.selectedPageButton, page === visiblePage - 1)
        }, visiblePage), displayDots && external_react_default.a.createElement(PaginationSelect, {
          id: "".concat(paginationSelectId, "_pageNumberSelect-").concat(visiblePage + 1),
          onValueChange: function onValueChange(target) {
            return handleChangePage(Number(target));
          },
          availableValues: availableValues,
          displayValue: "..."
        }));
      }, [handleChangePage, page, id]),
          visiblePagesButtons = Object(external_react_.useMemo)(function () {
        var visiblePages = function (page, totalPages) {
          var currentPage = page + 1;
          return totalPages <= 7 ? range_default()(1, totalPages + 1) : currentPage < 5 ? [].concat(_toConsumableArray(range_default()(1, 6)), [totalPages]) : currentPage + 5 - 1 > totalPages ? [1].concat(_toConsumableArray(range_default()(totalPages - 5 + 2, totalPages + 1))) : [1].concat(_toConsumableArray(range_default()(currentPage - 2, currentPage + 5 - 2)), [totalPages]);
        }(page, totalPages);

        return external_react_default.a.createElement("div", {
          className: Pagination_module_default.a.pageButtonsWrapper
        }, map_default()(visiblePages).call(visiblePages, renderPageButton));
      }, [page, totalPages, renderPageButton]),
          paginationSelectId = Object(platform_.uniqueInnerId)(id, "paginationSelectId").paginationSelectId;
      return external_react_default.a.createElement("div", {
        id: id,
        className: Pagination_module_default.a.pagination
      }, external_react_default.a.createElement("div", {
        className: Pagination_module_default.a.pageSizeSelectWrapper
      }, external_react_default.a.createElement(PaginationSelect, {
        id: paginationSelectId + "_pageSizeSelect",
        onValueChange: onSelectPageSizeChange,
        value: pageSizeSelectedOption,
        availableValues: transformedPageSizeOptions
      }), external_react_default.a.createElement("div", {
        className: Pagination_module_default.a.resultOfMessage
      }, external_react_default.a.createElement("span", null, translator(messages.resultOf), " "), numberOfRows)), totalPages > 1 && external_react_default.a.createElement("div", {
        className: Pagination_module_default.a.paginationNav
      }, prevNavButton, visiblePagesButtons, nextNavButton));
    };

    Pagination.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      canNext: external_prop_types_default.a.bool,
      canPrevious: external_prop_types_default.a.bool,
      pageSizeOptions: external_prop_types_default.a.array.isRequired,
      page: external_prop_types_default.a.number,
      numberOfRows: external_prop_types_default.a.number,
      pageSize: external_prop_types_default.a.number,
      onPageChange: external_prop_types_default.a.func,
      pageSizeSelectedOption: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
      onSelectPageSizeChange: external_prop_types_default.a.func
    }, NavButton.__docgenInfo = {
      componentName: "NavButton",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "NavButton",
      methods: [],
      actualName: "NavButton"
    }, Pagination.__docgenInfo = {
      componentName: "Pagination",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "Pagination",
      methods: [],
      actualName: "Pagination",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Component unique identifier"
        },
        canNext: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true` 'nextNavButton' button is rendered"
        },
        canPrevious: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If `true` 'prevNavButton' button is rendered"
        },
        pageSizeOptions: {
          type: {
            name: "array"
          },
          required: !0,
          description: "List of page size options"
        },
        page: {
          type: {
            name: "number"
          },
          required: !1,
          description: "Current page"
        },
        numberOfRows: {
          type: {
            name: "number"
          },
          required: !1,
          description: "Total rows number"
        },
        pageSize: {
          type: {
            name: "number"
          },
          required: !1,
          description: "Number of items per single page"
        },
        onPageChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback used to handle page change"
        },
        pageSizeSelectedOption: {
          type: {
            name: "union",
            value: [{
              name: "number"
            }, {
              name: "string"
            }]
          },
          required: !1,
          description: "Number of records per single page"
        },
        onSelectPageSizeChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback used to handle page size change"
        }
      }
    };

    var construct_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/reflect/construct"),
        construct_default = __webpack_require__.n(construct_),
        classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        classCallCheck_default = __webpack_require__.n(classCallCheck),
        createClass = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
        createClass_default = __webpack_require__.n(createClass),
        assertThisInitialized = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/assertThisInitialized.js"),
        assertThisInitialized_default = __webpack_require__.n(assertThisInitialized),
        inherits_ = __webpack_require__("@babel/runtime-corejs3/helpers/inherits"),
        inherits_default = __webpack_require__.n(inherits_),
        possibleConstructorReturn = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/possibleConstructorReturn.js"),
        possibleConstructorReturn_default = __webpack_require__.n(possibleConstructorReturn),
        getPrototypeOf = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/getPrototypeOf.js"),
        getPrototypeOf_default = __webpack_require__.n(getPrototypeOf),
        defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
        defineProperty_default = __webpack_require__.n(defineProperty);

    function _createSuper(Derived) {
      var hasNativeReflectConstruct = function () {
        if ("undefined" == typeof Reflect || !construct_default.a) return !1;
        if (construct_default.a.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(construct_default()(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var result,
            Super = getPrototypeOf_default()(Derived);

        if (hasNativeReflectConstruct) {
          var NewTarget = getPrototypeOf_default()(this).constructor;
          result = construct_default()(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);

        return possibleConstructorReturn_default()(this, result);
      };
    }

    var TableHeaderCell_TableHeaderCell = function (_React$Component) {
      inherits_default()(TableHeaderCell, _React$Component);

      var _super = _createSuper(TableHeaderCell);

      function TableHeaderCell() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return classCallCheck_default()(this, TableHeaderCell), _this = _super.call.apply(_super, [this].concat(args)), defineProperty_default()(assertThisInitialized_default()(_this), "handleToggleSort", function (evt) {
          var toggleSort = _this.props.toggleSort;
          toggleSort && ("Enter" !== evt.key && " " !== evt.key || (evt.preventDefault(), toggleSort(evt)));
        }), _this;
      }

      return createClass_default()(TableHeaderCell, [{
        key: "render",
        value: function value() {
          return external_react_default.a.createElement(external_react_table_.ReactTableDefaults.ThComponent, extends_default()({}, this.props, {
            onKeyDown: this.handleToggleSort
          }));
        }
      }]), TableHeaderCell;
    }(external_react_default.a.Component);

    TableHeaderCell_TableHeaderCell.__docgenInfo = {
      componentName: "TableHeaderCell",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "TableHeaderCell",
      methods: [{
        name: "handleToggleSort",
        docblock: null,
        modifiers: [],
        params: [{
          name: "evt",
          optional: void 0,
          type: null
        }],
        returns: null
      }],
      actualName: "TableHeaderCell"
    };

    var starts_with_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/starts-with"),
        starts_with_default = __webpack_require__.n(starts_with_),
        noop_ = __webpack_require__("lodash/noop"),
        noop_default = __webpack_require__.n(noop_);

    var TableContext = Object(external_react_.createContext)({
      styles: DataTable_module_default.a,
      columns: {
        configurable: !0,
        config: [],
        setConfig: noop_default.a
      }
    });

    var state_management_ = __webpack_require__("@jutro/state-management"),
        isNil = __webpack_require__("../../node_modules/lodash/isNil.js"),
        isNil_default = __webpack_require__.n(isNil);

    var ColumnsConfigModal_messages_messages = Object(external_react_intl_.defineMessages)({
      title: {
        id: "jutro-datatable.ColumnsConfigModal.Title",
        defaultMessage: "Customize Columns"
      },
      subtitle: {
        id: "jutro-datatable.ColumnsConfigModal.Subtitle",
        defaultMessage: "Uncheck columns to remove them from the table"
      },
      cancel: {
        id: "jutro-datatable.ColumnsConfigModal.Cancel",
        defaultMessage: "Cancel"
      },
      applyChanges: {
        id: "jutro-datatable.ColumnsConfigModal.ApplyChange",
        defaultMessage: "Apply Changes"
      }
    });

    var ColumnEntry_module = __webpack_require__("./columnsConfig/ColumnEntry.module.scss"),
        ColumnEntry_module_default = __webpack_require__.n(ColumnEntry_module);

    function ColumnEntry(_ref24) {
      var id = _ref24.id,
          header = _ref24.header,
          enabled = _ref24.enabled,
          onToggle = _ref24.onToggle;
      return !!header && external_react_default.a.createElement("div", {
        className: ColumnEntry_module_default.a.columnEntry
      }, external_react_default.a.createElement(components_.CheckboxField, {
        id: id,
        label: header,
        controlClassName: ColumnEntry_module_default.a.columnEntryCheckbox,
        labelClassName: ColumnEntry_module_default.a.columnEntryLabel,
        value: enabled,
        size: "small",
        showInlineLabel: !0,
        onValueChange: onToggle
      }));
    }

    function ColumnsConfigModal(_ref25) {
      var isOpen = _ref25.isOpen,
          onResolve = _ref25.onResolve,
          onReject = _ref25.onReject,
          parentSelector = _ref25.parentSelector,
          initialColumns = _ref25.initialColumns;

      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          _useState = Object(external_react_.useState)(initialColumns),
          _useState2 = slicedToArray_default()(_useState, 2),
          columns = _useState2[0],
          setColumns = _useState2[1],
          handleConfirm = Object(external_react_.useCallback)(function () {
        return onResolve(columns);
      }, [onResolve, columns]),
          columnEntries = Object(external_react_.useMemo)(function () {
        var onColumnToggle = function onColumnToggle(index) {
          return function (enabled) {
            var newColumns = Object(state_management_.update)(columns, index + ".enabled", function (currentlyEnabled) {
              return isNil_default()(enabled) ? !currentlyEnabled : enabled;
            });
            setColumns(newColumns);
          };
        };

        return map_default()(columns).call(columns, function (column, index) {
          return external_react_default.a.createElement(ColumnEntry, extends_default()({
            key: column.id
          }, column, {
            onToggle: onColumnToggle(index)
          }));
        });
      }, [columns]);

      return external_react_default.a.createElement(components_.ModalNext, {
        isOpen: isOpen,
        onRequestClose: onReject,
        parentSelector: parentSelector
      }, external_react_default.a.createElement(components_.ModalHeader, {
        title: translator(ColumnsConfigModal_messages_messages.title),
        subtitle: translator(ColumnsConfigModal_messages_messages.subtitle),
        onClose: onReject
      }), external_react_default.a.createElement(components_.ModalBody, {
        contentLayout: {
          component: "grid",
          componentProps: {
            columns: ["1fr"],
            gap: "xxsmall"
          }
        }
      }, columnEntries), external_react_default.a.createElement(components_.ModalFooter, null, external_react_default.a.createElement(components_.Button, {
        type: "tertiary",
        onClick: onReject
      }, translator(ColumnsConfigModal_messages_messages.cancel)), external_react_default.a.createElement(components_.Button, {
        onClick: handleConfirm
      }, translator(ColumnsConfigModal_messages_messages.applyChanges))));
    }

    ColumnEntry.propTypes = {
      id: external_prop_types_default.a.string.isRequired,
      header: external_prop_types_default.a.string,
      enabled: external_prop_types_default.a.bool,
      onToggle: external_prop_types_default.a.func
    }, ColumnEntry.__docgenInfo = {
      componentName: "ColumnEntry",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "ColumnEntry",
      methods: [],
      actualName: "ColumnEntry",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify the component"
        },
        header: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Label text to be displayed beside the checkbox"
        },
        enabled: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If true, the checkbox marked as checked"
        },
        onToggle: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to toggle the checkbox enabled state"
        }
      }
    };
    var columnPropTypes = {
      id: external_prop_types_default.a.string.isRequired,
      header: external_prop_types_default.a.string,
      enabled: external_prop_types_default.a.bool
    };
    ColumnsConfigModal.propTypes = {
      isOpen: external_prop_types_default.a.bool,
      onResolve: external_prop_types_default.a.func,
      onReject: external_prop_types_default.a.func,
      parentSelector: external_prop_types_default.a.func,
      initialColumns: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape(columnPropTypes))
    }, ColumnsConfigModal.__docgenInfo = {
      componentName: "ColumnsConfigModal",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "ColumnsConfigModal",
      methods: [],
      actualName: "ColumnsConfigModal",
      props: {
        isOpen: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Flag to indicate if the Modal is currently open"
        },
        onResolve: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to be called when the Modal has been requested to be resolve"
        },
        onReject: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to be called when the Modal has been requested to be closed"
        },
        parentSelector: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to find the Modal's parent selector"
        },
        initialColumns: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  description: "Used to identify the component",
                  required: !0
                },
                header: {
                  name: "string",
                  description: "Label text to be displayed beside the checkbox",
                  required: !1
                },
                enabled: {
                  name: "bool",
                  description: "If true, the checkbox marked as checked",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Array of columns"
        }
      }
    };

    var DataTable_messages_messages = Object(external_react_intl_.defineMessages)({
      noDataText: {
        id: "jutro-datatable.DataTable.Pagination.NoDataText",
        defaultMessage: "No rows found"
      },
      loadingText: {
        id: "jutro-datatable.DataTable.Pagination.LoadingText",
        defaultMessage: "Loading..."
      }
    }),
        TableBar = function TableBar(_ref26) {
      var filterValue = _ref26.filterValue,
          onFilterChange = _ref26.onFilterChange,
          filterPlaceholder = _ref26.filterPlaceholder,
          _ref26$selectionActio = _ref26.selectionActions,
          selectionActions = _ref26$selectionActio === void 0 ? [] : _ref26$selectionActio,
          showSelectionActions = _ref26.showSelectionActions,
          disabled = _ref26.disabled;

      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          showModal = Object(components_.useModal)().showModal,
          _useTableContext = Object(external_react_.useContext)(TableContext),
          styles = _useTableContext.styles,
          columns = _useTableContext.columns,
          columnsConfigurable = columns.configurable,
          columnsConfig = columns.config,
          setColumnsConfig = columns.setConfig,
          columnsConfigAction = Object(external_react_.useMemo)(function () {
        if (!columnsConfigurable) return null;
        return external_react_default.a.createElement("div", {
          className: styles.columnsConfigAction
        }, external_react_default.a.createElement(components_.IconButton, {
          icon: "mi-view-column",
          label: translator(DataTable_messages_messages.columnsConfig),
          onClick: function onClick() {
            var updatedConfig;
            return _regeneratorRuntime.async(function onClick$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.prev = 0;
                    _context8.next = 3;
                    return _regeneratorRuntime.awrap(showModal(external_react_default.a.createElement(ColumnsConfigModal, {
                      initialColumns: columnsConfig
                    })));

                  case 3:
                    updatedConfig = _context8.sent;
                    setColumnsConfig(updatedConfig);
                    _context8.next = 9;
                    break;

                  case 7:
                    _context8.prev = 7;
                    _context8.t0 = _context8["catch"](0);

                  case 9:
                  case "end":
                    return _context8.stop();
                }
              }
            }, null, null, [[0, 7]], Promise);
          }
        }));
      }, [columnsConfigurable, styles.columnsConfigAction, translator, showModal, columnsConfig, setColumnsConfig]);

      return external_react_default.a.createElement("div", {
        className: styles.tableBar
      }, external_react_default.a.createElement(components_.InputField, {
        id: "search",
        icon: "mi-search",
        iconPosition: "right",
        placeholder: filterPlaceholder,
        className: styles.searchWrapper,
        controlClassName: styles.search,
        onValueChange: onFilterChange,
        value: filterValue,
        disabled: disabled
      }), external_react_default.a.createElement("div", {
        className: styles.actionPanel
      }, showSelectionActions && external_react_default.a.createElement(external_react_transition_group_.TransitionGroup, {
        component: null
      }, external_react_default.a.createElement(external_react_transition_group_.Transition, {
        timeout: 400
      }, function (state) {
        var _external_classnames_2;

        var actionBarStyles = external_classnames_default()(styles.selectionActions, (_external_classnames_2 = {}, _defineProperty(_external_classnames_2, styles.withBorder, columnsConfigAction), _defineProperty(_external_classnames_2, styles.transition, "entered" !== state), _external_classnames_2)),
            buttonsStyles = external_classnames_default()(styles.buttons, _defineProperty({}, styles.enter, starts_with_default()(state).call(state, "enter")));
        return external_react_default.a.createElement("div", {
          className: actionBarStyles
        }, external_react_default.a.createElement("div", {
          className: buttonsStyles
        }, map_default()(selectionActions).call(selectionActions, function (_ref27) {
          var icon = _ref27.icon,
              label = _ref27.label,
              callback = _ref27.callback;
          return external_react_default.a.createElement(components_.IconButton, {
            key: label,
            icon: icon,
            label: label,
            onClick: callback
          });
        })));
      })), columnsConfigAction));
    };

    TableBar.__docgenInfo = {
      componentName: "TableBar",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "TableBar",
      methods: [],
      actualName: "TableBar",
      props: {
        selectionActions: {
          defaultValue: {
            value: "[]",
            computed: !1
          },
          required: !1
        }
      }
    };

    var omit_ = __webpack_require__("lodash/omit"),
        omit_default = __webpack_require__.n(omit_),
        findKey = __webpack_require__("../../node_modules/lodash/findKey.js"),
        findKey_default = __webpack_require__.n(findKey);

    function reducer(state, _ref28) {
      var type = _ref28.type,
          payload = _ref28.payload;

      switch (type) {
        case "COLLAPSE":
          {
            var viewIndex = findKey_default()(state, function (_ref29) {
              var rowId = _ref29.rowId;
              return rowId === payload;
            });
            return void 0 === viewIndex ? state : omit_default()(state, [viewIndex]);
          }

        case "TOGGLE":
          {
            var rowId = payload.rowId,
                _viewIndex = payload.viewIndex,
                oldExpanded = payload.allowMultiple ? state : {};
            return state[_viewIndex] ? omit_default()(state, [_viewIndex]) : _objectSpread({}, oldExpanded, _defineProperty({}, _viewIndex, {
              rowId: rowId
            }));
          }

        case "COLLAPSE_ALL":
          return {};

        default:
          return state;
      }
    }

    var actions_collapse = function actions_collapse(payload) {
      return {
        type: "COLLAPSE",
        payload: payload
      };
    },
        toggle = function toggle(rowId, viewIndex, allowMultiple) {
      return {
        type: "TOGGLE",
        payload: {
          rowId: rowId,
          viewIndex: viewIndex,
          allowMultiple: allowMultiple
        }
      };
    },
        actions_collapseAll = function actions_collapseAll() {
      return {
        type: "COLLAPSE_ALL"
      };
    };

    var identity_ = __webpack_require__("lodash/identity"),
        identity_default = __webpack_require__.n(identity_),
        every_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
        every_default = __webpack_require__.n(every_);

    var index_of_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/index-of"),
        index_of_default = __webpack_require__.n(index_of_);

    function reducer_reducer(state, _ref30) {
      var type = _ref30.type,
          payload = _ref30.payload;

      switch (type) {
        case "SELECT":
          return areEqual([payload], state.rows) ? _objectSpread({}, state, {
            all: !1
          }) : _objectSpread({}, state, {
            all: !1,
            rows: [payload]
          });

        case "TOGGLE":
          var newRows = function (array, value) {
            var _context;

            var index = index_of_default()(array).call(array, value);
            return -1 === index ? concat_default()(array).call(array, [value]) : concat_default()(_context = slice_default()(array).call(array, 0, index)).call(_context, slice_default()(array).call(array, index + 1));
          }(state.rows, payload);

          return _objectSpread({}, state, {
            all: !1,
            rows: newRows
          });

        case "SET_ALL":
          return areEqual(payload, state.rows) ? _objectSpread({}, state, {
            all: !0
          }) : _objectSpread({}, state, {
            all: !0,
            rows: payload
          });

        case "CLEAR_ALL":
          return state.rows.length ? _objectSpread({}, state, {
            all: !1,
            rows: []
          }) : _objectSpread({}, state, {
            all: !1
          });

        default:
          return state;
      }
    }

    function areEqual(array1, array2) {
      return array1.length === array2.length && every_default()(array1).call(array1, function (item) {
        return includes_default()(array2).call(array2, item);
      });
    }

    var actions_select = function actions_select(rowId) {
      return {
        type: "SELECT",
        payload: rowId
      };
    },
        actions_toggle = function actions_toggle(rowId) {
      return {
        type: "TOGGLE",
        payload: rowId
      };
    },
        actions_setAll = function actions_setAll(newRows) {
      return {
        type: "SET_ALL",
        payload: newRows
      };
    },
        actions_clearAll = function actions_clearAll() {
      return {
        type: "CLEAR_ALL"
      };
    };

    function withNormalizedRows() {
      var updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity_default.a;
      var selectionType = arguments.length > 1 ? arguments[1] : undefined;
      return function (state) {
        var _updateState = updateState(state),
            rows = _updateState.rows;

        return _objectSpread({}, objectWithoutProperties_default()(_updateState, ["rows"]), {
          rows: normalizeSelectedRows(rows, selectionType)
        });
      };
    }

    function normalizeSelectedRows(selectedRows, selectionType) {
      return "none" === selectionType ? [] : "multi" === selectionType ? selectedRows : slice_default()(selectedRows).call(selectedRows, 0, 1);
    }

    var config_reducer_reducer = function config_reducer_reducer(state, action) {
      switch (action.type) {
        case "SET_FILTER_VALUE":
          {
            var newState = _objectSpread({}, state, {
              filterValue: action.filterValue
            });

            return action.resetPage && (newState.page = 0), newState;
          }

        case "SET_PAGE":
          return _objectSpread({}, state, {
            page: action.page
          });

        case "SET_PAGE_SIZE":
          {
            var _newState = _objectSpread({}, state, {
              pageSize: action.pageSize
            });

            return action.resetPage && (_newState.page = 0), _newState;
          }

        case "SET_SORTED":
          {
            var sorted = action.sorted;
            return _objectSpread({}, state, {
              sorted: null == sorted ? void 0 : map_default()(sorted).call(sorted, function (method) {
                return _objectSpread({}, method);
              })
            });
          }

        case "SET_COLUMNS":
          return _objectSpread({}, state, {
            columns: action.columns
          });

        case "SET_EDITED_ROW":
          return _objectSpread({}, state, {
            editedRow: action.rowId
          });

        default:
          return state;
      }
    },
        actions_setFilterValue = function actions_setFilterValue(filterValue) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return {
        type: "SET_FILTER_VALUE",
        filterValue: filterValue,
        resetPage: resetPage
      };
    },
        actions_setPage = function actions_setPage(page) {
      return {
        type: "SET_PAGE",
        page: page
      };
    },
        actions_setPageSize = function actions_setPageSize(pageSize) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return {
        type: "SET_PAGE_SIZE",
        pageSize: pageSize,
        resetPage: resetPage
      };
    },
        actions_setSorted = function actions_setSorted(sorted) {
      return {
        type: "SET_SORTED",
        sorted: sorted
      };
    },
        actions_setColumns = function actions_setColumns(columns) {
      return {
        type: "SET_COLUMNS",
        columns: columns
      };
    },
        actions_setEditedRow = function actions_setEditedRow(rowId) {
      return {
        type: "SET_EDITED_ROW",
        rowId: rowId
      };
    },
        async_reducer_reducer = function async_reducer_reducer(state, _ref31) {
      var type = _ref31.type,
          payload = _objectWithoutProperties(_ref31, ["type"]);

      switch (type) {
        case "SET_ASYNC_DATA":
          {
            var asyncData = payload.asyncData,
                numberOfRows = payload.numberOfRows;
            return _objectSpread({}, state, {
              asyncData: asyncData,
              numberOfRows: numberOfRows
            });
          }

        case "SET_LOADING":
          {
            var loading = payload.loading;
            return _objectSpread({}, state, {
              loading: loading
            });
          }

        case "SET_ASYNC_INTERNAL_STATE":
          {
            var asyncInternalState = payload.asyncInternalState;
            return _objectSpread({}, state, {
              asyncInternalState: asyncInternalState
            });
          }

        default:
          return state;
      }
    },
        actions_setAsyncData = function actions_setAsyncData(asyncData, numberOfRows) {
      return {
        type: "SET_ASYNC_DATA",
        asyncData: asyncData,
        numberOfRows: numberOfRows
      };
    },
        actions_setLoading = function actions_setLoading(loading) {
      return {
        type: "SET_LOADING",
        loading: loading
      };
    },
        actions_setAsyncInternalState = function actions_setAsyncInternalState(asyncInternalState) {
      return {
        type: "SET_ASYNC_INTERNAL_STATE",
        asyncInternalState: asyncInternalState
      };
    };

    __webpack_require__("react-table/react-table.css");

    var nonConfigurableColumns = [RadioColumn, ActionColumn],
        DataTable_textAlignMapping = {
      left: "text-left",
      right: "text-right"
    },
        styleProps = external_lodash_default.a.mapValues({
      getTheadProps: DataTable_module_default.a.tableHeader,
      getTbodyProps: DataTable_module_default.a.tableBody,
      getTrGroupProps: DataTable_module_default.a.tableRowGroup
    }, function (className) {
      return function () {
        return {
          className: className
        };
      };
    }),
        expanderDefaults = _objectSpread({}, external_react_table_.ReactTableDefaults.expanderDefaults, {
      width: 28
    }),
        AnimatedTrGroupComponent = function AnimatedTrGroupComponent(_ref32) {
      var children = _ref32.children,
          props = _objectWithoutProperties(_ref32, ["children"]);

      return external_react_default.a.createElement(external_react_table_.ReactTableDefaults.TrGroupComponent, props, external_react_default.a.createElement(external_react_transition_group_.TransitionGroup, {
        component: null
      }, children));
    },
        transitionGroupProps = ["onExited", "in", "appear", "enter", "exit"],
        AnimationResistantTrComponent = function AnimationResistantTrComponent(_ref33) {
      var hasActions = _ref33.hasActions,
          props = _objectWithoutProperties(_ref33, ["hasActions"]);

      var a11yProps = {};
      return hasActions && (a11yProps.tabIndex = 0, a11yProps.role = "button", a11yProps["aria-label"] = "row"), external_react_default.a.createElement(external_react_table_.ReactTableDefaults.TrComponent, extends_default()({}, a11yProps, external_lodash_default.a.omit(props, transitionGroupProps)));
    },
        splitHeaderText = function splitHeaderText(text) {
      return external_react_default.a.createElement("span", {
        className: DataTable_module_default.a.headerMultiline
      }, text);
    },
        renderNull = function renderNull() {
      return null;
    },
        ignoredClickTargets = ["INPUT", "BUTTON", "A", "LABEL", "SELECT", "I"],
        handleNestedClick = function handleNestedClick(event, callback) {
      var currentTarget = event.target;
      currentTarget && includes_default()(ignoredClickTargets).call(ignoredClickTargets, currentTarget.tagName) || callback(event);
    },
        findById = function findById(id) {
      return function (_ref34) {
        var configId = _ref34.id;
        return id === configId;
      };
    },
        orderColumnsUsingConfig = function orderColumnsUsingConfig(config) {
      return function (columnA, columnB) {
        var aInitialIndex = find_index_default()(config).call(config, findById(columnA.props.id)),
            bInitialIndex = find_index_default()(config).call(config, findById(columnB.props.id));
        return -1 === aInitialIndex || -1 === bInitialIndex ? 0 : aInitialIndex - bInitialIndex;
      };
    },
        dataTableConfigColumnsShape = external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
      id: external_prop_types_default.a.string.isRequired,
      enabled: external_prop_types_default.a.bool.isRequired
    })),
        dataTableConfigColumnsSortedShape = external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
      id: external_prop_types_default.a.string.isRequired,
      desc: external_prop_types_default.a.bool.isRequired
    })),
        dataTableConfigShape = external_prop_types_default.a.shape({
      editedRow: external_prop_types_default.a.number,
      columns: dataTableConfigColumnsShape,
      filterValue: external_prop_types_default.a.string,
      page: external_prop_types_default.a.number,
      pageSize: external_prop_types_default.a.number,
      sorted: dataTableConfigColumnsSortedShape
    }),
        rowIdShape = external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
        dataTablePropTypes = {
      id: external_prop_types_default.a.string.isRequired,
      showSearch: external_prop_types_default.a.bool,
      showPagination: external_prop_types_default.a.bool,
      defaultPageSize: Object(prop_types_.deprecated)(external_prop_types_default.a.number, "5.0.0", "Please use defaultConfig.pageSize instead"),
      config: dataTableConfigShape,
      defaultConfig: dataTableConfigShape,
      onConfigChange: external_prop_types_default.a.func,
      pageSizeOptions: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
      data: external_prop_types_default.a.arrayOf(external_prop_types_default.a.object),
      filter: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onFilter instead"),
      onFilter: external_prop_types_default.a.func,
      columnFilter: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onColumnFilter instead"),
      onColumnFilter: external_prop_types_default.a.func,
      filterPlaceholder: prop_types_.intlMessageShape,
      children: external_prop_types_default.a.node.isRequired,
      expandable: external_prop_types_default.a.bool,
      multipleRowsExpandable: external_prop_types_default.a.bool,
      expanderContent: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onExpanderContent instead"),
      renderExpanderContent: external_prop_types_default.a.func,
      defaultSorted: Object(prop_types_.deprecated)(dataTableConfigColumnsSortedShape, "5.0.0", "Please use defaultConfig.sorted instead"),
      headerMultiline: external_prop_types_default.a.bool,
      onRowClick: external_prop_types_default.a.func,
      expandOnRowClick: external_prop_types_default.a.bool,
      selectOnRowClick: external_prop_types_default.a.bool,
      selectionType: external_prop_types_default.a.oneOf(["none", "single", "multi"]),
      selectedRows: external_prop_types_default.a.arrayOf(rowIdShape),
      selectionActions: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
        icon: external_prop_types_default.a.string.isRequired,
        label: external_prop_types_default.a.string.isRequired,
        callback: external_prop_types_default.a.func.isRequired
      })),
      onSelectionChange: external_prop_types_default.a.func,
      columnsConfigurable: external_prop_types_default.a.bool,
      loadingText: prop_types_.intlMessageShape,
      noDataText: prop_types_.intlMessageShape,
      localSorting: external_prop_types_default.a.bool,
      phone: external_prop_types_default.a.object,
      tablet: external_prop_types_default.a.object,
      onSaveRow: external_prop_types_default.a.func,
      onEditCancel: external_prop_types_default.a.func,
      onEditStart: external_prop_types_default.a.func,
      path: external_prop_types_default.a.string,
      onFetchData: external_prop_types_default.a.func,
      onGetRowId: external_prop_types_default.a.func,
      rowIdPath: external_prop_types_default.a.string
    },
        DataTable = function DataTable(dataTableProps) {
      var _useBreakpoint = Object(layout_.useBreakpoint)(dataTableProps),
          breakpointProps = _useBreakpoint.breakpointProps,
          applyBreakpoint = _useBreakpoint.applyBreakpoint,
          breakpoint = _useBreakpoint.breakpoint,
          id = breakpointProps.id,
          showSearch = breakpointProps.showSearch,
          showPagination = breakpointProps.showPagination,
          defaultPageSize = breakpointProps.defaultPageSize,
          defaultSorted = breakpointProps.defaultSorted,
          pageSizeOptions = breakpointProps.pageSizeOptions,
          syncData = breakpointProps.data,
          deprecatedFilter = filter_default()(breakpointProps),
          onFilter = breakpointProps.onFilter,
          deprecatedColumnFilter = breakpointProps.columnFilter,
          onColumnFilter = breakpointProps.onColumnFilter,
          defaultConfigProp = breakpointProps.defaultConfig,
          config = breakpointProps.config,
          filterPlaceholder = breakpointProps.filterPlaceholder,
          children = breakpointProps.children,
          onConfigChange = breakpointProps.onConfigChange,
          onSaveRow = breakpointProps.onSaveRow,
          onEditCancel = breakpointProps.onEditCancel,
          onEditStart = breakpointProps.onEditStart,
          expandable = breakpointProps.expandable,
          multipleRowsExpandable = breakpointProps.multipleRowsExpandable,
          deprecatedExpanderContent = breakpointProps.expanderContent,
          renderExpanderContent = breakpointProps.renderExpanderContent,
          basePath = breakpointProps.path,
          headerMultiline = breakpointProps.headerMultiline,
          onRowClick = breakpointProps.onRowClick,
          expandOnRowClick = breakpointProps.expandOnRowClick,
          selectOnRowClick = breakpointProps.selectOnRowClick,
          selectionType = breakpointProps.selectionType,
          onGetRowIdProp = breakpointProps.onGetRowId,
          rowIdPath = breakpointProps.rowIdPath,
          selectedRows = breakpointProps.selectedRows,
          selectionActions = breakpointProps.selectionActions,
          onSelectionChange = breakpointProps.onSelectionChange,
          onFetchData = breakpointProps.onFetchData,
          columnsConfigurable = breakpointProps.columnsConfigurable,
          loadingText = breakpointProps.loadingText,
          noDataText = breakpointProps.noDataText,
          localSorting = breakpointProps.localSorting,
          filter = onFilter || deprecatedFilter,
          columnFilter = onColumnFilter || deprecatedColumnFilter,
          expanderContent = renderExpanderContent || deprecatedExpanderContent,
          onGetRowId = Object(external_react_.useMemo)(function () {
        return rowIdPath ? function (row) {
          return row[rowIdPath];
        } : onGetRowIdProp;
      }, [onGetRowIdProp, rowIdPath]),
          defaultConfig = Object(external_react_.useMemo)(function () {
        return _objectSpread({}, defaultConfigProp, {
          pageSize: null != defaultPageSize ? defaultPageSize : defaultConfigProp.pageSize,
          sorted: null != defaultSorted ? defaultSorted : defaultConfigProp.sorted
        });
      }, [defaultConfigProp, defaultPageSize, defaultSorted]),
          childrenArray = external_react_default.a.Children.toArray(children),
          reactTable = Object(external_react_.useRef)(),
          shouldShowSearch = !1 !== showSearch,
          shouldShowPagination = !1 !== showPagination,
          shouldBeExpandable = expandable && !!expanderContent,
          shouldBeSelectable = "none" !== selectionType,
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          language = locale_.LocaleService.getStoredLanguage(),
          _useExpansion = function () {
        var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _useReducer = Object(external_react_.useReducer)(reducer, initialState),
            _useReducer2 = slicedToArray_default()(_useReducer, 2),
            expandedRows = _useReducer2[0],
            dispatch = _useReducer2[1];

        return [expandedRows, Object(external_react_.useMemo)(function () {
          return Object(state_management_.bindActionCreators)(dispatch, actions_namespaceObject);
        }, [])];
      }(),
          _useExpansion2 = slicedToArray_default()(_useExpansion, 2),
          expandedRows = _useExpansion2[0],
          _useExpansion2$ = _useExpansion2[1],
          collapse = _useExpansion2$.collapse,
          toggleExpansion = _useExpansion2$.toggle,
          collapseAll = _useExpansion2$.collapseAll,
          _useSelection = function (initialState, selectedRows, selectionType, onSelectionChange) {
        var updateState = selectedRows && function (oldState) {
          return _objectSpread({}, oldState, {
            rows: selectedRows
          });
        },
            _useControlledReducer = Object(state_management_.useControlledReducer)({
          reducer: reducer_reducer,
          initialState: initialState,
          controlledState: withNormalizedRows(updateState, selectionType),
          onStateChange: function onStateChange(_ref35) {
            var rows = _ref35.rows;
            onSelectionChange && rows !== state.rows && onSelectionChange(rows);
          },
          updateInControlledMode: !updateState
        }),
            _useControlledReducer2 = slicedToArray_default()(_useControlledReducer, 2),
            state = _useControlledReducer2[0],
            dispatch = _useControlledReducer2[1],
            boundActions = Object(external_react_.useMemo)(function () {
          return Object(state_management_.bindActionCreators)(dispatch, selection_actions_namespaceObject);
        }, []);

        return [state, boundActions];
      }({
        all: !1,
        rows: selectedRows || []
      }, selectedRows, selectionType, onSelectionChange),
          _useSelection2 = slicedToArray_default()(_useSelection, 2),
          selectedState = _useSelection2[0],
          _useSelection2$ = _useSelection2[1],
          selectRow = _useSelection2$.select,
          toggleSelection = _useSelection2$.toggle,
          setAll = _useSelection2$.setAll,
          clearAll = _useSelection2$.clearAll,
          _useAsync = function () {
        var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _useReducer = Object(external_react_.useReducer)(async_reducer_reducer, initialState),
            _useReducer2 = slicedToArray_default()(_useReducer, 2),
            state = _useReducer2[0],
            dispatch = _useReducer2[1];

        return [state, Object(external_react_.useMemo)(function () {
          return Object(state_management_.bindActionCreators)(dispatch, async_actions_namespaceObject);
        }, [])];
      }(),
          _useAsync2 = slicedToArray_default()(_useAsync, 2),
          _useAsync2$ = _useAsync2[0],
          asyncData = _useAsync2$.asyncData,
          loading = _useAsync2$.loading,
          totalNumberOfRows = _useAsync2$.numberOfRows,
          asyncInternalState = _useAsync2$.asyncInternalState,
          asyncActions = _useAsync2[1],
          data = onFetchData ? asyncData : syncData,
          getEditProps = function getEditProps(rowId) {
        return void 0 !== rowId ? {
          rowId: rowId,
          row: find_default()(data).call(data, function (row, index) {
            return onGetRowId(row, index) === rowId;
          })
        } : {};
      },
          _useState = Object(external_react_.useState)(getEditProps((null == config ? void 0 : config.editedRow) || defaultConfig.editedRow)),
          _useState2 = slicedToArray_default()(_useState, 2),
          editProps = _useState2[0],
          setEditProps = _useState2[1],
          updateEditedRow = function updateEditedRow(rowId) {
        return setEditProps(getEditProps(rowId));
      },
          initialColumnsConfig = Object(external_react_.useMemo)(function () {
        var _config$columns, _context;

        var initialConfig = null !== (_config$columns = null == config ? void 0 : config.columns) && void 0 !== _config$columns ? _config$columns : defaultConfig.columns,
            withInitialConfig = null == initialConfig ? void 0 : initialConfig.length;
        return childrenArray.length ? (withInitialConfig && sort_default()(childrenArray).call(childrenArray, orderColumnsUsingConfig(initialConfig)), filter_default()(_context = map_default()(childrenArray).call(childrenArray, function (childColumn) {
          var columnChildId = childColumn.props.id,
              type = childColumn.type;
          if (includes_default()(nonConfigurableColumns).call(nonConfigurableColumns, type)) return;
          var columnConfig = {
            id: columnChildId,
            enabled: !0
          };

          if (withInitialConfig) {
            var initialColumnConfig = find_default()(initialConfig).call(initialConfig, function (_ref36) {
              var configId = _ref36.id;
              return columnChildId === configId;
            });

            columnConfig.enabled = function () {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              var _config$enabled;

              return null === (_config$enabled = config.enabled) || void 0 === _config$enabled || _config$enabled;
            }(initialColumnConfig);
          }

          return columnConfig;
        })).call(_context, Boolean)) : [];
      }, [childrenArray, config, defaultConfig]),
          _useConfig = function (initialState, controlledState, onStateChange) {
        var _useControlledReducer = Object(state_management_.useControlledReducer)({
          reducer: config_reducer_reducer,
          initialState: initialState,
          controlledState: controlledState,
          onStateChange: onStateChange
        }),
            _useControlledReducer2 = slicedToArray_default()(_useControlledReducer, 2),
            state = _useControlledReducer2[0],
            dispatch = _useControlledReducer2[1];

        return [state, Object(external_react_.useMemo)(function () {
          return Object(state_management_.bindActionCreators)(dispatch, {
            setFilterValue: actions_setFilterValue,
            setPage: actions_setPage,
            setPageSize: actions_setPageSize,
            setSorted: actions_setSorted,
            setColumns: actions_setColumns,
            setEditedRow: actions_setEditedRow
          });
        }, [dispatch])];
      }(_objectSpread({}, defaultConfig, {
        columns: initialColumnsConfig
      }), config && function (oldConfig) {
        return editProps ? (config.editedRow !== (null == editProps ? void 0 : editProps.rowId) && updateEditedRow(config.editedRow), _objectSpread({}, config, {
          columns: initialColumnsConfig
        })) : _objectSpread({}, oldConfig, {
          columns: initialColumnsConfig
        });
      }, onConfigChange),
          _useConfig2 = slicedToArray_default()(_useConfig, 2),
          _useConfig2$ = _useConfig2[0],
          filterValue = _useConfig2$.filterValue,
          pageSizeSelectedOption = _useConfig2$.pageSize,
          page = _useConfig2$.page,
          sorted = _useConfig2$.sorted,
          columns = _useConfig2$.columns,
          editedRow = _useConfig2$.editedRow,
          _useConfig2$2 = _useConfig2[1],
          setFilterValue = _useConfig2$2.setFilterValue,
          setPageSize = _useConfig2$2.setPageSize,
          setPage = _useConfig2$2.setPage,
          setSorted = _useConfig2$2.setSorted,
          setColumns = _useConfig2$2.setColumns,
          setEditedRow = _useConfig2$2.setEditedRow,
          isEdited = Object(external_react_.useCallback)(function (rowId) {
        return editedRow === rowId;
      }, [editedRow]),
          editActions = {
        start: function start(row, index) {
          var rowId = onGetRowId(row, index);
          onEditStart && onEditStart(row, rowId), setEditedRow(rowId), updateEditedRow(rowId), collapse(rowId);
        },
        update: function update(row, path, newValue) {
          setEditProps(function (oldEditProps) {
            return _objectSpread({}, oldEditProps, {
              row: _objectSpread({}, oldEditProps.row, _defineProperty({}, path, newValue))
            });
          });
        },
        cancel: function cancel() {
          onEditCancel && onEditCancel(editProps.row, editProps.rowId), setEditedRow(), updateEditedRow();
        },
        save: function save() {
          onSaveRow && onSaveRow(editProps.row, editProps.rowId), setEditedRow(), updateEditedRow();
        }
      },
          _useState3 = Object(external_react_.useState)(null),
          _useState4 = slicedToArray_default()(_useState3, 2),
          pressedRowId = _useState4[0],
          setPressedRowId = _useState4[1],
          handleSortedChange = Object(external_react_.useCallback)(function (newSortedValue) {
        setSorted(newSortedValue), collapseAll();
      }, [setSorted, collapseAll]),
          handlePageChange = Object(external_react_.useCallback)(function (newPage) {
        setPage(newPage), collapseAll();
      }, [setPage, collapseAll]),
          handleExpand = Object(external_react_.useCallback)(function (rowId, viewIndex) {
        return !isEdited(rowId) && toggleExpansion(rowId, viewIndex, multipleRowsExpandable);
      }, [isEdited, multipleRowsExpandable, toggleExpansion]),
          filterFunction = Object(external_react_.useMemo)(function () {
        return filter || function (value) {
          var valueFilters = map_default()(childrenArray).call(childrenArray, function (_ref37) {
            var props = _ref37.props;
            return (filter_default()(props) || props.onFilter || columnFilter)(value, props);
          });
          return function (item, index, tableData) {
            return some_default()(valueFilters).call(valueFilters, function (valueFilter) {
              return valueFilter(item, index, tableData);
            });
          };
        };
      }, [filter, childrenArray, columnFilter]),
          contextColumnsConfig = Object(external_react_.useMemo)(function () {
        return map_default()(columns).call(columns, function (columnConfig) {
          var childColumn = find_default()(childrenArray).call(childrenArray, function (_ref38) {
            var columnChildId = _ref38.props.id;
            return columnConfig.id === columnChildId;
          });
          return _objectSpread({}, columnConfig, {
            header: childColumn.props.header
          });
        });
      }, [childrenArray, columns]),
          tableContext = Object(external_react_.useMemo)(function () {
        return {
          styles: DataTable_module_default.a,
          columns: _objectSpread({
            configurable: columnsConfigurable,
            config: contextColumnsConfig
          }, columnsConfigurable && {
            setConfig: setColumns
          })
        };
      }, [columnsConfigurable, contextColumnsConfig, setColumns]),
          filteredData = Object(external_react_.useMemo)(function () {
        return data && children ? shouldShowSearch && filterValue ? filter_default()(data).call(data, filterFunction(filterValue)) : data : [];
      }, [shouldShowSearch, data, children, filterFunction, filterValue]),
          numberOfRows = onFetchData ? totalNumberOfRows : filteredData.length,
          pageSize = Object(external_react_.useMemo)(function () {
        return shouldShowPagination && "All" !== pageSizeSelectedOption ? pageSizeSelectedOption : numberOfRows;
      }, [shouldShowPagination, pageSizeSelectedOption, numberOfRows]),
          Expander = Object(external_react_.useCallback)(function (_ref39) {
        var isExpanded = _ref39.isExpanded,
            row = _ref39.row,
            index = _ref39.index,
            viewIndex = _ref39.viewIndex;
        return external_react_default.a.createElement(components_.Chevron, {
          isOpen: isExpanded,
          className: DataTable_module_default.a.expanderIcon,
          tabIndex: "0",
          role: "button",
          onMouseDown: function onMouseDown(event) {
            event.preventDefault();
          },
          onKeyPress: Object(components_.getKeyPressHandler)(function () {
            return toggleExpansion(onGetRowId(row, index), viewIndex, multipleRowsExpandable);
          })
        });
      }, [toggleExpansion, multipleRowsExpandable, onGetRowId]),
          getExpandRowActions = Object(external_react_.useCallback)(function (_ref40) {
        var index = _ref40.index,
            viewIndex = _ref40.viewIndex,
            row = _ref40.row;
        return shouldBeExpandable && expandOnRowClick && function () {
          return handleExpand(onGetRowId(row, index), viewIndex);
        };
      }, [expandOnRowClick, handleExpand, shouldBeExpandable, onGetRowId]),
          SelectionHeader = Object(external_react_.useMemo)(function () {
        if ("multi" === selectionType) return function () {
          return external_react_default.a.createElement(components_.CheckboxField, {
            id: id + "-select-all",
            size: "small",
            onValueChange: function onValueChange(value) {
              if (value) {
                var _context2;

                var allRows = reactTable.current.getResolvedState().sortedData,
                    startIndex = page * pageSize,
                    visibleRows = map_default()(_context2 = slice_default()(allRows).call(allRows, startIndex, startIndex + pageSize)).call(_context2, function (_ref41) {
                  var _original = _ref41._original,
                      _index = _ref41._index;
                  return onGetRowId(_original, _index);
                });
                setAll(visibleRows);
              } else clearAll();
            },
            value: selectedState.all
          });
        };
      }, [id, pageSize, page, selectionType, selectedState.all, clearAll, setAll, onGetRowId]),
          SelectionCell = Object(external_react_.useMemo)(function () {
        if ("none" !== selectionType) return "single" === selectionType ? function (_ref42) {
          var index = _ref42.index,
              viewIndex = _ref42.viewIndex,
              row = _ref42.original;
          var rowId = onGetRowId(row, index);
          return external_react_default.a.createElement(components_.RadioButton, {
            id: "".concat(id, "-select-").concat(viewIndex),
            size: "small",
            option: {
              code: rowId
            },
            onValueChange: function onValueChange() {
              return selectRow(rowId);
            },
            value: "" + selectedState.rows[0],
            className: DataTable_module_default.a.radio
          });
        } : function (_ref43) {
          var index = _ref43.index,
              viewIndex = _ref43.viewIndex,
              row = _ref43.original;

          var _context3;

          var rowId = onGetRowId(row, index);
          return external_react_default.a.createElement(components_.CheckboxField, {
            id: "".concat(id, "-select-").concat(viewIndex),
            size: "small",
            onValueChange: function onValueChange() {
              return toggleSelection(rowId);
            },
            value: includes_default()(_context3 = selectedState.rows).call(_context3, rowId)
          });
        };
      }, [id, selectionType, selectedState.rows, selectRow, toggleSelection, onGetRowId]),
          shouldDisableActions = selectedState.rows.length > 1,
          columnsArray = Object(external_react_.useMemo)(function () {
        var _context5;

        var visibleColumns = childrenArray;

        var _context4;

        (null == columns ? void 0 : columns.length) && (visibleColumns = sort_default()(_context4 = filter_default()(visibleColumns).call(visibleColumns, function (_ref44) {
          var colId = _ref44.props.id;

          var _columnConfig$enabled;

          var columnConfig = find_default()(columns).call(columns, function (_ref45) {
            var configId = _ref45.id;
            return colId === configId;
          });
          return null === (_columnConfig$enabled = null == columnConfig ? void 0 : columnConfig.enabled) || void 0 === _columnConfig$enabled || _columnConfig$enabled;
        })).call(_context4, orderColumnsUsingConfig(columns)));
        var childrenColumns = map_default()(visibleColumns).call(visibleColumns, function (_ref46) {
          var props = _ref46.props;

          var _applyBreakpoint = applyBreakpoint(props),
              cell = _applyBreakpoint.cell,
              onCell = _applyBreakpoint.onCell,
              renderCell = _applyBreakpoint.renderCell,
              editCell = _applyBreakpoint.editCell,
              onEditCell = _applyBreakpoint.onEditCell,
              renderEditCell = _applyBreakpoint.renderEditCell,
              getRowActions = _applyBreakpoint.getRowActions,
              columnClassName = _applyBreakpoint.columnClassName,
              rest = objectWithoutProperties_default()(_applyBreakpoint, ["cell", "onCell", "renderCell", "editCell", "onEditCell", "renderEditCell", "getRowActions", "columnClassName"]),
              childId = rest.id,
              onHeader = rest.onHeader,
              header = rest.header,
              renderHeader = rest.renderHeader,
              textAlign = rest.textAlign,
              visible = rest.visible,
              headerClassName = rest.headerClassName,
              cellClassName = rest.cellClassName,
              columnProportion = rest.columnProportion,
              width = rest.width,
              sortable = rest.sortable,
              cellBasePath = rest.basePath,
              readOnly = rest.readOnly,
              editCellClass = rest.editCellClass,
              path = rest.path,
              onSort = rest.onSort,
              onAccessor = rest.onAccessor;

          "function" == typeof readOnly && console.warn("From Jutro version 5.0.0 'readOnly' prop type in DisplayColumn and FieldColumn will be changed to boolean"), "function" == typeof cellBasePath && console.warn("From Jutro version 5.0.0 'basePath' prop type in DisplayColumn and FieldColumn will be changed to string");

          var cellCallback = onCell || cell || renderCell,
              editCellCallback = onEditCell || editCell || renderEditCell,
              propsToCallback = _objectSpread({}, rest, {
            basePath: basePath,
            disableActions: shouldDisableActions,
            breakpoint: breakpoint
          }),
              Cell = cellCallback && function (_ref47) {
            var original = _ref47.original,
                index = _ref47.index;
            var rowId = onGetRowId(original, index);
            return !readOnly && editCellCallback && isEdited(rowId) ? editCellCallback({
              props: propsToCallback,
              editProps: _objectSpread({}, editProps, {
                index: index
              }),
              editActions: editActions
            }) : cellCallback(original, rowId, propsToCallback, editActions.start);
          },
              headerText = translator(header),
              headerFunction = renderHeader || onHeader || (headerMultiline ? splitHeaderText : external_lodash_default.a.identity);

          return {
            id: childId,
            Header: function Header() {
              return headerFunction(headerText);
            },
            Cell: Cell,
            className: external_classnames_default()(DataTable_textAlignMapping[textAlign], columnClassName, cellClassName),
            headerClassName: external_classnames_default()(DataTable_textAlignMapping[textAlign], _defineProperty({}, DataTable_module_default.a.headerOneLine, !headerMultiline), headerClassName),
            show: void 0 === visible || visible,
            minWidth: columnProportion,
            width: width,
            sortable: sortable,
            readOnly: readOnly,
            editCellClass: editCellClass,
            textAlign: textAlign,
            accessor: onAccessor || path,
            header: headerText,
            getRowActions: getRowActions,
            props: rest,
            sortMethod: onSort
          };
        }),
            selectionClassName = external_classnames_default()(DataTable_module_default.a.selectionCell, _defineProperty({}, DataTable_module_default.a.serviceCell, shouldBeExpandable)),
            selectionWidth = shouldBeExpandable ? 44 : 36,
            expanderClassName = external_classnames_default()(DataTable_module_default.a.expanderCell, _defineProperty({}, DataTable_module_default.a.serviceCell, shouldBeSelectable)),
            expanderWidth = shouldBeSelectable ? 16 : 28,
            serviceColumns = filter_default()(_context5 = [shouldBeSelectable && {
          id: "selection",
          Header: SelectionHeader,
          Cell: SelectionCell,
          sortable: !1,
          resizable: !1,
          minWidth: selectionWidth,
          width: selectionWidth,
          textAlign: "center",
          headerClassName: selectionClassName,
          className: selectionClassName
        }, shouldBeExpandable && {
          id: "expander",
          expander: !0,
          readOnly: !0,
          getRowActions: getExpandRowActions,
          Expander: Expander,
          className: expanderClassName,
          isEdited: isEdited,
          width: expanderWidth,
          minWidth: expanderWidth
        }]).call(_context5, Boolean);
        return concat_default()(serviceColumns).call(serviceColumns, childrenColumns);
      }, [childrenArray, columns, shouldBeExpandable, shouldBeSelectable, SelectionHeader, SelectionCell, getExpandRowActions, Expander, isEdited, applyBreakpoint, basePath, shouldDisableActions, breakpoint, translator, headerMultiline, editActions, editProps, onGetRowId]),
          getTrProps = Object(external_react_.useCallback)(function (item, row) {
        var _external_classnames_7;

        var _context6, _context7;

        var rowColumns = item.columns,
            original = row.original,
            index = row.index,
            viewIndex = row.viewIndex,
            rowClickAction = onRowClick && function (event) {
          return onRowClick(original, index, event);
        },
            availableActions = filter_default()(_context6 = external_lodash_default.a.flatten([rowClickAction].concat(_toConsumableArray(map_default()(rowColumns).call(rowColumns, function (_ref48) {
          var getRowActions = _ref48.getRowActions,
              props = _ref48.props;
          return getRowActions && getRowActions({
            row: original,
            index: index,
            viewIndex: viewIndex,
            props: props,
            onEditStart: editActions.start,
            selectOnRowClick: selectOnRowClick,
            expandOnRowClick: expandOnRowClick
          });
        }))))).call(_context6, Boolean),
            rowId = onGetRowId(row, index),
            hasActions = availableActions.length,
            isRowPressed = pressedRowId === rowId,
            isRowSelected = includes_default()(_context7 = selectedState.rows).call(_context7, rowId),
            actionsHandler = function actionsHandler(event) {
          event.target === event.currentTarget && event.preventDefault(), for_each_default()(availableActions).call(availableActions, function (action) {
            return handleNestedClick(event, action);
          });
        },
            getRowPressHandler = function getRowPressHandler(callback) {
          return function (event) {
            " " !== event.key && "Enter" !== event.key || handleNestedClick(event, callback);
          };
        },
            props = {
          hasActions: hasActions,
          className: external_classnames_default()(DataTable_module_default.a.tableRow, (_external_classnames_7 = {}, _defineProperty(_external_classnames_7, DataTable_module_default.a.clickableRow, hasActions), _defineProperty(_external_classnames_7, DataTable_module_default.a.activeRow, isRowPressed), _defineProperty(_external_classnames_7, DataTable_module_default.a.selectedRow, isRowSelected), _external_classnames_7))
        };

        return hasActions && (props.onClick = actionsHandler, props.onKeyPress = getRowPressHandler(actionsHandler), props.onKeyDown = getRowPressHandler(function () {
          return pressedRowId !== rowId && setPressedRowId(rowId);
        }), props.onKeyUp = getRowPressHandler(function () {
          return setPressedRowId(null);
        })), props;
      }, [editActions.start, expandOnRowClick, onRowClick, pressedRowId, selectOnRowClick, selectedState.rows, onGetRowId]),
          getTdProps = Object(external_react_.useCallback)(function (item, row, _ref49) {
        var _external_classnames_8;

        var readOnly = _ref49.readOnly,
            textAlign = _ref49.textAlign,
            editCellClass = _ref49.editCellClass,
            expander = _ref49.expander;
        var index = row.index,
            viewIndex = row.viewIndex,
            original = row.original,
            rowId = onGetRowId(original, index),
            edited = isEdited(rowId);
        return {
          className: external_classnames_default()(DataTable_module_default.a.tableCell, (_external_classnames_8 = {}, _defineProperty(_external_classnames_8, editCellClass, editCellClass && !readOnly && edited), _defineProperty(_external_classnames_8, DataTable_module_default.a.rightAlignCell, "right" === textAlign), _defineProperty(_external_classnames_8, "disabled", expander && edited), _external_classnames_8)),
          onClick: expander && function () {
            return handleExpand(rowId, viewIndex);
          }
        };
      }, [isEdited, handleExpand, onGetRowId]),
          defaultSortMethod = Object(external_react_.useCallback)(function (a, b) {
        return Object(locale_.sortWithLocale)(language)(normalize(a), normalize(b));
      }, [language]),
          tbodyProps = 0 === numberOfRows && {
        TbodyComponent: function TbodyComponent() {
          return external_react_default.a.createElement("div", {
            className: DataTable_module_default.a.noDataMessage
          }, translator(noDataText));
        }
      },
          handleAsyncDataChange = Object(external_react_.useCallback)(function _callee(asyncConfigs) {
        var _reactTable$current, _ref, _asyncConfigs$filterV, _ref2, _asyncConfigs$page, _ref3, _asyncConfigs$sorted, _ref4, _asyncConfigs$pageSiz, setAsyncData, setLoading, setAsyncInternalState, reactTableState, asyncParams, fetchedData;

        return _regeneratorRuntime.async(function _callee$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                setAsyncData = asyncActions.setAsyncData, setLoading = asyncActions.setLoading, setAsyncInternalState = asyncActions.setAsyncInternalState, reactTableState = null == reactTable || null === (_reactTable$current = reactTable.current) || void 0 === _reactTable$current ? void 0 : _reactTable$current.state, asyncParams = {
                  filterValue: null !== (_ref = null !== (_asyncConfigs$filterV = null == asyncConfigs ? void 0 : asyncConfigs.filterValue) && void 0 !== _asyncConfigs$filterV ? _asyncConfigs$filterV : null == reactTableState ? void 0 : reactTableState.filterValue) && void 0 !== _ref ? _ref : defaultConfig.filterValue,
                  page: null !== (_ref2 = null !== (_asyncConfigs$page = null == asyncConfigs ? void 0 : asyncConfigs.page) && void 0 !== _asyncConfigs$page ? _asyncConfigs$page : null == reactTableState ? void 0 : reactTableState.page) && void 0 !== _ref2 ? _ref2 : defaultConfig.page,
                  sorted: null !== (_ref3 = null !== (_asyncConfigs$sorted = null == asyncConfigs ? void 0 : asyncConfigs.sorted) && void 0 !== _asyncConfigs$sorted ? _asyncConfigs$sorted : null == reactTableState ? void 0 : reactTableState.sorted) && void 0 !== _ref3 ? _ref3 : defaultConfig.sorted,
                  pageSize: null !== (_ref4 = null !== (_asyncConfigs$pageSiz = null == asyncConfigs ? void 0 : asyncConfigs.pageSize) && void 0 !== _asyncConfigs$pageSiz ? _asyncConfigs$pageSiz : null == reactTableState ? void 0 : reactTableState.pageSize) && void 0 !== _ref4 ? _ref4 : defaultConfig.pageSize
                };

                if (!asyncInternalState) {
                  _context9.next = 8;
                  break;
                }

                if (!(localSorting && (null == asyncParams ? void 0 : asyncParams.sorted) !== (null == asyncInternalState ? void 0 : asyncInternalState.sorted))) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return", void setAsyncInternalState(asyncParams));

              case 4:
                if (!((null == asyncParams ? void 0 : asyncParams.pageSize) !== (null == asyncInternalState ? void 0 : asyncInternalState.pageSize) && "All" !== (null == asyncParams ? void 0 : asyncParams.pageSize))) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt("return", void setAsyncInternalState(asyncParams));

              case 6:
                _context9.next = 9;
                break;

              case 8:
                setAsyncInternalState(asyncParams);

              case 9:
                if (!asyncInternalState) {
                  _context9.next = 16;
                  break;
                }

                if (!(localSorting && (null == asyncParams ? void 0 : asyncParams.sorted) !== (null == asyncInternalState ? void 0 : asyncInternalState.sorted))) {
                  _context9.next = 12;
                  break;
                }

                return _context9.abrupt("return", void setAsyncInternalState(asyncParams));

              case 12:
                if (!((null == asyncParams ? void 0 : asyncParams.pageSize) !== (null == asyncInternalState ? void 0 : asyncInternalState.pageSize) && "All" !== (null == asyncParams ? void 0 : asyncParams.pageSize))) {
                  _context9.next = 14;
                  break;
                }

                return _context9.abrupt("return", void setAsyncInternalState(asyncParams));

              case 14:
                _context9.next = 17;
                break;

              case 16:
                setAsyncInternalState(asyncParams);

              case 17:
                _context9.prev = 17;
                setLoading(!0);
                _context9.next = 21;
                return _regeneratorRuntime.awrap(onFetchData(asyncParams));

              case 21:
                fetchedData = _context9.sent;
                setAsyncData(fetchedData.rows, fetchedData.numberOfRows);
                _context9.next = 28;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](17);
                Object(logger_.error)("Failed to fetch data, " + _context9.t0);

              case 28:
                _context9.prev = 28;
                setLoading(!1);
                return _context9.finish(28);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, null, null, [[17, 25, 28, 31]], Promise);
      }, [asyncActions, asyncInternalState, localSorting, defaultConfig, onFetchData]),
          debounceFilter = Object(external_react_.useCallback)(external_lodash_default.a.debounce(function (newFilterValue) {
        handleAsyncDataChange({
          filterValue: newFilterValue,
          page: 0
        });
      }, 500), [handleAsyncDataChange]),
          modeProps = onFetchData ? {
        data: data,
        loading: loading,
        manual: !localSorting,
        filterValue: filterValue,
        onFetchData: handleAsyncDataChange,
        loadingText: translator(loadingText)
      } : {
        manual: !1,
        sorted: sorted,
        defaultSortMethod: defaultSortMethod,
        onSortedChange: handleSortedChange,
        page: page,
        onPageChange: handlePageChange
      },
          getPaginationComponent = Object(external_react_.useCallback)(function (reactTableProps) {
        var paginationId = Object(platform_.uniqueInnerId)(id, "paginationId").paginationId,
            handleAsyncPageChange = function handleAsyncPageChange(newPage) {
          setPage(newPage), handleAsyncDataChange({
            page: newPage
          });
        },
            paginationProps = external_lodash_default.a.pick(reactTableProps, ["page", "onPageChange", "canNext", "canPrevious"]);

        return onFetchData && localSorting && (paginationProps.onPageChange = handleAsyncPageChange, paginationProps.page = page), external_react_default.a.createElement(Pagination, extends_default()({
          id: paginationId + "_pagination",
          numberOfRows: numberOfRows,
          pageSize: pageSize,
          pageSizeOptions: pageSizeOptions,
          pageSizeSelectedOption: pageSizeSelectedOption,
          onSelectPageSizeChange: function onSelectPageSizeChange(value) {
            var newPageSize = "All" === value ? value : Number(value);
            setPageSize(newPageSize, !onFetchData), collapseAll(), onFetchData && handleAsyncDataChange({
              page: 0,
              pageSize: newPageSize
            });
          }
        }, paginationProps));
      }, [localSorting, collapseAll, handleAsyncDataChange, id, numberOfRows, onFetchData, page, pageSize, pageSizeOptions, pageSizeSelectedOption, setPage, setPageSize]),
          paginationProps = shouldShowPagination && numberOfRows > 0 ? {
        defaultPageSize: defaultConfig.pageSize,
        PaginationComponent: function PaginationComponent(props) {
          return getPaginationComponent(props);
        }
      } : {
        showPagination: !1,
        pageSize: numberOfRows
      },
          expanderContentWrapper = Object(external_react_.useCallback)(function (_ref50) {
        var rowData = _ref50.original;
        var expanderContentWrapperStyles = external_classnames_default()(DataTable_module_default.a.expandableRowWrapper, DataTable_module_default.a.expandableRow);
        return external_react_default.a.createElement(components_.AnimationGroup, {
          animation: "expand",
          appear: !0,
          in: !0
        }, external_react_default.a.createElement("div", {
          className: expanderContentWrapperStyles
        }, expanderContent(rowData)));
      }, [expanderContent]),
          subComponent = shouldBeExpandable ? expanderContentWrapper : null,
          tableBar = Object(external_react_.useMemo)(function () {
        var actions = null == selectionActions ? void 0 : map_default()(selectionActions).call(selectionActions, function (_ref51) {
          var _callback = _ref51.callback,
              rest = _objectWithoutProperties(_ref51, ["callback"]);

          return _objectSpread({}, rest, {
            callback: function callback() {
              return _callback(selectedState.rows);
            }
          });
        });
        return shouldShowSearch && external_react_default.a.createElement(TableContext.Provider, {
          value: tableContext
        }, external_react_default.a.createElement(TableBar, {
          filterValue: filterValue,
          onFilterChange: function onFilterChange(newFilterValue) {
            setFilterValue(newFilterValue, !onFetchData), onFetchData && debounceFilter(newFilterValue), collapseAll();
          },
          filterPlaceholder: translator(filterPlaceholder),
          selectionActions: actions,
          showSelectionActions: !!selectedState.rows.length,
          disabled: loading
        }));
      }, [debounceFilter, filterPlaceholder, filterValue, loading, onFetchData, selectedState.rows, selectionActions, setFilterValue, shouldShowSearch, tableContext, translator, collapseAll]),
          reactTableKey = "".concat(id, "_").concat(onFetchData ? "async" : "sync");

      return external_react_default.a.createElement("div", {
        id: id,
        className: DataTable_module_default.a.dataTable
      }, tableBar, external_react_default.a.createElement(external_react_table_default.a, extends_default()({
        key: reactTableKey,
        ref: reactTable,
        data: filteredData,
        columns: columnsArray,
        ThComponent: TableHeaderCell_TableHeaderCell,
        getTheadThProps: getHeaderCellProps,
        minRows: 0,
        styles: DataTable_module_default.a,
        className: external_classnames_default()(DataTable_module_default.a.reactTable, "-striped", "-highlight"),
        SubComponent: subComponent,
        expanded: expandedRows
      }, paginationProps, styleProps, tbodyProps, {
        getTdProps: getTdProps,
        getTrProps: getTrProps,
        NoDataComponent: renderNull,
        expanderDefaults: expanderDefaults,
        TrGroupComponent: AnimatedTrGroupComponent,
        TrComponent: AnimationResistantTrComponent,
        defaultSorted: defaultConfig.sorted,
        pageSize: pageSize
      }, modeProps)));
    };

    function getHeaderCellProps(_props, _columnInfo, column) {
      return void 0 === column.sortable || column.sortable ? {
        className: DataTable_module_default.a.tableHeaderCell,
        tabIndex: 0,
        title: column.header,
        "aria-level": 1
      } : {
        className: external_classnames_default()(DataTable_module_default.a.tableHeaderCell, DataTable_module_default.a.unsortedHeaderCell),
        tabIndex: -1,
        pointerEvents: "none",
        title: column.header,
        "aria-hidden": !0
      };
    }

    function normalize(value) {
      return null == value ? "" : value;
    }

    DataTable.propTypes = dataTablePropTypes, DataTable.defaultProps = {
      showSearch: !0,
      showPagination: !0,
      defaultConfig: {
        filterValue: "",
        page: 0,
        pageSize: 10
      },
      columnFilter: defaultColumnFilter,
      pageSizeOptions: [10, 25, 50],
      expandable: !0,
      multipleRowsExpandable: !0,
      headerMultiline: !1,
      selectionType: "none",
      columnsConfigurable: !0,
      noDataText: DataTable_messages_messages.noDataText,
      loadingText: DataTable_messages_messages.loadingText,
      localSorting: !1,
      onGetRowId: function onGetRowId(row, index) {
        return index;
      }
    }, AnimatedTrGroupComponent.__docgenInfo = {
      componentName: "AnimatedTrGroupComponent",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "AnimatedTrGroupComponent",
      methods: [],
      actualName: "AnimatedTrGroupComponent"
    }, AnimationResistantTrComponent.__docgenInfo = {
      componentName: "AnimationResistantTrComponent",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "AnimationResistantTrComponent",
      methods: [],
      actualName: "AnimationResistantTrComponent"
    }, splitHeaderText.__docgenInfo = {
      componentName: "splitHeaderText",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "splitHeaderText",
      methods: [],
      actualName: "splitHeaderText"
    }, DataTable.__docgenInfo = {
      componentName: "DataTable",
      packageName: "@jutro/datatable",
      description: "Component for displaying tabular data",
      displayName: "DataTable",
      methods: [],
      actualName: "DataTable",
      metadataType: "container",
      props: {
        id: {
          type: {
            name: "string"
          },
          required: !0,
          description: "Used to identify the component"
        },
        showSearch: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether search bar should be shown",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        showPagination: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Defines whether pagination should be shown or not",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        defaultPageSize: {
          type: {
            name: "number"
          },
          required: !1,
          description: "@deprecated Number of items per single page",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        config: {
          type: {
            name: "custom",
            raw: "dataTableConfigShape"
          },
          required: !1,
          description: "Used to set data table config. Use it together with onConfigChange to control data table from outside.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting"
        },
        defaultConfig: {
          type: {
            name: "custom",
            raw: "dataTableConfigShape"
          },
          required: !1,
          description: "The configuration applied only on component initialization.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting",
          defaultValue: {
            value: "{\n    filterValue: '',\n    page: 0,\n    pageSize: 10,\n}",
            computed: !1
          }
        },
        onConfigChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Function to call after config value changes. New config value is passed as argument. It includes sorting method, filtering value, page, page size and columns visibility"
        },
        pageSizeOptions: {
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: "List of page size options",
          defaultValue: {
            value: "[10, 25, 50]",
            computed: !1
          }
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "object"
            }
          },
          required: !1,
          description: "Cells data"
        },
        filter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Predicate function for searching data",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onFilter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Predicate function for searching data"
        },
        columnFilter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Predicate function for searching data per column",
          defaultValue: {
            value: "defaultColumnFilter",
            computed: !0
          },
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onColumnFilter: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Predicate function for searching data per column"
        },
        filterPlaceholder: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Placeholder text for search input"
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: "Column of any type (e.g. MoneyColumn, DisplayColumn)"
        },
        expandable: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Possibility to make rows expandable",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        multipleRowsExpandable: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Multiple rows can be expanded at the same time",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        expanderContent: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Content of the expandable rows",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderExpanderContent: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Content of the expandable rows"
        },
        defaultSorted: {
          type: {
            name: "custom",
            raw: "dataTableConfigColumnsSortedShape"
          },
          required: !1,
          description: "@deprecated Array of objects containing the sort column id and whether or not it's a descending sort (e.g. [{id: 'foo', desc: false}]",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        headerMultiline: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If set to true header can be on 2 lines",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        onRowClick: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback for row click"
        },
        expandOnRowClick: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Row will expand on click"
        },
        selectOnRowClick: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Row will be selected on click"
        },
        selectionType: {
          type: {
            name: "enum",
            value: [{
              value: "'none'",
              computed: !1
            }, {
              value: "'single'",
              computed: !1
            }, {
              value: "'multi'",
              computed: !1
            }]
          },
          required: !1,
          description: "Configures row selection capability (none, single row, multi row)",
          defaultValue: {
            value: "'none'",
            computed: !1
          }
        },
        selectedRows: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "rowIdShape"
            }
          },
          required: !1,
          description: "Currently selected rows (passing value for this prop makes component fully controlled)"
        },
        selectionActions: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                icon: {
                  name: "string",
                  required: !0
                },
                label: {
                  name: "string",
                  required: !0
                },
                callback: {
                  name: "func",
                  required: !0
                }
              }
            }
          },
          required: !1,
          description: "List of actions available for selection"
        },
        onSelectionChange: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback to be invoked when selection changed"
        },
        columnsConfigurable: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "If set to false, end user will not have a possibility to customize visibility of columns",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        loadingText: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Text to show while data is loading, by default - 'Loading..'",
          defaultValue: {
            value: "messages.loadingText",
            computed: !0
          }
        },
        noDataText: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Text message, when no data present to be shown",
          defaultValue: {
            value: "messages.noDataText",
            computed: !0
          }
        },
        localSorting: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Enable local (client-side) sorting in async mode",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        phone: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include properties to use at 'phone' breakpoint"
        },
        tablet: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include properties to use 'tablet' and 'phone' breakpoint"
        },
        onSaveRow: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback (row, rowId) to be invoked when row is saved"
        },
        onEditCancel: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback (row, rowId) to be invoked when row edit is canceled"
        },
        onEditStart: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback (row, rowId) to be invoked when row edit is started"
        },
        path: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The full path of view model, it also acts as an accessor for datatable's data"
        },
        onFetchData: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback ({ filterValue, sorted, pageSize, page }) to be invoked when new data has to be fetched in async mode"
        },
        onGetRowId: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback (row) that returns unique id for the row.\nThe id should not change after editing the row.\nBy default index from data is used, but it does not work correctly when filtering.",
          defaultValue: {
            value: "(row, index) => index",
            computed: !1
          }
        },
        rowIdPath: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Name of row object property containing the row id. Takes precendence over onGetRowId prop."
        }
      }
    };

    var stringify_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/json/stringify"),
        stringify_default = __webpack_require__.n(stringify_),
        entries_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/entries"),
        entries_default = __webpack_require__.n(entries_);

    var columnConfigShape = external_prop_types_default.a.shape({
      id: external_prop_types_default.a.string,
      type: external_prop_types_default.a.oneOf(["field", "element"]),
      component: external_prop_types_default.a.oneOf(["actioncolumn", "displaycolumn", "fieldcolumn", "moneycolumn", "radiocolumn", "tablecolumn"]),
      componentProps: TableColumn.propTypes
    }),
        jsonDataTablePropTypes = _objectSpread({}, DataTable.propTypes, {
      callbackMap: external_prop_types_default.a.object,
      componentMap: external_prop_types_default.a.object,
      data: external_prop_types_default.a.object,
      dataSchema: external_prop_types_default.a.object.isRequired,
      dataSchemaExtension: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use onDataSchemaExtension instead"),
      onDataSchemaExtension: external_prop_types_default.a.func,
      onDeleteRow: external_prop_types_default.a.func,
      onSaveRow: external_prop_types_default.a.func,
      overrideProps: external_prop_types_default.a.object,
      showErrors: external_prop_types_default.a.bool,
      uiColumns: external_prop_types_default.a.arrayOf(columnConfigShape),
      readOnly: external_prop_types_default.a.bool
    });

    var JsonDataTable = function JsonDataTable(props) {
      var dataSchema = props.dataSchema,
          dataSchemaExtension = props.dataSchemaExtension,
          onDataSchemaExtension = props.onDataSchemaExtension,
          data = props.data,
          callbackMap = props.callbackMap,
          componentMap = props.componentMap,
          uiColumns = props.uiColumns,
          onDeleteRow = props.onDeleteRow,
          onSaveRow = props.onSaveRow,
          readOnly = props.readOnly,
          dataTableProps = objectWithoutProperties_default()(props, ["dataSchema", "dataSchemaExtension", "onDataSchemaExtension", "data", "callbackMap", "componentMap", "uiColumns", "onDeleteRow", "onSaveRow", "readOnly"]),
          _useJsonSchema = function (dataSchema, dataSchemaExtension, tableData) {
        var jsonHelper = Object(external_react_.useMemo)(function () {
          return new uiconfig_.JsonFormValidator({
            dataSchemaExtension: dataSchemaExtension
          });
        }, [dataSchemaExtension]);
        return [Object(external_react_.useMemo)(function () {
          return jsonHelper.dataProps(dataSchema, tableData, null);
        }, [dataSchema, tableData, jsonHelper])];
      }(dataSchema, onDataSchemaExtension || dataSchemaExtension, data && data[0] || {}),
          dataProps = slicedToArray_default()(_useJsonSchema, 1)[0],
          resolvers = {
        resolveDataProps: Object(external_react_.useCallback)(function (id, path) {
          var testProps = dataProps[path];
          return testProps && (testProps = _objectSpread({}, testProps, {
            componentProps: _objectSpread({}, testProps.componentProps, {
              fieldDatatype: testProps.datatype
            })
          }), testProps.componentProps.readOnly && (testProps.componentProps.renderEditCell = null)), testProps;
        }, [dataProps]),
        resolveCallbackMap: callbackMap,
        resolveComponentMap: componentMap
      },
          columnMetadata = uiColumns || function (dataProps, columnType) {
        var _context;

        return map_default()(_context = entries_default()(dataProps)).call(_context, function (_ref52) {
          var _ref53 = _slicedToArray(_ref52, 2),
              key = _ref53[0],
              value = _ref53[1];

          var label = value.componentProps.label;
          return {
            id: key,
            type: "field",
            component: columnType,
            componentProps: {
              header: label || key,
              path: key,
              textAlign: "left",
              readOnly: "id" === key
            }
          };
        });
      }(dataProps, "displaycolumn");

      uiColumns || logger_.log.info("columnMetadata: ", stringify_default()(columnMetadata, null, 2));
      var columns = Object(uiconfig_.renderContentFromMetadata)(columnMetadata, void 0, resolvers),
          isEditable = !readOnly && (onSaveRow || onDeleteRow);
      return external_react_default.a.createElement(DataTable, extends_default()({}, dataTableProps, {
        data: data,
        onSaveRow: onSaveRow
      }), columns, isEditable && external_react_default.a.createElement(ActionColumn, {
        id: "actions"
      }, onSaveRow && external_react_default.a.createElement(ActionItem, {
        id: "edit",
        icon: "pen",
        isEditTrigger: !0
      }), onDeleteRow && external_react_default.a.createElement(ActionItem, {
        id: "delete",
        icon: "trash",
        onClick: onDeleteRow
      })));
    };

    JsonDataTable.propTypes = jsonDataTablePropTypes, JsonDataTable.__docgenInfo = {
      componentName: "JsonDataTable",
      packageName: "@jutro/datatable",
      description: "DataTable variant allowing to integrate with schema, metadata and data",
      displayName: "JsonDataTable",
      methods: [],
      actualName: "JsonDataTable",
      metadataType: "container",
      props: {
        callbackMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve callback string to callback function"
        },
        componentMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve component string to component"
        },
        data: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Data for this table"
        },
        dataSchema: {
          type: {
            name: "object"
          },
          required: !0,
          description: "Schema for this form; used for data props and validation"
        },
        dataSchemaExtension: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Function to process schema data types with custom attributes",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        onDataSchemaExtension: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Function to process schema data types with custom attributes"
        },
        onDeleteRow: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback for row deletion"
        },
        onSaveRow: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Callback for saving the row edit"
        },
        overrideProps: {
          type: {
            name: "object"
          },
          required: !1,
          description: "optional\nOverride props by all, type or id."
        },
        showErrors: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "optional\nShow errors for all invalid fields; true after user attempts to submit/perform an action"
        },
        uiColumns: {
          type: {
            name: "arrayOf",
            value: {
              name: "custom",
              raw: "columnConfigShape"
            }
          },
          required: !1,
          description: "Array of ui configs for columns"
        },
        readOnly: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Indicate if the table should be editable or readOnly"
        }
      },
      composes: ["./DataTable"]
    };

    var reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
        reduce_default = __webpack_require__.n(reduce_),
        is_array_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/array/is-array"),
        is_array_default = __webpack_require__.n(is_array_),
        theme_ = __webpack_require__("@jutro/theme"),
        Table_module = __webpack_require__("./table/Table.module.scss"),
        Table_module_default = __webpack_require__.n(Table_module),
        TableTitleBar_module = __webpack_require__("./table/TableTitleBar.module.scss"),
        TableTitleBar_module_default = __webpack_require__.n(TableTitleBar_module);

    var TableTitleBar = function TableTitleBar(props) {
      var theme = props.theme,
          titleId = props.titleId,
          titlePosition = props.titlePosition,
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeProps = theme ? theme.getProps("TableTitleBar", props) : props,
          title = function (title, translator) {
        external_lodash_default.a.isFunction(title) && (title = title(translator));
        translator && (title = translator(title));
        return title;
      }(themeProps.title, translator),
          themeStyles = theme ? theme.getStyles("TableTitleBar", TableTitleBar_module_default.a) : TableTitleBar_module_default.a;

      return renderTitleBar(TableTitleBar_renderTitle(title, themeStyles, titleId, titlePosition), TableTitleBar_renderTitleAction(themeProps.titleAction, themeStyles), themeStyles);
    };

    function TableTitleBar_renderTitle(title, themeStyles, titleId, titlePosition) {
      var classNames = external_classnames_default()(themeStyles.title, themeStyles[titlePosition]);
      return title ? external_react_default.a.createElement("div", {
        id: titleId,
        className: classNames
      }, title) : null;
    }

    function TableTitleBar_renderTitleAction(titleAction, themeStyles) {
      return titleAction ? external_react_default.a.createElement("div", {
        className: themeStyles.titleAction
      }, titleAction()) : null;
    }

    function renderTitleBar(titleElement, titleActionElement, themeStyles) {
      return titleElement || titleActionElement ? external_react_default.a.createElement("div", {
        className: themeStyles.tableTitleBar
      }, titleElement, titleActionElement) : null;
    }

    TableTitleBar.propTypes = {
      title: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.func]),
      titleAction: external_prop_types_default.a.func,
      theme: external_prop_types_default.a.object,
      titleId: external_prop_types_default.a.string,
      position: external_prop_types_default.a.oneOf(["left", "right", "center"])
    }, TableTitleBar.defaultProps = {
      titlePosition: "left"
    }, TableTitleBar.metadataType = uimetadata_.metadataTypes.CONTAINER, TableTitleBar.__docgenInfo = {
      componentName: "TableTitleBar",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "TableTitleBar",
      methods: [],
      actualName: "TableTitleBar",
      metadataType: "container",
      props: {
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        titleAction: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        theme: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        titleId: {
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        position: {
          type: {
            name: "enum",
            value: [{
              value: "'left'",
              computed: !1
            }, {
              value: "'right'",
              computed: !1
            }, {
              value: "'center'",
              computed: !1
            }]
          },
          required: !1,
          description: ""
        },
        titlePosition: {
          defaultValue: {
            value: "'left'",
            computed: !1
          },
          required: !1
        }
      }
    }, TableTitleBar_renderTitle.__docgenInfo = {
      componentName: "renderTitle",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderTitle",
      methods: [],
      actualName: "renderTitle"
    }, TableTitleBar_renderTitleAction.__docgenInfo = {
      componentName: "renderTitleAction",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderTitleAction",
      methods: [],
      actualName: "renderTitleAction"
    }, renderTitleBar.__docgenInfo = {
      componentName: "renderTitleBar",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderTitleBar",
      methods: [],
      actualName: "renderTitleBar"
    };

    var tablePropTypes = {
      title: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.func]),
      renderTitle: external_prop_types_default.a.func,
      className: external_prop_types_default.a.string,
      children: external_prop_types_default.a.arrayOf(external_prop_types_default.a.node),
      phone: external_prop_types_default.a.object,
      tablet: external_prop_types_default.a.object,
      titleAction: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderTitleAction instead"),
      renderTitleAction: external_prop_types_default.a.func,
      columnsProportion: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
      placeholder: prop_types_.intlMessageShape,
      phoneCardComponent: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", "Please use renderPhoneCardComponent instead"),
      renderPhoneCardComponent: external_prop_types_default.a.func,
      titleId: external_prop_types_default.a.string,
      titlePosition: external_prop_types_default.a.string,
      data: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
        id: external_prop_types_default.a.string
      }))
    },
        Table = function Table(props) {
      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          theme = Object(external_react_.useContext)(theme_.ThemeContext);
      return external_react_default.a.createElement(layout_.BreakpointTrackerContext.Consumer, null, function (breakpoint) {
        return renderTableComponent(props, breakpoint, translator, theme);
      });
    };

    function Table_renderHeader(headerProps) {
      var componentProps = headerProps.componentProps,
          breakpoint = headerProps.breakpoint,
          translator = headerProps.translator,
          themeStyles = headerProps.themeStyles;
      return renderLine({
        componentProps: componentProps,
        breakpoint: breakpoint,
        renderProp: function renderProp(columnProps) {
          return TableColumn.renderHeader(columnProps, translator, themeStyles);
        },
        keyMapper: function keyMapper() {
          return "header";
        },
        themeStyles: themeStyles
      });
    }

    function renderRow(props) {
      var componentProps = props.componentProps,
          row = props.row,
          index = props.index,
          breakpoint = props.breakpoint,
          translator = props.translator,
          themeStyles = props.themeStyles;
      return renderLine({
        componentProps: componentProps,
        breakpoint: breakpoint,
        renderProp: function renderProp(columnProps) {
          return TableColumn.renderCell(row, index, _objectSpread({}, columnProps, {
            basePath: componentProps.path
          }), translator, themeStyles);
        },
        keyMapper: function keyMapper() {
          return row.id || "" + index;
        },
        themeStyles: themeStyles
      });
    }

    var ignoreRowClicks = ["INPUT", "BUTTON", "A", "LABEL", "SELECT"];

    function handleRowClick(evt, columnCallback) {
      var currentTarget = evt.target;
      currentTarget && includes_default()(ignoreRowClicks).call(ignoreRowClicks, currentTarget.tagName) || columnCallback(evt);
    }

    function renderLine(props) {
      var _context;

      var componentProps = props.componentProps,
          breakpoint = props.breakpoint,
          renderProp = props.renderProp,
          keyMapper = props.keyMapper,
          themeStyles = props.themeStyles,
          children = componentProps.children,
          columnsProportion = componentProps.columnsProportion;
      var onRowClick;
      var columns = map_default()(_context = external_react_default.a.Children.toArray(children)).call(_context, function (column, index) {
        var columnProps = layout_.BreakpointTracker.applyBreakpointOverrides(column.props, breakpoint);
        return !1 === columnProps.visible || columnsProportion && !columnsProportion[index] ? null : (column.type.onRowClick && (onRowClick = function onRowClick(evt) {
          return handleRowClick(evt, column.type.onRowClick);
        }), renderProp(_objectSpread({}, columnProps, {
          scope: "col"
        })));
      });
      return external_react_default.a.createElement("tr", {
        className: themeStyles.row,
        key: keyMapper(),
        onClick: onRowClick
      }, columns);
    }

    function renderTableTitleBar(props) {
      var title = props.title,
          titleAction = props.titleAction,
          theme = props.theme,
          titleId = props.titleId,
          titlePosition = props.titlePosition;
      return external_react_default.a.createElement(TableTitleBar, {
        title: title,
        titleAction: titleAction,
        theme: theme,
        titleId: titleId,
        titlePosition: titlePosition
      });
    }

    function renderColGroup(columnsProportion, children) {
      if (children && columnsProportion) {
        (is_array_default()(children) ? filter_default()(children).call(children, function (col) {
          return col && !1 !== col.props.visible;
        }).length : 1) !== columnsProportion.length && logger_.log.warning("Number of table columns and columns proportion does not match");
      }

      if (!columnsProportion || 0 === columnsProportion.length) return;
      columnsProportion = filter_default()(columnsProportion).call(columnsProportion, function (x) {
        return !!x;
      });
      var proportionTotal = reduce_default()(columnsProportion).call(columnsProportion, function (total, x) {
        return total + x;
      }),
          cols = map_default()(columnsProportion).call(columnsProportion, function (x, index) {
        return external_react_default.a.createElement("col", {
          key: index,
          style: {
            width: x / proportionTotal * 100 + "%"
          }
        });
      });
      return external_react_default.a.createElement("colgroup", null, cols);
    }

    function renderPlaceHolder(placeholder, themeStyles, translator) {
      if (!placeholder) return null;
      var placeholderText = translator ? translator(placeholder) : placeholder;
      return external_react_default.a.createElement("div", {
        className: themeStyles.placeholder
      }, placeholderText);
    }

    var renderDesktopTable = function renderDesktopTable(componentProps, breakpoint, themeStyles, translator, titleId) {
      var data = componentProps.data,
          children = componentProps.children,
          colGroup = renderColGroup(componentProps.columnsProportion, children),
          header = Table_renderHeader({
        componentProps: componentProps,
        breakpoint: breakpoint,
        translator: translator,
        themeStyles: themeStyles
      }),
          body = map_default()(data).call(data, function (row, index) {
        return renderRow({
          componentProps: componentProps,
          row: row,
          index: index,
          breakpoint: breakpoint,
          translator: translator,
          themeStyles: themeStyles
        });
      });
      return external_react_default.a.createElement("table", {
        className: themeStyles.tableElement,
        "aria-describedby": titleId
      }, colGroup, external_react_default.a.createElement("thead", null, header), external_react_default.a.createElement("tbody", null, body));
    },
        renderCardRow = function renderCardRow(rowProps, row, index, themeStyles, translator) {
      var classes = external_classnames_default()(themeStyles.tableCardRow, _defineProperty({}, themeStyles.radioRow, null == rowProps ? void 0 : rowProps.option)),
          cardProps = _objectSpread({}, rowProps, {
        headerClassName: themeStyles.tableCardElementHeader,
        cellClassName: themeStyles.tableCardElementContent,
        scope: "row",
        textAlign: void 0
      });

      return external_react_default.a.createElement("tr", {
        key: rowProps.id + index,
        className: classes
      }, TableColumn.renderHeader(cardProps, translator), TableColumn.renderCell(row, index, cardProps, translator, themeStyles));
    },
        renderPhoneTable = function renderPhoneTable(componentProps, breakpoint, themeStyles, translator, titleId) {
      var _context2, _context3;

      var data = componentProps.data,
          children = componentProps.children,
          renderPhoneCardComponent = componentProps.renderPhoneCardComponent,
          phoneCardComponent = componentProps.phoneCardComponent,
          Card = renderPhoneCardComponent || phoneCardComponent || "div";
      var clickableColumn;
      for_each_default()(_context2 = filter_default()(_context3 = external_react_default.a.Children.toArray(children)).call(_context3, Boolean)).call(_context2, function (child) {
        child.type.onRowClick && (clickableColumn = child);
      });
      var onCardClick = clickableColumn ? function (evt) {
        return handleRowClick(evt, clickableColumn.type.onRowClick);
      } : void 0,
          cards = map_default()(data).call(data, function (row, index) {
        var _context4;

        var key = row.id || "" + index,
            card = map_default()(_context4 = external_react_default.a.Children.toArray(children)).call(_context4, function (child) {
          return renderCardRow(child.props, row, index, themeStyles, translator);
        });
        return external_react_default.a.createElement(Card, {
          key: key,
          className: themeStyles.card,
          onClick: onCardClick,
          id: key
        }, external_react_default.a.createElement("div", {
          onClick: onCardClick
        }, external_react_default.a.createElement("table", {
          className: themeStyles.tableCard,
          "aria-describedby": titleId
        }, external_react_default.a.createElement("tbody", null, card))));
      });
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, cards);
    },
        renderDesktopOrPhoneTable = function renderDesktopOrPhoneTable(props) {
      var componentProps = props.componentProps,
          breakpoint = props.breakpoint,
          themeStyles = props.themeStyles,
          translator = props.translator,
          titleId = props.titleId;
      return breakpoint && "phone" === breakpoint ? renderPhoneTable(componentProps, 0, themeStyles, translator, titleId) : renderDesktopTable(componentProps, breakpoint, themeStyles, translator, titleId);
    },
        isClickable = function isClickable(child) {
      var _child$type;

      return null == child || null === (_child$type = child.type) || void 0 === _child$type ? void 0 : _child$type.onRowClick;
    },
        isHoverable = function isHoverable(props) {
      var children = props.children;
      return !!children && (is_array_default()(children) || children.type !== external_react_default.a.Fragment || (children = children.props.children), is_array_default()(children) ? some_default()(children).call(children, isClickable) : children.type.onRowClick);
    },
        renderTableComponent = function renderTableComponent(props, breakpoint, translator, theme) {
      var themeProps = theme ? theme.getProps("Table", props) : props,
          themeStyles = theme ? theme.getStyles("Table", Table_module_default.a) : Table_module_default.a,
          componentProps = layout_.BreakpointTracker.applyBreakpointOverrides(themeProps, breakpoint),
          data = componentProps.data,
          className = componentProps.className,
          title = componentProps.title,
          renderTitle = componentProps.renderTitle,
          titleId = componentProps.titleId,
          titleAction = componentProps.titleAction,
          renderTitleAction = componentProps.renderTitleAction,
          titlePosition = componentProps.titlePosition,
          placeholder = componentProps.placeholder,
          tableClasses = external_classnames_default()(themeStyles.table, _defineProperty({}, Table_module_default.a.hoverable, isHoverable(themeProps)), className),
          titleBar = renderTableTitleBar({
        title: title || renderTitle,
        titleAction: renderTitleAction || titleAction,
        theme: theme,
        titleId: titleId,
        titlePosition: titlePosition
      }),
          hasData = !external_lodash_default.a.isEmpty(data),
          placeholderElement = hasData ? null : renderPlaceHolder(placeholder, themeStyles, translator);
      return external_react_default.a.createElement("div", {
        className: tableClasses
      }, titleBar, hasData && renderDesktopOrPhoneTable({
        componentProps: componentProps,
        breakpoint: breakpoint,
        themeStyles: themeStyles,
        translator: translator,
        titleId: titleId
      }), placeholderElement);
    };

    Table.propTypes = tablePropTypes, Table.metadataType = uimetadata_.metadataTypes.CONTAINER, Table.__docgenInfo = {
      componentName: "Table",
      packageName: "@jutro/datatable",
      description: "Renders a table. You can use it to display data from a model.",
      displayName: "Table",
      methods: [],
      actualName: "Table",
      metadataType: "container",
      props: {
        title: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: "Title which is placed in title bar"
        },
        renderTitle: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Function that renders custom title"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Optional css class(es) to add to the grid tag"
        },
        children: {
          type: {
            name: "arrayOf",
            value: {
              name: "node"
            }
          },
          required: !1,
          description: "Children; preferably 'GridItem'; works with any child"
        },
        phone: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include any Table property for use at 'phone' breakpoint"
        },
        tablet: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Include any Table property for use at 'tablet' and 'phone' breakpoint"
        },
        titleAction: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Render prop for customizing action in the title area",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderTitleAction: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Render prop for customizing action in the title area"
        },
        columnsProportion: {
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: "Proportion of columns (e.g. [2, 2, 1])"
        },
        placeholder: {
          type: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                }
              }
            }]
          },
          required: !1,
          description: "Placeholder to show when data is empty"
        },
        phoneCardComponent: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated Component to wrap mobile Radio Table",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: null
          }
        },
        renderPhoneCardComponent: {
          type: {
            name: "func"
          },
          required: !1,
          description: "Component to wrap mobile Radio Table"
        },
        titleId: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The id used for the tables title for use in the aria-describedby"
        },
        titlePosition: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The position of the title in the title bar (left, right, center)"
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  description: "Optional string for generating keys for rows",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Cells data"
        }
      }
    }, Table_renderHeader.__docgenInfo = {
      componentName: "renderHeader",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderHeader",
      methods: [],
      actualName: "renderHeader"
    }, renderRow.__docgenInfo = {
      componentName: "renderRow",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderRow",
      methods: [],
      actualName: "renderRow"
    }, renderLine.__docgenInfo = {
      componentName: "renderLine",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderLine",
      methods: [],
      actualName: "renderLine"
    }, renderTableTitleBar.__docgenInfo = {
      componentName: "renderTableTitleBar",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderTableTitleBar",
      methods: [],
      actualName: "renderTableTitleBar"
    }, renderColGroup.__docgenInfo = {
      componentName: "renderColGroup",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderColGroup",
      methods: [],
      actualName: "renderColGroup"
    }, renderPlaceHolder.__docgenInfo = {
      componentName: "renderPlaceHolder",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderPlaceHolder",
      methods: [],
      actualName: "renderPlaceHolder"
    }, renderDesktopTable.__docgenInfo = {
      componentName: "renderDesktopTable",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderDesktopTable",
      methods: [],
      actualName: "renderDesktopTable"
    }, renderCardRow.__docgenInfo = {
      componentName: "renderCardRow",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderCardRow",
      methods: [],
      actualName: "renderCardRow"
    }, renderPhoneTable.__docgenInfo = {
      componentName: "renderPhoneTable",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderPhoneTable",
      methods: [],
      actualName: "renderPhoneTable"
    }, renderDesktopOrPhoneTable.__docgenInfo = {
      componentName: "renderDesktopOrPhoneTable",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderDesktopOrPhoneTable",
      methods: [],
      actualName: "renderDesktopOrPhoneTable"
    }, renderTableComponent.__docgenInfo = {
      componentName: "renderTableComponent",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "renderTableComponent",
      methods: [],
      actualName: "renderTableComponent"
    };

    var to_primitive_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/symbol/to-primitive"),
        to_primitive_default = __webpack_require__.n(to_primitive_),
        FilterBar_module = __webpack_require__("./filterBar/FilterBar.module.scss"),
        FilterBar_module_default = __webpack_require__.n(FilterBar_module);

    var FilterBar_messages_messages = Object(external_react_intl_.defineMessages)({
      title: {
        id: "jutro-datatable.filterBar.title",
        defaultMessage: "Filters"
      },
      searchInput: {
        id: "jutro-datatable.filterBar.searchInput",
        defaultMessage: "Search"
      },
      clearFilters: {
        id: "jutro-datatable.filterBar.clearFilters",
        defaultMessage: "Clear Filters"
      },
      applyFilters: {
        id: "jutro-datatable.filterBar.applyFilters",
        defaultMessage: "Apply"
      },
      manageFilters: {
        id: "jutro-datatable.filterBar.manageFilters",
        defaultMessage: "Filters"
      }
    });

    var values_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/values"),
        values_default = __webpack_require__.n(values_),
        set_ = __webpack_require__("lodash/set"),
        set_default = __webpack_require__.n(set_),
        isEmpty = __webpack_require__("../../node_modules/lodash/isEmpty.js"),
        isEmpty_default = __webpack_require__.n(isEmpty);

    var FilterBarContentInternal = function FilterBarContentInternal(_ref54) {
      var styles = _ref54.styles,
          metadata = _ref54.metadata,
          onFiltersChange = _ref54.onFiltersChange,
          componentMap = _ref54.componentMap,
          callbackMap = _ref54.callbackMap,
          isFiltersEmpty = _ref54.isFiltersEmpty,
          _ref54$initialFilters = _ref54.initialFilters,
          initialFilters = _ref54$initialFilters === void 0 ? {} : _ref54$initialFilters;

      var _context;

      var translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          _useState = Object(external_react_.useState)(initialFilters),
          _useState2 = slicedToArray_default()(_useState, 2),
          formData = _useState2[0],
          setFormData = _useState2[1],
          isFormEmpty = every_default()(_context = values_default()(formData)).call(_context, isEmpty_default.a),
          overrideProps = {
        "@field": {
          className: FilterBar_module_default.a.filterItem
        }
      },
          applyFilters = Object(external_react_.useCallback)(function () {
        var _context2;

        onFiltersChange(reduce_default()(_context2 = entries_default()(formData)).call(_context2, function (newFilters, _ref55) {
          var _ref56 = _slicedToArray(_ref55, 2),
              path = _ref56[0],
              value = _ref56[1];

          return null != value && "" !== value && (newFilters[path] = value), newFilters;
        }, {}));
      }, [formData, onFiltersChange]),
          handleClearFilter = Object(external_react_.useCallback)(function () {
        setFormData({}), onFiltersChange({});
      }, [onFiltersChange, setFormData]),
          handleFormEnter = Object(external_react_.useCallback)(function (event) {
        "Enter" !== event.key || event.defaultPrevented || applyFilters();
      }, [applyFilters]);

      return external_react_default.a.createElement("div", {
        className: FilterBar_module_default.a.filterBar
      }, external_react_default.a.createElement("div", {
        className: FilterBar_module_default.a.titleBar
      }, external_react_default.a.createElement("div", {
        className: FilterBar_module_default.a.filterTitle
      }, translator(FilterBar_messages_messages.title)), external_react_default.a.createElement("div", null, !isFormEmpty && !isFiltersEmpty && external_react_default.a.createElement(components_.Button, {
        id: "clearFilter",
        type: "tertiary",
        size: "small",
        onClick: handleClearFilter
      }, translator(FilterBar_messages_messages.clearFilters)), external_react_default.a.createElement(components_.Button, {
        id: "applyFilter",
        size: "small",
        disabled: isFormEmpty,
        onClick: applyFilters
      }, translator(FilterBar_messages_messages.applyFilters)))), external_react_default.a.createElement("hr", {
        className: FilterBar_module_default.a.titleDivider
      }), external_react_default.a.createElement(layout_.Flex, {
        gap: "small",
        onKeyDown: handleFormEnter,
        role: "presentation"
      }, external_react_default.a.createElement(uiconfig_.MetadataForm, {
        uiProps: metadata,
        onDataChange: function onDataChange(value, path) {
          setFormData(function (prevState) {
            var newState = _objectSpread({}, prevState);

            return set_default()(newState, path, value), newState;
          });
        },
        classNameMap: styles,
        resolveValue: function resolveValue(id, path) {
          return get_default()(formData, path);
        },
        callbackMap: callbackMap,
        componentMap: componentMap,
        overrideProps: overrideProps,
        data: formData
      })));
    };

    FilterBarContentInternal.displayName = "FilterBarContent";
    var FilterBarContent = external_react_default.a.memo(FilterBarContentInternal);

    function _toPropertyKey(arg) {
      var key = function (input, hint) {
        if ("object" != typeof input || null === input) return input;
        var prim = input[to_primitive_default.a];

        if (void 0 !== prim) {
          var res = prim.call(input, hint || "default");
          if ("object" != typeof res) return res;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === hint ? String : Number)(input);
      }(arg, "string");

      return "symbol" == typeof key ? key : String(key);
    }

    FilterBarContentInternal.__docgenInfo = {
      componentName: "FilterBarContent",
      packageName: "@jutro/datatable",
      description: "",
      displayName: "FilterBarContent",
      methods: [],
      actualName: "FilterBarContentInternal",
      props: {
        initialFilters: {
          defaultValue: {
            value: "{}",
            computed: !1
          },
          required: !1
        }
      }
    };

    var filterBarPropTypes = {
      uiProps: external_prop_types_default.a.object,
      classNameMap: external_prop_types_default.a.object,
      componentMap: external_prop_types_default.a.object,
      callbackMap: external_prop_types_default.a.object,
      onFiltersChange: external_prop_types_default.a.func.isRequired,
      initialFilters: external_prop_types_default.a.object,
      searchKey: external_prop_types_default.a.string
    },
        FilterBar = function FilterBar(_ref57) {
      var callbackMap = _ref57.callbackMap,
          componentMap = _ref57.componentMap,
          initialFiltersProp = _ref57.initialFilters,
          onFiltersChangeProp = _ref57.onFiltersChange,
          metadata = _ref57.uiProps,
          searchKey = _ref57.searchKey,
          styles = _ref57.styles;

      var _context;

      var initialSearch = initialFiltersProp[searchKey],
          initialFilters = objectWithoutProperties_default()(initialFiltersProp, map_default()(_context = [searchKey]).call(_context, _toPropertyKey)),
          _useState = Object(external_react_.useState)(initialSearch),
          _useState2 = slicedToArray_default()(_useState, 2),
          search = _useState2[0],
          setSearch = _useState2[1],
          searchDebounced = Object(platform_.useDebounce)(search, 300),
          _useState3 = Object(external_react_.useState)(initialFilters),
          _useState4 = slicedToArray_default()(_useState3, 2),
          filters = _useState4[0],
          setFilters = _useState4[1],
          onFiltersChangeRef = Object(external_react_.useRef)(null),
          searchKeyRef = Object(external_react_.useRef)(searchKey),
          _useState5 = Object(external_react_.useState)(!1),
          _useState6 = slicedToArray_default()(_useState5, 2),
          isShown = _useState6[0],
          setShown = _useState6[1],
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          numberFiltersApplied = keys_default()(filters).length,
          isFiltersEmpty = 0 === numberFiltersApplied,
          toggleFilterBar = Object(external_react_.useCallback)(function () {
        setShown(!isShown);
      }, [isShown]);

      Object(external_react_.useEffect)(function () {
        if (onFiltersChangeRef.current) {
          var newFilters = _objectSpread({}, filters);

          searchDebounced && (newFilters[searchKeyRef.current] = searchDebounced), onFiltersChangeRef.current(newFilters);
        }
      }, [searchDebounced, filters]), Object(external_react_.useEffect)(function () {
        onFiltersChangeRef.current = onFiltersChangeProp;
      }, [onFiltersChangeProp]);
      var filterBarContentProps = {
        styles: styles,
        metadata: metadata,
        onFiltersChange: setFilters,
        componentMap: componentMap,
        callbackMap: callbackMap,
        isFiltersEmpty: isFiltersEmpty,
        initialFilters: filters
      },
          manageFiltersButtonClassNames = external_classnames_default()(FilterBar_module_default.a.manageFiltersButton, _defineProperty({}, FilterBar_module_default.a.manageFiltersButtonSelected, isShown));
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_default.a.createElement("div", {
        className: FilterBar_module_default.a.searchBar
      }, external_react_default.a.createElement(components_.InputField, {
        id: "searchFilterBar",
        icon: "mi-search",
        iconPosition: "right",
        value: search,
        onValueChange: setSearch,
        placeholder: translator(FilterBar_messages_messages.searchInput),
        controlClassName: FilterBar_module_default.a.searchField
      }), metadata && external_react_default.a.createElement(components_.Button, {
        id: "manageFilters",
        icon: "mi-tune",
        type: "neutral",
        onClick: toggleFilterBar,
        className: manageFiltersButtonClassNames
      }, translator(FilterBar_messages_messages.manageFilters), !isFiltersEmpty && external_react_default.a.createElement(components_.Badge, {
        id: "filtersCount",
        type: "info",
        value: numberFiltersApplied,
        className: FilterBar_module_default.a.manageFiltersBadge
      }))), metadata && external_react_default.a.createElement(components_.Collapse, {
        isOpen: isShown
      }, external_react_default.a.createElement(FilterBarContent, filterBarContentProps)));
    };

    function extractAPIFromSchema(schema, target, restService) {
      var targetUrl = target,
          apiTargetUrl = "".concat(null == schema ? void 0 : schema.servers[0].url).concat(targetUrl),
          collectionPath = null == schema ? void 0 : schema.paths[targetUrl],
          api = {};
      collectionPath.get && (api.getAll = function () {
        var url = apiTargetUrl;
        return restService.get(url);
      }), collectionPath.post && (api.create = function (entity) {
        var url = apiTargetUrl,
            rest = (entity.id, objectWithoutProperties_default()(entity, ["id"]));
        return restService.post(url, rest);
      });
      var detailsPath = null == schema ? void 0 : schema.paths[targetUrl + "/{id}"];
      return detailsPath.get && (api.get = function (entityId) {
        var url = "".concat(apiTargetUrl, "/").concat(entityId);
        return restService.get(url);
      }), detailsPath.put && (api.update = function (entity) {
        var entityId = entity.id,
            url = "".concat(apiTargetUrl, "/").concat(entityId);
        return restService.put(url, entity);
      }), detailsPath.delete && (api.delete = function (entityId) {
        var url = "".concat(apiTargetUrl, "/").concat(entityId);
        return restService.delete(url);
      }), api;
    }

    FilterBar.propTypes = filterBarPropTypes, FilterBar.defaultProps = {
      initialFilters: {},
      searchKey: "search"
    }, FilterBar.__docgenInfo = {
      componentName: "FilterBar",
      packageName: "@jutro/datatable",
      description: "Component for filters rendering, supplied through metadata",
      displayName: "FilterBar",
      methods: [],
      actualName: "FilterBar",
      metadataType: "container",
      props: {
        uiProps: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Content metadata or an array of metadata"
        },
        classNameMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve class name to hashed class name"
        },
        componentMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve component map"
        },
        callbackMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve callback name to callback function"
        },
        onFiltersChange: {
          type: {
            name: "func"
          },
          required: !0,
          description: "Callback for when filters are changed"
        },
        initialFilters: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Object with initial filters to be applied",
          defaultValue: {
            value: "{}",
            computed: !1
          }
        },
        searchKey: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Name of search filter key in filters data. Can not change during component lifetime",
          defaultValue: {
            value: "'search'",
            computed: !1
          }
        }
      }
    };

    var now_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/date/now"),
        now_default = __webpack_require__.n(now_),
        external_util_ = __webpack_require__("util");

    var stringExactMatch = function stringExactMatch(value, filter) {
      var _context;

      return includes_default()(_context = value.toLowerCase()).call(_context, filter.toLowerCase());
    };

    var dataFilter = function dataFilter(data, filters) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$searchKey = options.searchKey,
          searchKey = void 0 === _options$searchKey ? "search" : _options$searchKey,
          _options$formatters = options.formatters,
          formatters = void 0 === _options$formatters ? {} : _options$formatters,
          filterKeys = keys_default()(filters);
      return filter_default()(data).call(data, function (dataItem) {
        return every_default()(filterKeys).call(filterKeys, function (filterKey) {
          var filter = filters[filterKey];

          var _context2;

          if (filterKey === searchKey) return some_default()(_context2 = entries_default()(dataItem)).call(_context2, function (_ref58) {
            var _ref59 = _slicedToArray(_ref58, 2),
                key = _ref59[0],
                value = _ref59[1];

            return stringExactMatch(function (key, value, formatters) {
              return formatters[key] ? formatters[key](value) : value.toString();
            }(key, value, formatters), filter);
          });
          if (is_array_default()(filter)) return includes_default()(filter).call(filter, dataItem[filterKey]);

          if ((null == filter ? void 0 : filter.min) || (null == filter ? void 0 : filter.max)) {
            var min = filter.min,
                max = filter.max;
            return min ? max ? dataItem[filterKey] >= min && dataItem[filterKey] <= max : dataItem[filterKey] >= min : dataItem[filterKey] <= max;
          }

          if (Object(external_util_.isDate)(filter) || "number" == typeof filter) return dataItem[filterKey] === filter;
          if ("function" == typeof filter) return filter(dataItem[filterKey]);

          if ((null == filter ? void 0 : starts_with_default()(filter).call(filter, ">")) || (null == filter ? void 0 : starts_with_default()(filter).call(filter, "<"))) {
            return new Function("return ".concat(dataItem[filterKey]).concat(filter, ";"))();
          }

          return "string" != typeof filter || stringExactMatch(dataItem[filterKey].toString(), filter);
        });
      });
    },
        useDataFilter = function useDataFilter(data, filters, options) {
      return Object(external_react_.useMemo)(function () {
        return [dataFilter(data, filters, options), now_default()()];
      }, [data, filters, options]);
    };

    Object(uiconfig_.appendSimpleNamedComponentMap)({
      ActionColumn: {
        component: ActionColumn
      },
      ActionItem: {
        component: ActionItem
      },
      DisplayColumn: {
        component: DisplayColumn
      },
      FieldColumn: {
        component: FieldColumn
      },
      FilterBar: {
        component: FilterBar
      },
      MoneyColumn: {
        component: MoneyColumn
      },
      RadioColumn: {
        component: RadioColumn
      },
      DataTable: {
        component: DataTable
      },
      Table: {
        component: Table
      },
      TableColumn: {
        component: TableColumn
      },
      JsonDataTable: {
        component: JsonDataTable
      }
    });
  },
  "./table/Table.module.scss": function tableTableModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      themeRoot: "jut__Table__themeRoot",
      table: "jut__Table__table",
      radio: "jut__Table__radio",
      tableElement: "jut__Table__tableElement",
      tableHeader: "jut__Table__tableHeader",
      tableCell: "jut__Table__tableCell",
      hoverable: "jut__Table__hoverable",
      row: "jut__Table__row",
      card: "jut__Table__card",
      radioRow: "jut__Table__radioRow",
      tableCardElementHeader: "jut__Table__tableCardElementHeader",
      tableCardElementContent: "jut__Table__tableCardElementContent",
      tableCardRow: "jut__Table__tableCardRow",
      placeholder: "jut__Table__placeholder",
      tableCard: "jut__Table__tableCard"
    };
  },
  "./table/TableTitleBar.module.scss": function tableTableTitleBarModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      tableTitleBar: "jut__TableTitleBar__tableTitleBar",
      title: "jut__TableTitleBar__title",
      left: "jut__TableTitleBar__left",
      right: "jut__TableTitleBar__right",
      center: "jut__TableTitleBar__center",
      titleAction: "jut__TableTitleBar__titleAction"
    };
  },
  "@babel/runtime-corejs3/core-js-stable/array/is-array": function babelRuntimeCorejs3CoreJsStableArrayIsArray(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/array/is-array");
  },
  "@babel/runtime-corejs3/core-js-stable/date/now": function babelRuntimeCorejs3CoreJsStableDateNow(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/date/now");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/concat": function babelRuntimeCorejs3CoreJsStableInstanceConcat(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/concat");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babelRuntimeCorejs3CoreJsStableInstanceEvery(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/filter": function babelRuntimeCorejs3CoreJsStableInstanceFilter(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find": function babelRuntimeCorejs3CoreJsStableInstanceFind(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find-index": function babelRuntimeCorejs3CoreJsStableInstanceFindIndex(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find-index");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babelRuntimeCorejs3CoreJsStableInstanceIncludes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/index-of": function babelRuntimeCorejs3CoreJsStableInstanceIndexOf(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babelRuntimeCorejs3CoreJsStableInstanceMap(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babelRuntimeCorejs3CoreJsStableInstanceReduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/slice": function babelRuntimeCorejs3CoreJsStableInstanceSlice(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/some": function babelRuntimeCorejs3CoreJsStableInstanceSome(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/some");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/sort": function babelRuntimeCorejs3CoreJsStableInstanceSort(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/sort");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/starts-with": function babelRuntimeCorejs3CoreJsStableInstanceStartsWith(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/starts-with");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/trim": function babelRuntimeCorejs3CoreJsStableInstanceTrim(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/trim");
  },
  "@babel/runtime-corejs3/core-js-stable/json/stringify": function babelRuntimeCorejs3CoreJsStableJsonStringify(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/json/stringify");
  },
  "@babel/runtime-corejs3/core-js-stable/object/entries": function babelRuntimeCorejs3CoreJsStableObjectEntries(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/entries");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babelRuntimeCorejs3CoreJsStableObjectKeys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/object/values": function babelRuntimeCorejs3CoreJsStableObjectValues(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/values");
  },
  "@babel/runtime-corejs3/core-js-stable/reflect/construct": function babelRuntimeCorejs3CoreJsStableReflectConstruct(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
  },
  "@babel/runtime-corejs3/core-js-stable/symbol/to-primitive": function babelRuntimeCorejs3CoreJsStableSymbolToPrimitive(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/symbol/to-primitive");
  },
  "@babel/runtime-corejs3/helpers/extends": function babelRuntimeCorejs3HelpersExtends(module, exports) {
    module.exports = require("@babel/runtime-corejs3/helpers/extends");
  },
  "@babel/runtime-corejs3/helpers/inherits": function babelRuntimeCorejs3HelpersInherits(module, exports) {
    module.exports = require("@babel/runtime-corejs3/helpers/inherits");
  },
  "@jutro/components": function jutroComponents(module, exports) {
    module.exports = require("@jutro/components");
  },
  "@jutro/layout": function jutroLayout(module, exports) {
    module.exports = require("@jutro/layout");
  },
  "@jutro/locale": function jutroLocale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "@jutro/platform": function jutroPlatform(module, exports) {
    module.exports = require("@jutro/platform");
  },
  "@jutro/prop-types": function jutroPropTypes(module, exports) {
    module.exports = require("@jutro/prop-types");
  },
  "@jutro/router": function jutroRouter(module, exports) {
    module.exports = require("@jutro/router");
  },
  "@jutro/state-management": function jutroStateManagement(module, exports) {
    module.exports = require("@jutro/state-management");
  },
  "@jutro/theme": function jutroTheme(module, exports) {
    module.exports = require("@jutro/theme");
  },
  "@jutro/uiconfig": function jutroUiconfig(module, exports) {
    module.exports = require("@jutro/uiconfig");
  },
  "@jutro/uimetadata": function jutroUimetadata(module, exports) {
    module.exports = require("@jutro/uimetadata");
  },
  classnames: function classnames(module, exports) {
    module.exports = require("classnames");
  },
  "core-js-pure/features/array/from": function coreJsPureFeaturesArrayFrom(module, exports) {
    module.exports = require("core-js-pure/features/array/from");
  },
  "core-js-pure/features/array/is-array": function coreJsPureFeaturesArrayIsArray(module, exports) {
    module.exports = require("core-js-pure/features/array/is-array");
  },
  "core-js-pure/features/get-iterator": function coreJsPureFeaturesGetIterator(module, exports) {
    module.exports = require("core-js-pure/features/get-iterator");
  },
  "core-js-pure/features/instance/index-of": function coreJsPureFeaturesInstanceIndexOf(module, exports) {
    module.exports = require("core-js-pure/features/instance/index-of");
  },
  "core-js-pure/features/instance/slice": function coreJsPureFeaturesInstanceSlice(module, exports) {
    module.exports = require("core-js-pure/features/instance/slice");
  },
  "core-js-pure/features/is-iterable": function coreJsPureFeaturesIsIterable(module, exports) {
    module.exports = require("core-js-pure/features/is-iterable");
  },
  "core-js-pure/features/object/define-property": function coreJsPureFeaturesObjectDefineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  "core-js-pure/features/object/get-own-property-symbols": function coreJsPureFeaturesObjectGetOwnPropertySymbols(module, exports) {
    module.exports = require("core-js-pure/features/object/get-own-property-symbols");
  },
  "core-js-pure/features/object/get-prototype-of": function coreJsPureFeaturesObjectGetPrototypeOf(module, exports) {
    module.exports = require("core-js-pure/features/object/get-prototype-of");
  },
  "core-js-pure/features/object/keys": function coreJsPureFeaturesObjectKeys(module, exports) {
    module.exports = require("core-js-pure/features/object/keys");
  },
  "core-js-pure/features/object/set-prototype-of": function coreJsPureFeaturesObjectSetPrototypeOf(module, exports) {
    module.exports = require("core-js-pure/features/object/set-prototype-of");
  },
  "core-js-pure/features/symbol": function coreJsPureFeaturesSymbol(module, exports) {
    module.exports = require("core-js-pure/features/symbol");
  },
  "core-js-pure/features/symbol/iterator": function coreJsPureFeaturesSymbolIterator(module, exports) {
    module.exports = require("core-js-pure/features/symbol/iterator");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJsModulesWebDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  "lodash/get": function lodashGet(module, exports) {
    module.exports = require("lodash/get");
  },
  "lodash/identity": function lodashIdentity(module, exports) {
    module.exports = require("lodash/identity");
  },
  "lodash/noop": function lodashNoop(module, exports) {
    module.exports = require("lodash/noop");
  },
  "lodash/omit": function lodashOmit(module, exports) {
    module.exports = require("lodash/omit");
  },
  "lodash/range": function lodashRange(module, exports) {
    module.exports = require("lodash/range");
  },
  "lodash/set": function lodashSet(module, exports) {
    module.exports = require("lodash/set");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-intl": function reactIntl(module, exports) {
    module.exports = require("react-intl");
  },
  "react-table": function reactTable(module, exports) {
    module.exports = require("react-table");
  },
  "react-table/react-table.css": function reactTableReactTableCss(module, exports) {
    module.exports = require("react-table/react-table.css");
  },
  "react-transition-group": function reactTransitionGroup(module, exports) {
    module.exports = require("react-transition-group");
  },
  util: function util(module, exports) {
    module.exports = require("util");
  }
});